const map = {
	"./0.svg": [
		72613,
		[
			72613
		]
	],
	"./00.svg": [
		72415,
		[
			72415
		]
	],
	"./1.svg": [
		91716,
		[
			91716
		]
	],
	"./100.svg": [
		86276,
		[
			86276
		]
	],
	"./2.svg": [
		46167,
		[
			46167
		]
	],
	"./3.svg": [
		40838,
		[
			40838
		]
	],
	"./360-degrees.svg": [
		52548,
		[
			52548
		]
	],
	"./4.svg": [
		10249,
		[
			10249
		]
	],
	"./5.svg": [
		1240,
		[
			1240
		]
	],
	"./6.svg": [
		59307,
		[
			59307
		]
	],
	"./7.svg": [
		65434,
		[
			65434
		]
	],
	"./8.svg": [
		79789,
		[
			79789
		]
	],
	"./9.svg": [
		32428,
		[
			32428
		]
	],
	"./a.svg": [
		6676,
		[
			6676
		]
	],
	"./abacus.svg": [
		84914,
		[
			84914
		]
	],
	"./accent-grave.svg": [
		28381,
		[
			28381
		]
	],
	"./acorn.svg": [
		4362,
		[
			4362
		]
	],
	"./ad.svg": [
		74320,
		[
			74320
		]
	],
	"./add.svg": [
		86844,
		[
			86844
		]
	],
	"./address-book.svg": [
		86741,
		[
			86741
		]
	],
	"./address-card.svg": [
		49752,
		[
			49752
		]
	],
	"./adjust.svg": [
		31138,
		[
			31138
		]
	],
	"./aeropress.svg": [
		13945,
		[
			13945
		]
	],
	"./air-conditioner.svg": [
		22688,
		[
			22688
		]
	],
	"./air-freshener.svg": [
		96406,
		[
			96406
		]
	],
	"./airplay-audio.svg": [
		97798,
		[
			97798
		]
	],
	"./airplay.svg": [
		34807,
		[
			34807
		]
	],
	"./alarm-clock.svg": [
		5999,
		[
			5999
		]
	],
	"./alarm-exclamation.svg": [
		36346,
		[
			36346
		]
	],
	"./alarm-minus.svg": [
		1589,
		[
			1589
		]
	],
	"./alarm-plus.svg": [
		39863,
		[
			39863
		]
	],
	"./alarm-snooze.svg": [
		78277,
		[
			78277
		]
	],
	"./album-circle-plus.svg": [
		69130,
		[
			69130
		]
	],
	"./album-circle-user.svg": [
		58727,
		[
			58727
		]
	],
	"./album-collection-circle-plus.svg": [
		11815,
		[
			11815
		]
	],
	"./album-collection-circle-user.svg": [
		85974,
		[
			85974
		]
	],
	"./album-collection.svg": [
		71441,
		[
			71441
		]
	],
	"./album.svg": [
		12628,
		[
			12628
		]
	],
	"./alicorn.svg": [
		1139,
		[
			1139
		]
	],
	"./alien-8bit.svg": [
		37524,
		[
			37524
		]
	],
	"./alien-monster.svg": [
		72545,
		[
			72545
		]
	],
	"./alien.svg": [
		82180,
		[
			82180
		]
	],
	"./align-center.svg": [
		61776,
		[
			61776
		]
	],
	"./align-justify.svg": [
		34505,
		[
			34505
		]
	],
	"./align-left.svg": [
		32140,
		[
			32140
		]
	],
	"./align-right.svg": [
		74259,
		[
			74259
		]
	],
	"./align-slash.svg": [
		7938,
		[
			7938
		]
	],
	"./allergies.svg": [
		22301,
		[
			22301
		]
	],
	"./almost-equal-to.svg": [
		20924,
		[
			20924
		]
	],
	"./alt.svg": [
		67284,
		[
			67284
		]
	],
	"./ambulance.svg": [
		79023,
		[
			79023
		]
	],
	"./american-sign-language-interpreting.svg": [
		44980,
		[
			44980
		]
	],
	"./amp-guitar.svg": [
		76922,
		[
			76922
		]
	],
	"./ampersand.svg": [
		36652,
		[
			36652
		]
	],
	"./analytics.svg": [
		71473,
		[
			71473
		]
	],
	"./anchor-circle-check.svg": [
		25646,
		[
			25646
		]
	],
	"./anchor-circle-exclamation.svg": [
		3801,
		[
			3801
		]
	],
	"./anchor-circle-xmark.svg": [
		94877,
		[
			94877
		]
	],
	"./anchor-lock.svg": [
		32876,
		[
			32876
		]
	],
	"./anchor.svg": [
		12380,
		[
			12380
		]
	],
	"./angel.svg": [
		63950,
		[
			63950
		]
	],
	"./angle-90.svg": [
		34890,
		[
			12509
		]
	],
	"./angle-double-down.svg": [
		93583,
		[
			93583
		]
	],
	"./angle-double-left.svg": [
		27472,
		[
			27472
		]
	],
	"./angle-double-right.svg": [
		82079,
		[
			82079
		]
	],
	"./angle-double-up.svg": [
		64032,
		[
			64032
		]
	],
	"./angle-down.svg": [
		3809,
		[
			3809
		]
	],
	"./angle-left.svg": [
		62650,
		[
			62650
		]
	],
	"./angle-right.svg": [
		11985,
		[
			11985
		]
	],
	"./angle-up.svg": [
		26526,
		[
			26526
		]
	],
	"./angle.svg": [
		98528,
		[
			98528
		]
	],
	"./angles-down.svg": [
		93880,
		[
			93880
		]
	],
	"./angles-left.svg": [
		21815,
		[
			21815
		]
	],
	"./angles-right.svg": [
		53042,
		[
			53042
		]
	],
	"./angles-up-down.svg": [
		98752,
		[
			98752
		]
	],
	"./angles-up.svg": [
		19595,
		[
			19595
		]
	],
	"./angry.svg": [
		26146,
		[
			26146
		]
	],
	"./ankh.svg": [
		19823,
		[
			19823
		]
	],
	"./ant.svg": [
		6826,
		[
			6826
		]
	],
	"./apartment.svg": [
		71795,
		[
			71795
		]
	],
	"./aperture.svg": [
		51675,
		[
			51675
		]
	],
	"./apostrophe.svg": [
		87660,
		[
			87660
		]
	],
	"./apple-alt.svg": [
		24079,
		[
			24079
		]
	],
	"./apple-core.svg": [
		21931,
		[
			21931
		]
	],
	"./apple-crate.svg": [
		19159,
		[
			19159
		]
	],
	"./apple-whole.svg": [
		46695,
		[
			46695
		]
	],
	"./archive.svg": [
		13895,
		[
			13895
		]
	],
	"./archway.svg": [
		6064,
		[
			6064
		]
	],
	"./area-chart.svg": [
		63111,
		[
			63111
		]
	],
	"./arrow-alt-circle-down.svg": [
		4370,
		[
			4370
		]
	],
	"./arrow-alt-circle-left.svg": [
		24601,
		[
			24601
		]
	],
	"./arrow-alt-circle-right.svg": [
		68900,
		[
			68900
		]
	],
	"./arrow-alt-circle-up.svg": [
		62913,
		[
			62913
		]
	],
	"./arrow-alt-down.svg": [
		88793,
		[
			88793
		]
	],
	"./arrow-alt-from-bottom.svg": [
		74275,
		[
			74275
		]
	],
	"./arrow-alt-from-left.svg": [
		70517,
		[
			70517
		]
	],
	"./arrow-alt-from-right.svg": [
		45784,
		[
			45784
		]
	],
	"./arrow-alt-from-top.svg": [
		89767,
		[
			89767
		]
	],
	"./arrow-alt-left.svg": [
		4098,
		[
			4098
		]
	],
	"./arrow-alt-right.svg": [
		80697,
		[
			80697
		]
	],
	"./arrow-alt-square-down.svg": [
		80185,
		[
			80185
		]
	],
	"./arrow-alt-square-left.svg": [
		95490,
		[
			95490
		]
	],
	"./arrow-alt-square-right.svg": [
		15481,
		[
			15481
		]
	],
	"./arrow-alt-square-up.svg": [
		94390,
		[
			94390
		]
	],
	"./arrow-alt-to-bottom.svg": [
		86342,
		[
			86342
		]
	],
	"./arrow-alt-to-left.svg": [
		68368,
		[
			68368
		]
	],
	"./arrow-alt-to-right.svg": [
		35455,
		[
			35455
		]
	],
	"./arrow-alt-to-top.svg": [
		49660,
		[
			49660
		]
	],
	"./arrow-alt-up.svg": [
		39190,
		[
			39190
		]
	],
	"./arrow-circle-down.svg": [
		90092,
		[
			90092
		]
	],
	"./arrow-circle-left.svg": [
		44123,
		[
			44123
		]
	],
	"./arrow-circle-right.svg": [
		22878,
		[
			22878
		]
	],
	"./arrow-circle-up.svg": [
		42631,
		[
			42631
		]
	],
	"./arrow-down-1-9.svg": [
		22191,
		[
			22191
		]
	],
	"./arrow-down-9-1.svg": [
		70015,
		[
			70015
		]
	],
	"./arrow-down-a-z.svg": [
		62732,
		[
			62732
		]
	],
	"./arrow-down-arrow-up.svg": [
		85239,
		[
			85239
		]
	],
	"./arrow-down-big-small.svg": [
		29132,
		[
			29132
		]
	],
	"./arrow-down-from-arc.svg": [
		76959,
		[
			76959
		]
	],
	"./arrow-down-from-bracket.svg": [
		83151,
		[
			83151
		]
	],
	"./arrow-down-from-dotted-line.svg": [
		68228,
		[
			68228
		]
	],
	"./arrow-down-from-line.svg": [
		72283,
		[
			72283
		]
	],
	"./arrow-down-left-and-arrow-up-right-to-center.svg": [
		98434,
		[
			98434
		]
	],
	"./arrow-down-left.svg": [
		36679,
		[
			36679
		]
	],
	"./arrow-down-long-to-line.svg": [
		88203,
		[
			88203
		]
	],
	"./arrow-down-long.svg": [
		25110,
		[
			25110
		]
	],
	"./arrow-down-right.svg": [
		64674,
		[
			64674
		]
	],
	"./arrow-down-short-wide.svg": [
		84170,
		[
			84170
		]
	],
	"./arrow-down-small-big.svg": [
		81196,
		[
			81196
		]
	],
	"./arrow-down-square-triangle.svg": [
		774,
		[
			774
		]
	],
	"./arrow-down-to-arc.svg": [
		14632,
		[
			14632
		]
	],
	"./arrow-down-to-bracket.svg": [
		36644,
		[
			36644
		]
	],
	"./arrow-down-to-dotted-line.svg": [
		30455,
		[
			30455
		]
	],
	"./arrow-down-to-line.svg": [
		52878,
		[
			52878
		]
	],
	"./arrow-down-to-square.svg": [
		90293,
		[
			90293
		]
	],
	"./arrow-down-triangle-square.svg": [
		40456,
		[
			40456
		]
	],
	"./arrow-down-up-across-line.svg": [
		89478,
		[
			89478
		]
	],
	"./arrow-down-up-lock.svg": [
		44297,
		[
			44297
		]
	],
	"./arrow-down-wide-short.svg": [
		41996,
		[
			41996
		]
	],
	"./arrow-down-z-a.svg": [
		23460,
		[
			23460
		]
	],
	"./arrow-down.svg": [
		89811,
		[
			89811
		]
	],
	"./arrow-from-bottom.svg": [
		91741,
		[
			91741
		]
	],
	"./arrow-from-left.svg": [
		93503,
		[
			93503
		]
	],
	"./arrow-from-right.svg": [
		63418,
		[
			63418
		]
	],
	"./arrow-from-top.svg": [
		93461,
		[
			93461
		]
	],
	"./arrow-left-arrow-right.svg": [
		90449,
		[
			90449
		]
	],
	"./arrow-left-from-arc.svg": [
		5254,
		[
			5254
		]
	],
	"./arrow-left-from-bracket.svg": [
		6010,
		[
			6010
		]
	],
	"./arrow-left-from-dotted-line.svg": [
		12733,
		[
			12733
		]
	],
	"./arrow-left-from-line.svg": [
		47956,
		[
			47956
		]
	],
	"./arrow-left-long-to-line.svg": [
		40690,
		[
			40690
		]
	],
	"./arrow-left-long.svg": [
		32463,
		[
			32463
		]
	],
	"./arrow-left-rotate.svg": [
		94152,
		[
			94152
		]
	],
	"./arrow-left-to-arc.svg": [
		72333,
		[
			72333
		]
	],
	"./arrow-left-to-bracket.svg": [
		47605,
		[
			47605
		]
	],
	"./arrow-left-to-dotted-line.svg": [
		1594,
		[
			1594
		]
	],
	"./arrow-left-to-line.svg": [
		43561,
		[
			43561
		]
	],
	"./arrow-left.svg": [
		40644,
		[
			40644
		]
	],
	"./arrow-pointer.svg": [
		93010,
		[
			93010
		]
	],
	"./arrow-progress.svg": [
		60830,
		[
			60830
		]
	],
	"./arrow-right-arrow-left.svg": [
		20147,
		[
			20147
		]
	],
	"./arrow-right-from-arc.svg": [
		46119,
		[
			46119
		]
	],
	"./arrow-right-from-bracket.svg": [
		98311,
		[
			98311
		]
	],
	"./arrow-right-from-dotted-line.svg": [
		21980,
		[
			21980
		]
	],
	"./arrow-right-from-file.svg": [
		66231,
		[
			66231
		]
	],
	"./arrow-right-from-line.svg": [
		16195,
		[
			16195
		]
	],
	"./arrow-right-long-to-line.svg": [
		67091,
		[
			67091
		]
	],
	"./arrow-right-long.svg": [
		37662,
		[
			15281
		]
	],
	"./arrow-right-rotate.svg": [
		94993,
		[
			94993
		]
	],
	"./arrow-right-to-arc.svg": [
		21504,
		[
			21504
		]
	],
	"./arrow-right-to-bracket.svg": [
		63884,
		[
			63884
		]
	],
	"./arrow-right-to-city.svg": [
		40269,
		[
			40269
		]
	],
	"./arrow-right-to-dotted-line.svg": [
		92991,
		[
			92991
		]
	],
	"./arrow-right-to-file.svg": [
		48578,
		[
			48578
		]
	],
	"./arrow-right-to-line.svg": [
		49766,
		[
			49766
		]
	],
	"./arrow-right.svg": [
		89675,
		[
			89675
		]
	],
	"./arrow-rotate-back.svg": [
		53602,
		[
			53602
		]
	],
	"./arrow-rotate-backward.svg": [
		58568,
		[
			58568
		]
	],
	"./arrow-rotate-forward.svg": [
		79922,
		[
			79922
		]
	],
	"./arrow-rotate-left-10.svg": [
		54486,
		[
			54486
		]
	],
	"./arrow-rotate-left.svg": [
		73636,
		[
			73636
		]
	],
	"./arrow-rotate-right-10.svg": [
		24791,
		[
			24791
		]
	],
	"./arrow-rotate-right.svg": [
		19115,
		[
			19115
		]
	],
	"./arrow-square-down.svg": [
		67487,
		[
			67487
		]
	],
	"./arrow-square-left.svg": [
		25376,
		[
			25376
		]
	],
	"./arrow-square-right.svg": [
		76239,
		[
			76239
		]
	],
	"./arrow-square-up.svg": [
		23760,
		[
			23760
		]
	],
	"./arrow-to-bottom.svg": [
		71056,
		[
			71056
		]
	],
	"./arrow-to-left.svg": [
		44866,
		[
			44866
		]
	],
	"./arrow-to-right.svg": [
		3065,
		[
			3065
		]
	],
	"./arrow-to-top.svg": [
		55818,
		[
			55818
		]
	],
	"./arrow-trend-down.svg": [
		89165,
		[
			89165
		]
	],
	"./arrow-trend-up.svg": [
		45074,
		[
			45074
		]
	],
	"./arrow-turn-down-left.svg": [
		1983,
		[
			1983
		]
	],
	"./arrow-turn-down-right.svg": [
		92986,
		[
			92986
		]
	],
	"./arrow-turn-down.svg": [
		76987,
		[
			76987
		]
	],
	"./arrow-turn-left-down.svg": [
		43885,
		[
			43885
		]
	],
	"./arrow-turn-left-up.svg": [
		84242,
		[
			84242
		]
	],
	"./arrow-turn-left.svg": [
		66588,
		[
			66588
		]
	],
	"./arrow-turn-right.svg": [
		57347,
		[
			57347
		]
	],
	"./arrow-turn-up.svg": [
		64180,
		[
			64180
		]
	],
	"./arrow-u-turn-down-left.svg": [
		84837,
		[
			84837
		]
	],
	"./arrow-u-turn-down-right.svg": [
		33864,
		[
			33864
		]
	],
	"./arrow-u-turn-left-down.svg": [
		51299,
		[
			51299
		]
	],
	"./arrow-u-turn-left-up.svg": [
		49276,
		[
			49276
		]
	],
	"./arrow-u-turn-right-down.svg": [
		21758,
		[
			21758
		]
	],
	"./arrow-u-turn-right-up.svg": [
		47189,
		[
			47189
		]
	],
	"./arrow-u-turn-up-left.svg": [
		17800,
		[
			17800
		]
	],
	"./arrow-u-turn-up-right.svg": [
		93431,
		[
			93431
		]
	],
	"./arrow-up-1-9.svg": [
		30456,
		[
			30456
		]
	],
	"./arrow-up-9-1.svg": [
		57224,
		[
			57224
		]
	],
	"./arrow-up-a-z.svg": [
		63099,
		[
			63099
		]
	],
	"./arrow-up-arrow-down.svg": [
		33225,
		[
			33225
		]
	],
	"./arrow-up-big-small.svg": [
		9387,
		[
			9387
		]
	],
	"./arrow-up-from-arc.svg": [
		15422,
		[
			15422
		]
	],
	"./arrow-up-from-bracket.svg": [
		77794,
		[
			77794
		]
	],
	"./arrow-up-from-dotted-line.svg": [
		88197,
		[
			88197
		]
	],
	"./arrow-up-from-ground-water.svg": [
		7001,
		[
			7001
		]
	],
	"./arrow-up-from-line.svg": [
		33196,
		[
			33196
		]
	],
	"./arrow-up-from-square.svg": [
		95919,
		[
			95919
		]
	],
	"./arrow-up-from-water-pump.svg": [
		17442,
		[
			17442
		]
	],
	"./arrow-up-left-from-circle.svg": [
		25356,
		[
			25356
		]
	],
	"./arrow-up-left.svg": [
		18566,
		[
			18566
		]
	],
	"./arrow-up-long-to-line.svg": [
		32170,
		[
			32170
		]
	],
	"./arrow-up-long.svg": [
		59719,
		[
			59719
		]
	],
	"./arrow-up-right-and-arrow-down-left-from-center.svg": [
		70941,
		[
			70941
		]
	],
	"./arrow-up-right-dots.svg": [
		27854,
		[
			27854
		]
	],
	"./arrow-up-right-from-square.svg": [
		62370,
		[
			62370
		]
	],
	"./arrow-up-right.svg": [
		83877,
		[
			83877
		]
	],
	"./arrow-up-short-wide.svg": [
		55895,
		[
			55895
		]
	],
	"./arrow-up-small-big.svg": [
		17787,
		[
			17787
		]
	],
	"./arrow-up-square-triangle.svg": [
		24717,
		[
			24717
		]
	],
	"./arrow-up-to-arc.svg": [
		82549,
		[
			82549
		]
	],
	"./arrow-up-to-bracket.svg": [
		88493,
		[
			88493
		]
	],
	"./arrow-up-to-dotted-line.svg": [
		10034,
		[
			10034
		]
	],
	"./arrow-up-to-line.svg": [
		16945,
		[
			16945
		]
	],
	"./arrow-up-triangle-square.svg": [
		85071,
		[
			85071
		]
	],
	"./arrow-up-wide-short.svg": [
		23809,
		[
			23809
		]
	],
	"./arrow-up-z-a.svg": [
		43171,
		[
			43171
		]
	],
	"./arrow-up.svg": [
		52460,
		[
			52460
		]
	],
	"./arrows-alt-h.svg": [
		40096,
		[
			40096
		]
	],
	"./arrows-alt-v.svg": [
		97558,
		[
			97558
		]
	],
	"./arrows-alt.svg": [
		27503,
		[
			27503
		]
	],
	"./arrows-cross.svg": [
		40954,
		[
			40954
		]
	],
	"./arrows-down-to-line.svg": [
		92191,
		[
			92191
		]
	],
	"./arrows-down-to-people.svg": [
		55116,
		[
			55116
		]
	],
	"./arrows-from-dotted-line.svg": [
		15958,
		[
			15958
		]
	],
	"./arrows-from-line.svg": [
		78357,
		[
			78357
		]
	],
	"./arrows-h.svg": [
		32398,
		[
			32398
		]
	],
	"./arrows-left-right-to-line.svg": [
		41309,
		[
			41309
		]
	],
	"./arrows-left-right.svg": [
		61984,
		[
			61984
		]
	],
	"./arrows-maximize.svg": [
		67292,
		[
			67292
		]
	],
	"./arrows-minimize.svg": [
		12618,
		[
			12618
		]
	],
	"./arrows-repeat-1.svg": [
		15437,
		[
			15437
		]
	],
	"./arrows-repeat.svg": [
		77003,
		[
			77003
		]
	],
	"./arrows-retweet.svg": [
		16928,
		[
			16928
		]
	],
	"./arrows-rotate-reverse.svg": [
		35634,
		[
			35634
		]
	],
	"./arrows-rotate.svg": [
		44231,
		[
			44231
		]
	],
	"./arrows-spin.svg": [
		39178,
		[
			39178
		]
	],
	"./arrows-split-up-and-left.svg": [
		28006,
		[
			28006
		]
	],
	"./arrows-to-circle.svg": [
		96942,
		[
			96942
		]
	],
	"./arrows-to-dot.svg": [
		47611,
		[
			47611
		]
	],
	"./arrows-to-dotted-line.svg": [
		46209,
		[
			46209
		]
	],
	"./arrows-to-eye.svg": [
		87769,
		[
			10150
		]
	],
	"./arrows-to-line.svg": [
		19192,
		[
			19192
		]
	],
	"./arrows-turn-right.svg": [
		23462,
		[
			1081
		]
	],
	"./arrows-turn-to-dots.svg": [
		78712,
		[
			78712
		]
	],
	"./arrows-up-down-left-right.svg": [
		82329,
		[
			82329
		]
	],
	"./arrows-up-down.svg": [
		95006,
		[
			95006
		]
	],
	"./arrows-up-to-line.svg": [
		8748,
		[
			8748
		]
	],
	"./arrows-v.svg": [
		52616,
		[
			52616
		]
	],
	"./arrows.svg": [
		91205,
		[
			13586
		]
	],
	"./asl-interpreting.svg": [
		49683,
		[
			49683
		]
	],
	"./assistive-listening-systems.svg": [
		35865,
		[
			35865
		]
	],
	"./asterisk.svg": [
		54483,
		[
			54483
		]
	],
	"./at.svg": [
		23264,
		[
			23264
		]
	],
	"./atlas.svg": [
		17220,
		[
			17220
		]
	],
	"./atom-alt.svg": [
		67462,
		[
			67462
		]
	],
	"./atom-simple.svg": [
		97111,
		[
			97111
		]
	],
	"./atom.svg": [
		42320,
		[
			19939
		]
	],
	"./audio-description-slash.svg": [
		93066,
		[
			93066
		]
	],
	"./audio-description.svg": [
		35562,
		[
			35562
		]
	],
	"./austral-sign.svg": [
		15529,
		[
			15529
		]
	],
	"./australian-dollar-sign.svg": [
		33384,
		[
			33384
		]
	],
	"./automobile.svg": [
		91920,
		[
			91920
		]
	],
	"./avocado.svg": [
		95874,
		[
			95874
		]
	],
	"./award-simple.svg": [
		13497,
		[
			13497
		]
	],
	"./award.svg": [
		79450,
		[
			79450
		]
	],
	"./axe-battle.svg": [
		71088,
		[
			71088
		]
	],
	"./axe.svg": [
		17617,
		[
			17617
		]
	],
	"./b.svg": [
		94535,
		[
			94535
		]
	],
	"./baby-carriage.svg": [
		69198,
		[
			46817
		]
	],
	"./baby.svg": [
		63883,
		[
			63883
		]
	],
	"./backpack.svg": [
		9761,
		[
			9761
		]
	],
	"./backspace.svg": [
		40516,
		[
			40516
		]
	],
	"./backward-fast.svg": [
		26007,
		[
			26007
		]
	],
	"./backward-step.svg": [
		44907,
		[
			44907
		]
	],
	"./backward.svg": [
		6860,
		[
			6860
		]
	],
	"./bacon.svg": [
		26736,
		[
			26736
		]
	],
	"./bacteria.svg": [
		67674,
		[
			67674
		]
	],
	"./bacterium.svg": [
		7855,
		[
			7855
		]
	],
	"./badge-check.svg": [
		31955,
		[
			31955
		]
	],
	"./badge-dollar.svg": [
		14763,
		[
			14763
		]
	],
	"./badge-percent.svg": [
		31148,
		[
			31148
		]
	],
	"./badge-sheriff.svg": [
		20798,
		[
			20798
		]
	],
	"./badge.svg": [
		40544,
		[
			40544
		]
	],
	"./badger-honey.svg": [
		83648,
		[
			83648
		]
	],
	"./badminton.svg": [
		11899,
		[
			11899
		]
	],
	"./bag-seedling.svg": [
		62099,
		[
			62099
		]
	],
	"./bag-shopping-minus.svg": [
		3055,
		[
			3055
		]
	],
	"./bag-shopping-plus.svg": [
		39073,
		[
			39073
		]
	],
	"./bag-shopping.svg": [
		56232,
		[
			56232
		]
	],
	"./bagel.svg": [
		83112,
		[
			83112
		]
	],
	"./bags-shopping.svg": [
		97587,
		[
			97587
		]
	],
	"./baguette.svg": [
		41390,
		[
			41390
		]
	],
	"./bahai.svg": [
		64094,
		[
			64094
		]
	],
	"./baht-sign.svg": [
		12414,
		[
			12414
		]
	],
	"./balance-scale-left.svg": [
		41130,
		[
			41130
		]
	],
	"./balance-scale-right.svg": [
		42529,
		[
			42529
		]
	],
	"./balance-scale.svg": [
		78096,
		[
			78096
		]
	],
	"./ball-pile.svg": [
		67313,
		[
			67313
		]
	],
	"./ball-yarn.svg": [
		35811,
		[
			35811
		]
	],
	"./balloon.svg": [
		99956,
		[
			99956
		]
	],
	"./balloons.svg": [
		41599,
		[
			41599
		]
	],
	"./ballot-check.svg": [
		80042,
		[
			80042
		]
	],
	"./ballot.svg": [
		96341,
		[
			96341
		]
	],
	"./ban-bug.svg": [
		97739,
		[
			97739
		]
	],
	"./ban-parking.svg": [
		85009,
		[
			85009
		]
	],
	"./ban-smoking.svg": [
		93671,
		[
			93671
		]
	],
	"./ban.svg": [
		13178,
		[
			13178
		]
	],
	"./banana.svg": [
		78792,
		[
			78792
		]
	],
	"./band-aid.svg": [
		14383,
		[
			14383
		]
	],
	"./bandage.svg": [
		60043,
		[
			60043
		]
	],
	"./bangladeshi-taka-sign.svg": [
		20719,
		[
			20719
		]
	],
	"./banjo.svg": [
		96003,
		[
			96003
		]
	],
	"./bank.svg": [
		9821,
		[
			9821
		]
	],
	"./bar-chart.svg": [
		62241,
		[
			62241
		]
	],
	"./bar-progress-empty.svg": [
		45806,
		[
			45806
		]
	],
	"./bar-progress-full.svg": [
		99008,
		[
			99008
		]
	],
	"./bar-progress-half.svg": [
		97768,
		[
			97768
		]
	],
	"./bar-progress-quarter.svg": [
		63897,
		[
			63897
		]
	],
	"./bar-progress-three-quarters.svg": [
		73221,
		[
			73221
		]
	],
	"./bar-progress.svg": [
		48330,
		[
			48330
		]
	],
	"./barcode-alt.svg": [
		61575,
		[
			61575
		]
	],
	"./barcode-read.svg": [
		84442,
		[
			84442
		]
	],
	"./barcode-scan.svg": [
		13409,
		[
			13409
		]
	],
	"./barcode.svg": [
		18045,
		[
			18045
		]
	],
	"./barn-silo.svg": [
		22914,
		[
			22914
		]
	],
	"./barn.svg": [
		35492,
		[
			35492
		]
	],
	"./bars-filter.svg": [
		17092,
		[
			17092
		]
	],
	"./bars-progress.svg": [
		16687,
		[
			16687
		]
	],
	"./bars-sort.svg": [
		75670,
		[
			75670
		]
	],
	"./bars-staggered.svg": [
		40708,
		[
			40708
		]
	],
	"./bars.svg": [
		66433,
		[
			66433
		]
	],
	"./baseball-ball.svg": [
		12455,
		[
			12455
		]
	],
	"./baseball-bat-ball.svg": [
		99121,
		[
			99121
		]
	],
	"./baseball-bat.svg": [
		40089,
		[
			40089
		]
	],
	"./baseball.svg": [
		63023,
		[
			63023
		]
	],
	"./basket-shopping-minus.svg": [
		63353,
		[
			63353
		]
	],
	"./basket-shopping-plus.svg": [
		81291,
		[
			81291
		]
	],
	"./basket-shopping-simple.svg": [
		22785,
		[
			22785
		]
	],
	"./basket-shopping.svg": [
		96978,
		[
			96978
		]
	],
	"./basketball-ball.svg": [
		55048,
		[
			55048
		]
	],
	"./basketball-hoop.svg": [
		99969,
		[
			99969
		]
	],
	"./basketball.svg": [
		46298,
		[
			46298
		]
	],
	"./bat.svg": [
		88784,
		[
			88784
		]
	],
	"./bath.svg": [
		68200,
		[
			68200
		]
	],
	"./bathtub.svg": [
		5441,
		[
			5441
		]
	],
	"./battery-0.svg": [
		12369,
		[
			12369
		]
	],
	"./battery-1.svg": [
		97984,
		[
			97984
		]
	],
	"./battery-2.svg": [
		42643,
		[
			42643
		]
	],
	"./battery-3.svg": [
		55266,
		[
			55266
		]
	],
	"./battery-4.svg": [
		83789,
		[
			83789
		]
	],
	"./battery-5.svg": [
		36428,
		[
			36428
		]
	],
	"./battery-bolt.svg": [
		71142,
		[
			71142
		]
	],
	"./battery-car.svg": [
		51999,
		[
			51999
		]
	],
	"./battery-empty.svg": [
		69846,
		[
			69846
		]
	],
	"./battery-exclamation.svg": [
		73206,
		[
			73206
		]
	],
	"./battery-full.svg": [
		48632,
		[
			48632
		]
	],
	"./battery-half.svg": [
		1920,
		[
			1920
		]
	],
	"./battery-low.svg": [
		44727,
		[
			44727
		]
	],
	"./battery-quarter.svg": [
		97825,
		[
			97825
		]
	],
	"./battery-slash.svg": [
		92114,
		[
			92114
		]
	],
	"./battery-three-quarters.svg": [
		32669,
		[
			32669
		]
	],
	"./battery.svg": [
		77122,
		[
			77122
		]
	],
	"./bed-alt.svg": [
		76978,
		[
			76978
		]
	],
	"./bed-bunk.svg": [
		37087,
		[
			37087
		]
	],
	"./bed-empty.svg": [
		83032,
		[
			83032
		]
	],
	"./bed-front.svg": [
		36566,
		[
			36566
		]
	],
	"./bed-pulse.svg": [
		18020,
		[
			18020
		]
	],
	"./bed.svg": [
		54228,
		[
			54228
		]
	],
	"./bee.svg": [
		15509,
		[
			15509
		]
	],
	"./beer-foam.svg": [
		31865,
		[
			31865
		]
	],
	"./beer-mug-empty.svg": [
		10031,
		[
			10031
		]
	],
	"./beer-mug.svg": [
		61707,
		[
			61707
		]
	],
	"./beer.svg": [
		42045,
		[
			42045
		]
	],
	"./bell-concierge.svg": [
		5298,
		[
			5298
		]
	],
	"./bell-exclamation.svg": [
		41848,
		[
			41848
		]
	],
	"./bell-on.svg": [
		58622,
		[
			58622
		]
	],
	"./bell-plus.svg": [
		58745,
		[
			58745
		]
	],
	"./bell-ring.svg": [
		48771,
		[
			48771
		]
	],
	"./bell-school-slash.svg": [
		76333,
		[
			76333
		]
	],
	"./bell-school.svg": [
		95345,
		[
			95345
		]
	],
	"./bell-slash.svg": [
		17768,
		[
			17768
		]
	],
	"./bell.svg": [
		16400,
		[
			16400
		]
	],
	"./bells.svg": [
		15699,
		[
			15699
		]
	],
	"./bench-tree.svg": [
		21236,
		[
			21236
		]
	],
	"./betamax.svg": [
		87493,
		[
			87493
		]
	],
	"./bezier-curve.svg": [
		58264,
		[
			58264
		]
	],
	"./bible.svg": [
		92975,
		[
			15356
		]
	],
	"./bicycle.svg": [
		8590,
		[
			8590
		]
	],
	"./biking-mountain.svg": [
		27059,
		[
			27059
		]
	],
	"./biking.svg": [
		91993,
		[
			91993
		]
	],
	"./billboard.svg": [
		21036,
		[
			21036
		]
	],
	"./bin-bottles-recycle.svg": [
		96218,
		[
			96218
		]
	],
	"./bin-bottles.svg": [
		89494,
		[
			89494
		]
	],
	"./bin-recycle.svg": [
		1318,
		[
			1318
		]
	],
	"./bin.svg": [
		51234,
		[
			51234
		]
	],
	"./binary-circle-check.svg": [
		45254,
		[
			22873
		]
	],
	"./binary-lock.svg": [
		25444,
		[
			25444
		]
	],
	"./binary-slash.svg": [
		42956,
		[
			42956
		]
	],
	"./binary.svg": [
		28228,
		[
			28228
		]
	],
	"./binoculars.svg": [
		45485,
		[
			45485
		]
	],
	"./biohazard.svg": [
		77395,
		[
			77395
		]
	],
	"./bird.svg": [
		88790,
		[
			88790
		]
	],
	"./birthday-cake.svg": [
		98029,
		[
			98029
		]
	],
	"./bitcoin-sign.svg": [
		25411,
		[
			25411
		]
	],
	"./blackboard.svg": [
		10068,
		[
			10068
		]
	],
	"./blanket-fire.svg": [
		75505,
		[
			75505
		]
	],
	"./blanket.svg": [
		56064,
		[
			56064
		]
	],
	"./blender-phone.svg": [
		4698,
		[
			4698
		]
	],
	"./blender.svg": [
		31237,
		[
			31237
		]
	],
	"./blind.svg": [
		88652,
		[
			88652
		]
	],
	"./blinds-open.svg": [
		19688,
		[
			19688
		]
	],
	"./blinds-raised.svg": [
		55180,
		[
			55180
		]
	],
	"./blinds.svg": [
		18823,
		[
			18823
		]
	],
	"./block-brick-fire.svg": [
		2227,
		[
			2227
		]
	],
	"./block-brick.svg": [
		4166,
		[
			4166
		]
	],
	"./block-question.svg": [
		95151,
		[
			95151
		]
	],
	"./block-quote.svg": [
		85,
		[
			85
		]
	],
	"./block.svg": [
		53494,
		[
			53494
		]
	],
	"./blog.svg": [
		10851,
		[
			10851
		]
	],
	"./blueberries.svg": [
		73029,
		[
			73029
		]
	],
	"./bluetooth.svg": [
		6655,
		[
			6655
		]
	],
	"./bold.svg": [
		71274,
		[
			71274
		]
	],
	"./bolt-auto.svg": [
		91198,
		[
			91198
		]
	],
	"./bolt-lightning.svg": [
		73003,
		[
			73003
		]
	],
	"./bolt-slash.svg": [
		23450,
		[
			23450
		]
	],
	"./bolt.svg": [
		22362,
		[
			22362
		]
	],
	"./bomb.svg": [
		15619,
		[
			15619
		]
	],
	"./bone-break.svg": [
		66031,
		[
			66031
		]
	],
	"./bone.svg": [
		7285,
		[
			7285
		]
	],
	"./bong.svg": [
		33863,
		[
			33863
		]
	],
	"./book-alt.svg": [
		5526,
		[
			5526
		]
	],
	"./book-arrow-right.svg": [
		7709,
		[
			7709
		]
	],
	"./book-arrow-up.svg": [
		97482,
		[
			97482
		]
	],
	"./book-atlas.svg": [
		32450,
		[
			32450
		]
	],
	"./book-bible.svg": [
		77473,
		[
			77473
		]
	],
	"./book-blank.svg": [
		85657,
		[
			85657
		]
	],
	"./book-bookmark.svg": [
		39417,
		[
			39417
		]
	],
	"./book-circle-arrow-right.svg": [
		20928,
		[
			20928
		]
	],
	"./book-circle-arrow-up.svg": [
		74157,
		[
			74157
		]
	],
	"./book-circle.svg": [
		2189,
		[
			2189
		]
	],
	"./book-copy.svg": [
		98818,
		[
			98818
		]
	],
	"./book-dead.svg": [
		17243,
		[
			17243
		]
	],
	"./book-font.svg": [
		45786,
		[
			45786
		]
	],
	"./book-heart.svg": [
		54503,
		[
			54503
		]
	],
	"./book-journal-whills.svg": [
		87062,
		[
			87062
		]
	],
	"./book-law.svg": [
		62159,
		[
			62159
		]
	],
	"./book-medical.svg": [
		8570,
		[
			8570
		]
	],
	"./book-open-alt.svg": [
		34971,
		[
			34971
		]
	],
	"./book-open-cover.svg": [
		25675,
		[
			25675
		]
	],
	"./book-open-lines.svg": [
		49235,
		[
			49235
		]
	],
	"./book-open-reader.svg": [
		98647,
		[
			98647
		]
	],
	"./book-open.svg": [
		30937,
		[
			30937
		]
	],
	"./book-quran.svg": [
		28338,
		[
			28338
		]
	],
	"./book-reader.svg": [
		69752,
		[
			69752
		]
	],
	"./book-section.svg": [
		16206,
		[
			16206
		]
	],
	"./book-skull.svg": [
		77896,
		[
			77896
		]
	],
	"./book-sparkles.svg": [
		98076,
		[
			98076
		]
	],
	"./book-spells.svg": [
		45072,
		[
			45072
		]
	],
	"./book-spine.svg": [
		69734,
		[
			69734
		]
	],
	"./book-tanakh.svg": [
		59750,
		[
			59750
		]
	],
	"./book-user.svg": [
		81892,
		[
			81892
		]
	],
	"./book.svg": [
		92000,
		[
			92000
		]
	],
	"./bookmark-circle.svg": [
		30232,
		[
			30232
		]
	],
	"./bookmark-plus.svg": [
		30052,
		[
			30052
		]
	],
	"./bookmark-slash.svg": [
		80823,
		[
			80823
		]
	],
	"./bookmark.svg": [
		24091,
		[
			24091
		]
	],
	"./books-medical.svg": [
		81737,
		[
			81737
		]
	],
	"./books.svg": [
		39267,
		[
			39267
		]
	],
	"./boombox.svg": [
		7517,
		[
			7517
		]
	],
	"./boot-heeled.svg": [
		84013,
		[
			84013
		]
	],
	"./boot.svg": [
		22503,
		[
			22503
		]
	],
	"./booth-curtain.svg": [
		57312,
		[
			57312
		]
	],
	"./border-all.svg": [
		12783,
		[
			12783
		]
	],
	"./border-bottom-right.svg": [
		31774,
		[
			31774
		]
	],
	"./border-bottom.svg": [
		65863,
		[
			65863
		]
	],
	"./border-center-h.svg": [
		51322,
		[
			51322
		]
	],
	"./border-center-v.svg": [
		97436,
		[
			97436
		]
	],
	"./border-inner.svg": [
		49410,
		[
			49410
		]
	],
	"./border-left.svg": [
		41457,
		[
			41457
		]
	],
	"./border-none.svg": [
		92700,
		[
			92700
		]
	],
	"./border-outer.svg": [
		83687,
		[
			83687
		]
	],
	"./border-right.svg": [
		68764,
		[
			68764
		]
	],
	"./border-style-alt.svg": [
		33915,
		[
			33915
		]
	],
	"./border-style.svg": [
		64857,
		[
			64857
		]
	],
	"./border-top-left.svg": [
		38495,
		[
			38495
		]
	],
	"./border-top.svg": [
		47899,
		[
			47899
		]
	],
	"./bore-hole.svg": [
		88648,
		[
			88648
		]
	],
	"./bottle-baby.svg": [
		15928,
		[
			15928
		]
	],
	"./bottle-droplet.svg": [
		99442,
		[
			99442
		]
	],
	"./bottle-water.svg": [
		23729,
		[
			23729
		]
	],
	"./bow-arrow.svg": [
		93733,
		[
			93733
		]
	],
	"./bowl-chopsticks-noodles.svg": [
		33076,
		[
			33076
		]
	],
	"./bowl-chopsticks.svg": [
		61255,
		[
			61255
		]
	],
	"./bowl-food.svg": [
		3876,
		[
			3876
		]
	],
	"./bowl-hot.svg": [
		37793,
		[
			37793
		]
	],
	"./bowl-rice.svg": [
		46055,
		[
			46055
		]
	],
	"./bowl-salad.svg": [
		94659,
		[
			94659
		]
	],
	"./bowl-scoop.svg": [
		33868,
		[
			33868
		]
	],
	"./bowl-scoops.svg": [
		58407,
		[
			58407
		]
	],
	"./bowl-shaved-ice.svg": [
		35753,
		[
			35753
		]
	],
	"./bowl-soft-serve.svg": [
		27434,
		[
			27434
		]
	],
	"./bowl-spoon.svg": [
		72911,
		[
			72911
		]
	],
	"./bowling-ball-pin.svg": [
		25075,
		[
			25075
		]
	],
	"./bowling-ball.svg": [
		99353,
		[
			99353
		]
	],
	"./bowling-pins.svg": [
		94658,
		[
			94658
		]
	],
	"./box-alt.svg": [
		6924,
		[
			6924
		]
	],
	"./box-archive.svg": [
		15356,
		[
			92975
		]
	],
	"./box-arrow-down-arrow-up.svg": [
		27087,
		[
			27087
		]
	],
	"./box-arrow-down-magnifying-glass.svg": [
		47232,
		[
			47232
		]
	],
	"./box-arrow-down.svg": [
		56555,
		[
			56555
		]
	],
	"./box-arrow-up.svg": [
		62948,
		[
			62948
		]
	],
	"./box-ballot.svg": [
		46525,
		[
			46525
		]
	],
	"./box-check.svg": [
		52645,
		[
			52645
		]
	],
	"./box-circle-check.svg": [
		50484,
		[
			50484
		]
	],
	"./box-dollar.svg": [
		64221,
		[
			64221
		]
	],
	"./box-fragile.svg": [
		11669,
		[
			11669
		]
	],
	"./box-full.svg": [
		73068,
		[
			73068
		]
	],
	"./box-heart.svg": [
		31985,
		[
			31985
		]
	],
	"./box-isometric-tape.svg": [
		33807,
		[
			33807
		]
	],
	"./box-isometric.svg": [
		25078,
		[
			25078
		]
	],
	"./box-magnifying-glass.svg": [
		86039,
		[
			86039
		]
	],
	"./box-open-full.svg": [
		90587,
		[
			90587
		]
	],
	"./box-open.svg": [
		17011,
		[
			17011
		]
	],
	"./box-taped.svg": [
		1569,
		[
			1569
		]
	],
	"./box-tissue.svg": [
		23558,
		[
			23558
		]
	],
	"./box-up.svg": [
		85104,
		[
			85104
		]
	],
	"./box-usd.svg": [
		96613,
		[
			96613
		]
	],
	"./box.svg": [
		41366,
		[
			41366
		]
	],
	"./boxes-alt.svg": [
		71820,
		[
			71820
		]
	],
	"./boxes-packing.svg": [
		58168,
		[
			58168
		]
	],
	"./boxes-stacked.svg": [
		31914,
		[
			31914
		]
	],
	"./boxes.svg": [
		29078,
		[
			29078
		]
	],
	"./boxing-glove.svg": [
		12390,
		[
			12390
		]
	],
	"./bra.svg": [
		89092,
		[
			89092
		]
	],
	"./bracket-curly-left.svg": [
		56313,
		[
			56313
		]
	],
	"./bracket-curly-right.svg": [
		900,
		[
			900
		]
	],
	"./bracket-curly.svg": [
		95301,
		[
			95301
		]
	],
	"./bracket-left.svg": [
		24141,
		[
			24141
		]
	],
	"./bracket-round-right.svg": [
		4983,
		[
			4983
		]
	],
	"./bracket-round.svg": [
		37006,
		[
			37006
		]
	],
	"./bracket-square-right.svg": [
		21114,
		[
			21114
		]
	],
	"./bracket-square.svg": [
		46779,
		[
			46779
		]
	],
	"./bracket.svg": [
		8297,
		[
			8297
		]
	],
	"./brackets-curly.svg": [
		79228,
		[
			79228
		]
	],
	"./brackets-round.svg": [
		76087,
		[
			76087
		]
	],
	"./brackets-square.svg": [
		62536,
		[
			62536
		]
	],
	"./brackets.svg": [
		85160,
		[
			85160
		]
	],
	"./braille.svg": [
		85682,
		[
			85682
		]
	],
	"./brain-arrow-curved-right.svg": [
		92516,
		[
			92516
		]
	],
	"./brain-circuit.svg": [
		92103,
		[
			92103
		]
	],
	"./brain.svg": [
		23193,
		[
			23193
		]
	],
	"./brake-warning.svg": [
		73907,
		[
			73907
		]
	],
	"./brazilian-real-sign.svg": [
		74082,
		[
			74082
		]
	],
	"./bread-loaf.svg": [
		13438,
		[
			13438
		]
	],
	"./bread-slice-butter.svg": [
		43781,
		[
			43781
		]
	],
	"./bread-slice.svg": [
		66206,
		[
			66206
		]
	],
	"./bridge-circle-check.svg": [
		80954,
		[
			80954
		]
	],
	"./bridge-circle-exclamation.svg": [
		50685,
		[
			50685
		]
	],
	"./bridge-circle-xmark.svg": [
		14137,
		[
			14137
		]
	],
	"./bridge-lock.svg": [
		83912,
		[
			83912
		]
	],
	"./bridge-suspension.svg": [
		32642,
		[
			32642
		]
	],
	"./bridge-water.svg": [
		45402,
		[
			45402
		]
	],
	"./bridge.svg": [
		94136,
		[
			94136
		]
	],
	"./briefcase-arrow-right.svg": [
		99276,
		[
			99276
		]
	],
	"./briefcase-blank.svg": [
		32632,
		[
			32632
		]
	],
	"./briefcase-clock.svg": [
		88188,
		[
			88188
		]
	],
	"./briefcase-medical.svg": [
		90571,
		[
			12952
		]
	],
	"./briefcase.svg": [
		8089,
		[
			8089
		]
	],
	"./briefs.svg": [
		50252,
		[
			50252
		]
	],
	"./brightness-low.svg": [
		89683,
		[
			89683
		]
	],
	"./brightness.svg": [
		88686,
		[
			88686
		]
	],
	"./bring-forward.svg": [
		41861,
		[
			41861
		]
	],
	"./bring-front.svg": [
		10855,
		[
			10855
		]
	],
	"./broadcast-tower.svg": [
		70248,
		[
			70248
		]
	],
	"./broccoli.svg": [
		37878,
		[
			37878
		]
	],
	"./broom-ball.svg": [
		93068,
		[
			93068
		]
	],
	"./broom-wide.svg": [
		55550,
		[
			55550
		]
	],
	"./broom.svg": [
		46894,
		[
			46894
		]
	],
	"./browser.svg": [
		54197,
		[
			54197
		]
	],
	"./browsers.svg": [
		68156,
		[
			68156
		]
	],
	"./brush.svg": [
		76009,
		[
			76009
		]
	],
	"./bucket.svg": [
		70797,
		[
			70797
		]
	],
	"./bug-slash.svg": [
		48419,
		[
			48419
		]
	],
	"./bug.svg": [
		53207,
		[
			53207
		]
	],
	"./bugs.svg": [
		43622,
		[
			43622
		]
	],
	"./building-circle-arrow-right.svg": [
		74705,
		[
			74705
		]
	],
	"./building-circle-check.svg": [
		30871,
		[
			30871
		]
	],
	"./building-circle-exclamation.svg": [
		10276,
		[
			10276
		]
	],
	"./building-circle-xmark.svg": [
		41820,
		[
			41820
		]
	],
	"./building-columns.svg": [
		69177,
		[
			69177
		]
	],
	"./building-flag.svg": [
		38990,
		[
			38990
		]
	],
	"./building-lock.svg": [
		5877,
		[
			5877
		]
	],
	"./building-magnifying-glass.svg": [
		39380,
		[
			39380
		]
	],
	"./building-memo.svg": [
		40646,
		[
			40646
		]
	],
	"./building-ngo.svg": [
		57512,
		[
			57512
		]
	],
	"./building-shield.svg": [
		691,
		[
			691
		]
	],
	"./building-un.svg": [
		67953,
		[
			67953
		]
	],
	"./building-user.svg": [
		99713,
		[
			22094
		]
	],
	"./building-wheat.svg": [
		96769,
		[
			96769
		]
	],
	"./building.svg": [
		59175,
		[
			59175
		]
	],
	"./buildings.svg": [
		57750,
		[
			57750
		]
	],
	"./bulldozer.svg": [
		68334,
		[
			68334
		]
	],
	"./bullhorn.svg": [
		87467,
		[
			87467
		]
	],
	"./bullseye-arrow.svg": [
		9942,
		[
			9942
		]
	],
	"./bullseye-pointer.svg": [
		75002,
		[
			75002
		]
	],
	"./bullseye.svg": [
		97218,
		[
			97218
		]
	],
	"./buoy-mooring.svg": [
		77566,
		[
			77566
		]
	],
	"./buoy.svg": [
		50196,
		[
			50196
		]
	],
	"./burger-cheese.svg": [
		56798,
		[
			56798
		]
	],
	"./burger-fries.svg": [
		6554,
		[
			6554
		]
	],
	"./burger-glass.svg": [
		22759,
		[
			22759
		]
	],
	"./burger-lettuce.svg": [
		83781,
		[
			83781
		]
	],
	"./burger-soda.svg": [
		68774,
		[
			68774
		]
	],
	"./burger.svg": [
		32296,
		[
			32296
		]
	],
	"./burn.svg": [
		45216,
		[
			45216
		]
	],
	"./burrito.svg": [
		2638,
		[
			2638
		]
	],
	"./burst.svg": [
		36355,
		[
			36355
		]
	],
	"./bus-alt.svg": [
		29205,
		[
			29205
		]
	],
	"./bus-school.svg": [
		20344,
		[
			20344
		]
	],
	"./bus-side.svg": [
		83741,
		[
			83741
		]
	],
	"./bus-simple.svg": [
		75426,
		[
			75426
		]
	],
	"./bus-stop.svg": [
		43980,
		[
			43980
		]
	],
	"./bus.svg": [
		34843,
		[
			34843
		]
	],
	"./business-front.svg": [
		64087,
		[
			64087
		]
	],
	"./business-time.svg": [
		53001,
		[
			53001
		]
	],
	"./butter.svg": [
		93669,
		[
			93669
		]
	],
	"./butterfly.svg": [
		19116,
		[
			19116
		]
	],
	"./c.svg": [
		54998,
		[
			54998
		]
	],
	"./cab.svg": [
		22675,
		[
			22675
		]
	],
	"./cabin.svg": [
		47670,
		[
			47670
		]
	],
	"./cabinet-filing.svg": [
		76837,
		[
			76837
		]
	],
	"./cable-car.svg": [
		34375,
		[
			34375
		]
	],
	"./cactus.svg": [
		96378,
		[
			96378
		]
	],
	"./caduceus.svg": [
		78154,
		[
			78154
		]
	],
	"./cake-candles.svg": [
		39378,
		[
			39378
		]
	],
	"./cake-slice.svg": [
		97242,
		[
			97242
		]
	],
	"./cake.svg": [
		41307,
		[
			41307
		]
	],
	"./calculator-alt.svg": [
		72993,
		[
			72993
		]
	],
	"./calculator-simple.svg": [
		49694,
		[
			49694
		]
	],
	"./calculator.svg": [
		45103,
		[
			45103
		]
	],
	"./calendar-alt.svg": [
		73711,
		[
			73711
		]
	],
	"./calendar-arrow-down.svg": [
		58382,
		[
			58382
		]
	],
	"./calendar-arrow-up.svg": [
		16997,
		[
			16997
		]
	],
	"./calendar-check.svg": [
		48666,
		[
			48666
		]
	],
	"./calendar-circle-exclamation.svg": [
		27846,
		[
			27846
		]
	],
	"./calendar-circle-minus.svg": [
		2329,
		[
			2329
		]
	],
	"./calendar-circle-plus.svg": [
		53835,
		[
			53835
		]
	],
	"./calendar-circle-user.svg": [
		50090,
		[
			50090
		]
	],
	"./calendar-circle.svg": [
		46162,
		[
			46162
		]
	],
	"./calendar-clock.svg": [
		55680,
		[
			55680
		]
	],
	"./calendar-day.svg": [
		21820,
		[
			21820
		]
	],
	"./calendar-days.svg": [
		8855,
		[
			8855
		]
	],
	"./calendar-download.svg": [
		47122,
		[
			47122
		]
	],
	"./calendar-edit.svg": [
		61518,
		[
			61518
		]
	],
	"./calendar-exclamation.svg": [
		21405,
		[
			21405
		]
	],
	"./calendar-heart.svg": [
		57782,
		[
			57782
		]
	],
	"./calendar-image.svg": [
		86305,
		[
			86305
		]
	],
	"./calendar-lines-pen.svg": [
		19161,
		[
			19161
		]
	],
	"./calendar-lines.svg": [
		52527,
		[
			52527
		]
	],
	"./calendar-minus.svg": [
		97734,
		[
			75353
		]
	],
	"./calendar-note.svg": [
		68390,
		[
			68390
		]
	],
	"./calendar-pen.svg": [
		62355,
		[
			62355
		]
	],
	"./calendar-plus.svg": [
		92590,
		[
			92590
		]
	],
	"./calendar-range.svg": [
		84153,
		[
			84153
		]
	],
	"./calendar-star.svg": [
		28762,
		[
			28762
		]
	],
	"./calendar-time.svg": [
		59541,
		[
			59541
		]
	],
	"./calendar-times.svg": [
		45180,
		[
			45180
		]
	],
	"./calendar-upload.svg": [
		15425,
		[
			15425
		]
	],
	"./calendar-users.svg": [
		9970,
		[
			9970
		]
	],
	"./calendar-week.svg": [
		92846,
		[
			70465
		]
	],
	"./calendar-xmark.svg": [
		81849,
		[
			81849
		]
	],
	"./calendar.svg": [
		13125,
		[
			13125
		]
	],
	"./calendars.svg": [
		40300,
		[
			40300
		]
	],
	"./camcorder.svg": [
		74597,
		[
			74597
		]
	],
	"./camera-alt.svg": [
		86352,
		[
			86352
		]
	],
	"./camera-cctv.svg": [
		70399,
		[
			70399
		]
	],
	"./camera-circle-ellipsis.svg": [
		27865,
		[
			27865
		]
	],
	"./camera-circle.svg": [
		28895,
		[
			28895
		]
	],
	"./camera-clock.svg": [
		62155,
		[
			62155
		]
	],
	"./camera-home.svg": [
		15262,
		[
			15262
		]
	],
	"./camera-movie.svg": [
		78321,
		[
			78321
		]
	],
	"./camera-polaroid.svg": [
		49723,
		[
			49723
		]
	],
	"./camera-retro.svg": [
		15273,
		[
			15273
		]
	],
	"./camera-rotate.svg": [
		92610,
		[
			92610
		]
	],
	"./camera-security.svg": [
		27869,
		[
			27869
		]
	],
	"./camera-shutter.svg": [
		71706,
		[
			71706
		]
	],
	"./camera-slash.svg": [
		54146,
		[
			54146
		]
	],
	"./camera-viewfinder.svg": [
		45668,
		[
			45668
		]
	],
	"./camera-web-slash.svg": [
		85083,
		[
			85083
		]
	],
	"./camera-web.svg": [
		59743,
		[
			59743
		]
	],
	"./camera.svg": [
		16914,
		[
			16914
		]
	],
	"./campfire.svg": [
		82032,
		[
			82032
		]
	],
	"./campground.svg": [
		69533,
		[
			69533
		]
	],
	"./can-food.svg": [
		28260,
		[
			28260
		]
	],
	"./cancel.svg": [
		1809,
		[
			1809
		]
	],
	"./candle-holder.svg": [
		23747,
		[
			23747
		]
	],
	"./candy-bar.svg": [
		40218,
		[
			40218
		]
	],
	"./candy-cane.svg": [
		94028,
		[
			94028
		]
	],
	"./candy-corn.svg": [
		96237,
		[
			96237
		]
	],
	"./candy.svg": [
		19554,
		[
			19554
		]
	],
	"./cannabis.svg": [
		92254,
		[
			92254
		]
	],
	"./cannon.svg": [
		48116,
		[
			48116
		]
	],
	"./capsule.svg": [
		9540,
		[
			9540
		]
	],
	"./capsules.svg": [
		89615,
		[
			89615
		]
	],
	"./car-alt.svg": [
		85117,
		[
			85117
		]
	],
	"./car-battery.svg": [
		35299,
		[
			35299
		]
	],
	"./car-bolt.svg": [
		88341,
		[
			88341
		]
	],
	"./car-building.svg": [
		74348,
		[
			74348
		]
	],
	"./car-bump.svg": [
		29136,
		[
			29136
		]
	],
	"./car-burst.svg": [
		75846,
		[
			75846
		]
	],
	"./car-bus.svg": [
		39830,
		[
			17449
		]
	],
	"./car-circle-bolt.svg": [
		51248,
		[
			51248
		]
	],
	"./car-crash.svg": [
		35365,
		[
			35365
		]
	],
	"./car-garage.svg": [
		35667,
		[
			35667
		]
	],
	"./car-key.svg": [
		93657,
		[
			93657
		]
	],
	"./car-mechanic.svg": [
		33290,
		[
			33290
		]
	],
	"./car-mirrors.svg": [
		9972,
		[
			9972
		]
	],
	"./car-on.svg": [
		37711,
		[
			37711
		]
	],
	"./car-people.svg": [
		49597,
		[
			49597
		]
	],
	"./car-rear.svg": [
		53246,
		[
			53246
		]
	],
	"./car-side-bolt.svg": [
		75411,
		[
			75411
		]
	],
	"./car-side.svg": [
		14325,
		[
			14325
		]
	],
	"./car-siren-on.svg": [
		52863,
		[
			52863
		]
	],
	"./car-siren.svg": [
		75155,
		[
			75155
		]
	],
	"./car-tilt.svg": [
		17945,
		[
			17945
		]
	],
	"./car-tunnel.svg": [
		90370,
		[
			90370
		]
	],
	"./car-wash.svg": [
		39025,
		[
			39025
		]
	],
	"./car-wrench.svg": [
		97847,
		[
			97847
		]
	],
	"./car.svg": [
		17347,
		[
			17347
		]
	],
	"./caravan-alt.svg": [
		6713,
		[
			6713
		]
	],
	"./caravan-simple.svg": [
		3078,
		[
			3078
		]
	],
	"./caravan.svg": [
		47399,
		[
			47399
		]
	],
	"./card-club.svg": [
		758,
		[
			758
		]
	],
	"./card-diamond.svg": [
		77226,
		[
			77226
		]
	],
	"./card-heart.svg": [
		78518,
		[
			78518
		]
	],
	"./card-spade.svg": [
		97445,
		[
			97445
		]
	],
	"./cards-blank.svg": [
		36301,
		[
			36301
		]
	],
	"./cards.svg": [
		98444,
		[
			98444
		]
	],
	"./caret-circle-down.svg": [
		57482,
		[
			57482
		]
	],
	"./caret-circle-left.svg": [
		66305,
		[
			66305
		]
	],
	"./caret-circle-right.svg": [
		20972,
		[
			20972
		]
	],
	"./caret-circle-up.svg": [
		74905,
		[
			74905
		]
	],
	"./caret-down.svg": [
		1201,
		[
			1201
		]
	],
	"./caret-large-down.svg": [
		90567,
		[
			90567
		]
	],
	"./caret-large-left.svg": [
		88152,
		[
			88152
		]
	],
	"./caret-large-right.svg": [
		3911,
		[
			3911
		]
	],
	"./caret-large-up.svg": [
		67512,
		[
			67512
		]
	],
	"./caret-left.svg": [
		77930,
		[
			77930
		]
	],
	"./caret-right.svg": [
		62593,
		[
			62593
		]
	],
	"./caret-square-down.svg": [
		39473,
		[
			39473
		]
	],
	"./caret-square-left.svg": [
		38730,
		[
			38730
		]
	],
	"./caret-square-right.svg": [
		59553,
		[
			59553
		]
	],
	"./caret-square-up.svg": [
		86209,
		[
			86209
		]
	],
	"./caret-up.svg": [
		36590,
		[
			36590
		]
	],
	"./carpool.svg": [
		2061,
		[
			2061
		]
	],
	"./carriage-baby.svg": [
		6114,
		[
			6114
		]
	],
	"./carrot.svg": [
		21302,
		[
			21302
		]
	],
	"./cars.svg": [
		65770,
		[
			65770
		]
	],
	"./cart-arrow-down.svg": [
		42238,
		[
			42238
		]
	],
	"./cart-arrow-up.svg": [
		99253,
		[
			99253
		]
	],
	"./cart-circle-arrow-down.svg": [
		36703,
		[
			36703
		]
	],
	"./cart-circle-arrow-up.svg": [
		86160,
		[
			86160
		]
	],
	"./cart-circle-check.svg": [
		39377,
		[
			39377
		]
	],
	"./cart-circle-exclamation.svg": [
		5846,
		[
			5846
		]
	],
	"./cart-circle-plus.svg": [
		6971,
		[
			6971
		]
	],
	"./cart-circle-xmark.svg": [
		26586,
		[
			26586
		]
	],
	"./cart-flatbed-boxes.svg": [
		89012,
		[
			89012
		]
	],
	"./cart-flatbed-empty.svg": [
		17420,
		[
			17420
		]
	],
	"./cart-flatbed-suitcase.svg": [
		70574,
		[
			70574
		]
	],
	"./cart-flatbed.svg": [
		85528,
		[
			85528
		]
	],
	"./cart-minus.svg": [
		51926,
		[
			51926
		]
	],
	"./cart-plus.svg": [
		43774,
		[
			43774
		]
	],
	"./cart-shopping-fast.svg": [
		41709,
		[
			41709
		]
	],
	"./cart-shopping.svg": [
		17494,
		[
			17494
		]
	],
	"./cart-xmark.svg": [
		92969,
		[
			92969
		]
	],
	"./cash-register.svg": [
		54064,
		[
			54064
		]
	],
	"./cassette-betamax.svg": [
		15640,
		[
			15640
		]
	],
	"./cassette-tape.svg": [
		16020,
		[
			16020
		]
	],
	"./cassette-vhs.svg": [
		9241,
		[
			9241
		]
	],
	"./castle.svg": [
		85755,
		[
			85755
		]
	],
	"./cat-space.svg": [
		44576,
		[
			44576
		]
	],
	"./cat.svg": [
		36637,
		[
			36637
		]
	],
	"./cauldron.svg": [
		69569,
		[
			69569
		]
	],
	"./cctv.svg": [
		39819,
		[
			39819
		]
	],
	"./cedi-sign.svg": [
		19360,
		[
			19360
		]
	],
	"./cent-sign.svg": [
		37881,
		[
			37881
		]
	],
	"./certificate.svg": [
		77528,
		[
			77528
		]
	],
	"./chain-broken.svg": [
		42300,
		[
			42300
		]
	],
	"./chain-horizontal-slash.svg": [
		22027,
		[
			22027
		]
	],
	"./chain-horizontal.svg": [
		44623,
		[
			44623
		]
	],
	"./chain-slash.svg": [
		82602,
		[
			82602
		]
	],
	"./chain.svg": [
		80842,
		[
			80842
		]
	],
	"./chair-office.svg": [
		77555,
		[
			77555
		]
	],
	"./chair.svg": [
		37902,
		[
			37902
		]
	],
	"./chalkboard-teacher.svg": [
		9313,
		[
			9313
		]
	],
	"./chalkboard-user.svg": [
		46484,
		[
			46484
		]
	],
	"./chalkboard.svg": [
		3632,
		[
			3632
		]
	],
	"./champagne-glass.svg": [
		36696,
		[
			36696
		]
	],
	"./champagne-glasses.svg": [
		60508,
		[
			60508
		]
	],
	"./charging-station.svg": [
		36145,
		[
			36145
		]
	],
	"./chart-area.svg": [
		99293,
		[
			99293
		]
	],
	"./chart-bar.svg": [
		54633,
		[
			54633
		]
	],
	"./chart-bullet.svg": [
		64418,
		[
			64418
		]
	],
	"./chart-candlestick.svg": [
		46595,
		[
			46595
		]
	],
	"./chart-column.svg": [
		46904,
		[
			46904
		]
	],
	"./chart-diagram.svg": [
		28409,
		[
			28409
		]
	],
	"./chart-fft.svg": [
		58930,
		[
			58930
		]
	],
	"./chart-gantt.svg": [
		19180,
		[
			19180
		]
	],
	"./chart-kanban.svg": [
		79667,
		[
			79667
		]
	],
	"./chart-line-down.svg": [
		5865,
		[
			5865
		]
	],
	"./chart-line-up-down.svg": [
		14799,
		[
			14799
		]
	],
	"./chart-line-up.svg": [
		25062,
		[
			25062
		]
	],
	"./chart-line.svg": [
		88744,
		[
			88744
		]
	],
	"./chart-mixed-up-circle-currency.svg": [
		97520,
		[
			97520
		]
	],
	"./chart-mixed-up-circle-dollar.svg": [
		79863,
		[
			79863
		]
	],
	"./chart-mixed.svg": [
		42271,
		[
			42271
		]
	],
	"./chart-network.svg": [
		35720,
		[
			35720
		]
	],
	"./chart-pie-alt.svg": [
		16598,
		[
			16598
		]
	],
	"./chart-pie-simple-circle-currency.svg": [
		6424,
		[
			6424
		]
	],
	"./chart-pie-simple-circle-dollar.svg": [
		55791,
		[
			55791
		]
	],
	"./chart-pie-simple.svg": [
		46983,
		[
			46983
		]
	],
	"./chart-pie.svg": [
		34912,
		[
			34912
		]
	],
	"./chart-pyramid.svg": [
		37850,
		[
			37850
		]
	],
	"./chart-radar.svg": [
		60942,
		[
			60942
		]
	],
	"./chart-scatter-3d.svg": [
		68848,
		[
			68848
		]
	],
	"./chart-scatter-bubble.svg": [
		14671,
		[
			14671
		]
	],
	"./chart-scatter.svg": [
		65816,
		[
			65816
		]
	],
	"./chart-simple-horizontal.svg": [
		477,
		[
			477
		]
	],
	"./chart-simple.svg": [
		79944,
		[
			79944
		]
	],
	"./chart-sine.svg": [
		81957,
		[
			81957
		]
	],
	"./chart-tree-map.svg": [
		13095,
		[
			13095
		]
	],
	"./chart-user.svg": [
		65383,
		[
			65383
		]
	],
	"./chart-waterfall.svg": [
		63808,
		[
			63808
		]
	],
	"./check-circle.svg": [
		25546,
		[
			25546
		]
	],
	"./check-double.svg": [
		19529,
		[
			19529
		]
	],
	"./check-square.svg": [
		26927,
		[
			26927
		]
	],
	"./check-to-slot.svg": [
		73058,
		[
			73058
		]
	],
	"./check.svg": [
		81437,
		[
			81437
		]
	],
	"./cheese-swiss.svg": [
		79666,
		[
			79666
		]
	],
	"./cheese.svg": [
		6992,
		[
			6992
		]
	],
	"./cheeseburger.svg": [
		88783,
		[
			88783
		]
	],
	"./chemex.svg": [
		87715,
		[
			87715
		]
	],
	"./cherries.svg": [
		31172,
		[
			31172
		]
	],
	"./chess-bishop-alt.svg": [
		30779,
		[
			30779
		]
	],
	"./chess-bishop-piece.svg": [
		53004,
		[
			53004
		]
	],
	"./chess-bishop.svg": [
		32345,
		[
			32345
		]
	],
	"./chess-board.svg": [
		22386,
		[
			22386
		]
	],
	"./chess-clock-alt.svg": [
		24486,
		[
			24486
		]
	],
	"./chess-clock-flip.svg": [
		88180,
		[
			88180
		]
	],
	"./chess-clock.svg": [
		27824,
		[
			27824
		]
	],
	"./chess-king-alt.svg": [
		25533,
		[
			25533
		]
	],
	"./chess-king-piece.svg": [
		93834,
		[
			93834
		]
	],
	"./chess-king.svg": [
		69475,
		[
			69475
		]
	],
	"./chess-knight-alt.svg": [
		32911,
		[
			32911
		]
	],
	"./chess-knight-piece.svg": [
		22848,
		[
			22848
		]
	],
	"./chess-knight.svg": [
		99237,
		[
			99237
		]
	],
	"./chess-pawn-alt.svg": [
		99986,
		[
			99986
		]
	],
	"./chess-pawn-piece.svg": [
		63385,
		[
			63385
		]
	],
	"./chess-pawn.svg": [
		50676,
		[
			50676
		]
	],
	"./chess-queen-alt.svg": [
		6862,
		[
			6862
		]
	],
	"./chess-queen-piece.svg": [
		55189,
		[
			55189
		]
	],
	"./chess-queen.svg": [
		41464,
		[
			41464
		]
	],
	"./chess-rook-alt.svg": [
		61155,
		[
			61155
		]
	],
	"./chess-rook-piece.svg": [
		7764,
		[
			7764
		]
	],
	"./chess-rook.svg": [
		19201,
		[
			19201
		]
	],
	"./chess.svg": [
		65109,
		[
			65109
		]
	],
	"./chestnut.svg": [
		20251,
		[
			20251
		]
	],
	"./chevron-circle-down.svg": [
		59794,
		[
			59794
		]
	],
	"./chevron-circle-left.svg": [
		80025,
		[
			80025
		]
	],
	"./chevron-circle-right.svg": [
		12388,
		[
			12388
		]
	],
	"./chevron-circle-up.svg": [
		78241,
		[
			78241
		]
	],
	"./chevron-double-down.svg": [
		94151,
		[
			94151
		]
	],
	"./chevron-double-left.svg": [
		75384,
		[
			75384
		]
	],
	"./chevron-double-right.svg": [
		40871,
		[
			40871
		]
	],
	"./chevron-double-up.svg": [
		87736,
		[
			87736
		]
	],
	"./chevron-down.svg": [
		70969,
		[
			70969
		]
	],
	"./chevron-left.svg": [
		95586,
		[
			95586
		]
	],
	"./chevron-right.svg": [
		91641,
		[
			91641
		]
	],
	"./chevron-square-down.svg": [
		23161,
		[
			23161
		]
	],
	"./chevron-square-left.svg": [
		47778,
		[
			47778
		]
	],
	"./chevron-square-right.svg": [
		11865,
		[
			11865
		]
	],
	"./chevron-square-up.svg": [
		48374,
		[
			48374
		]
	],
	"./chevron-up.svg": [
		98902,
		[
			98902
		]
	],
	"./chevrons-down.svg": [
		51168,
		[
			51168
		]
	],
	"./chevrons-left.svg": [
		4911,
		[
			4911
		]
	],
	"./chevrons-right.svg": [
		24266,
		[
			24266
		]
	],
	"./chevrons-up.svg": [
		76947,
		[
			76947
		]
	],
	"./chf-sign.svg": [
		56318,
		[
			56318
		]
	],
	"./child-combatant.svg": [
		14971,
		[
			14971
		]
	],
	"./child-dress.svg": [
		85985,
		[
			85985
		]
	],
	"./child-reaching.svg": [
		2495,
		[
			2495
		]
	],
	"./child-rifle.svg": [
		46010,
		[
			46010
		]
	],
	"./child.svg": [
		35535,
		[
			35535
		]
	],
	"./children.svg": [
		64166,
		[
			64166
		]
	],
	"./chimney.svg": [
		14284,
		[
			14284
		]
	],
	"./chocolate-bar.svg": [
		78971,
		[
			78971
		]
	],
	"./chopsticks.svg": [
		85344,
		[
			85344
		]
	],
	"./church.svg": [
		10358,
		[
			10358
		]
	],
	"./circle-0.svg": [
		50204,
		[
			50204
		]
	],
	"./circle-1.svg": [
		78749,
		[
			78749
		]
	],
	"./circle-2.svg": [
		66654,
		[
			66654
		]
	],
	"./circle-3.svg": [
		29231,
		[
			29231
		]
	],
	"./circle-4.svg": [
		11760,
		[
			11760
		]
	],
	"./circle-5.svg": [
		10209,
		[
			10209
		]
	],
	"./circle-6.svg": [
		44818,
		[
			44818
		]
	],
	"./circle-7.svg": [
		77859,
		[
			240
		]
	],
	"./circle-8.svg": [
		20820,
		[
			20820
		]
	],
	"./circle-9.svg": [
		65749,
		[
			65749
		]
	],
	"./circle-a.svg": [
		77581,
		[
			77581
		]
	],
	"./circle-ampersand.svg": [
		94209,
		[
			94209
		]
	],
	"./circle-arrow-down-left.svg": [
		37166,
		[
			37166
		]
	],
	"./circle-arrow-down-right.svg": [
		23053,
		[
			23053
		]
	],
	"./circle-arrow-down.svg": [
		35300,
		[
			35300
		]
	],
	"./circle-arrow-left.svg": [
		47811,
		[
			47811
		]
	],
	"./circle-arrow-right.svg": [
		75353,
		[
			97734
		]
	],
	"./circle-arrow-up-left.svg": [
		59907,
		[
			59907
		]
	],
	"./circle-arrow-up-right.svg": [
		30278,
		[
			30278
		]
	],
	"./circle-arrow-up.svg": [
		6367,
		[
			6367
		]
	],
	"./circle-austral.svg": [
		49204,
		[
			49204
		]
	],
	"./circle-australian-dollar.svg": [
		4639,
		[
			4639
		]
	],
	"./circle-b.svg": [
		94606,
		[
			94606
		]
	],
	"./circle-baht.svg": [
		65919,
		[
			65919
		]
	],
	"./circle-bangladeshi-taka.svg": [
		3976,
		[
			3976
		]
	],
	"./circle-bitcoin.svg": [
		89838,
		[
			89838
		]
	],
	"./circle-bolt.svg": [
		50349,
		[
			50349
		]
	],
	"./circle-book-open.svg": [
		67180,
		[
			67180
		]
	],
	"./circle-bookmark.svg": [
		7132,
		[
			7132
		]
	],
	"./circle-brazilian-real.svg": [
		99427,
		[
			99427
		]
	],
	"./circle-c.svg": [
		9247,
		[
			9247
		]
	],
	"./circle-calendar.svg": [
		34038,
		[
			34038
		]
	],
	"./circle-camera.svg": [
		51073,
		[
			51073
		]
	],
	"./circle-caret-down.svg": [
		66422,
		[
			66422
		]
	],
	"./circle-caret-left.svg": [
		56605,
		[
			56605
		]
	],
	"./circle-caret-right.svg": [
		29856,
		[
			29856
		]
	],
	"./circle-caret-up.svg": [
		80813,
		[
			80813
		]
	],
	"./circle-cedi.svg": [
		49293,
		[
			49293
		]
	],
	"./circle-cent.svg": [
		97878,
		[
			97878
		]
	],
	"./circle-check.svg": [
		35564,
		[
			13183
		]
	],
	"./circle-chevron-down.svg": [
		62666,
		[
			62666
		]
	],
	"./circle-chevron-left.svg": [
		71489,
		[
			71489
		]
	],
	"./circle-chevron-right.svg": [
		86828,
		[
			86828
		]
	],
	"./circle-chevron-up.svg": [
		85177,
		[
			85177
		]
	],
	"./circle-chf.svg": [
		14241,
		[
			14241
		]
	],
	"./circle-colon.svg": [
		59517,
		[
			59517
		]
	],
	"./circle-cruzeiro.svg": [
		67729,
		[
			67729
		]
	],
	"./circle-currency.svg": [
		4501,
		[
			4501
		]
	],
	"./circle-d.svg": [
		8128,
		[
			8128
		]
	],
	"./circle-danish-krone.svg": [
		26157,
		[
			26157
		]
	],
	"./circle-dashed.svg": [
		95251,
		[
			95251
		]
	],
	"./circle-divide.svg": [
		55831,
		[
			55831
		]
	],
	"./circle-dollar-to-slot.svg": [
		55741,
		[
			55741
		]
	],
	"./circle-dollar.svg": [
		86638,
		[
			86638
		]
	],
	"./circle-dong.svg": [
		67494,
		[
			67494
		]
	],
	"./circle-dot.svg": [
		22409,
		[
			22409
		]
	],
	"./circle-down-left.svg": [
		14442,
		[
			14442
		]
	],
	"./circle-down-right.svg": [
		93441,
		[
			93441
		]
	],
	"./circle-down.svg": [
		89072,
		[
			89072
		]
	],
	"./circle-e.svg": [
		6161,
		[
			6161
		]
	],
	"./circle-ellipsis-vertical.svg": [
		70700,
		[
			70700
		]
	],
	"./circle-ellipsis.svg": [
		95037,
		[
			95037
		]
	],
	"./circle-envelope.svg": [
		52280,
		[
			52280
		]
	],
	"./circle-equals.svg": [
		25815,
		[
			25815
		]
	],
	"./circle-euro.svg": [
		37975,
		[
			37975
		]
	],
	"./circle-eurozone.svg": [
		88733,
		[
			11114
		]
	],
	"./circle-exclamation-check.svg": [
		88904,
		[
			88904
		]
	],
	"./circle-exclamation.svg": [
		91671,
		[
			91671
		]
	],
	"./circle-f.svg": [
		65410,
		[
			65410
		]
	],
	"./circle-florin.svg": [
		92592,
		[
			92592
		]
	],
	"./circle-franc.svg": [
		11128,
		[
			11128
		]
	],
	"./circle-g.svg": [
		52787,
		[
			52787
		]
	],
	"./circle-gf.svg": [
		21223,
		[
			21223
		]
	],
	"./circle-guarani.svg": [
		19717,
		[
			19717
		]
	],
	"./circle-h.svg": [
		89508,
		[
			89508
		]
	],
	"./circle-half-horizontal.svg": [
		11088,
		[
			11088
		]
	],
	"./circle-half-stroke-horizontal.svg": [
		15353,
		[
			15353
		]
	],
	"./circle-half-stroke.svg": [
		33580,
		[
			33580
		]
	],
	"./circle-half.svg": [
		6999,
		[
			6999
		]
	],
	"./circle-heart.svg": [
		23240,
		[
			23240
		]
	],
	"./circle-house.svg": [
		75832,
		[
			75832
		]
	],
	"./circle-hryvnia.svg": [
		80057,
		[
			80057
		]
	],
	"./circle-i.svg": [
		86757,
		[
			86757
		]
	],
	"./circle-indian-rupee.svg": [
		3045,
		[
			3045
		]
	],
	"./circle-info.svg": [
		73688,
		[
			73688
		]
	],
	"./circle-j.svg": [
		54982,
		[
			54982
		]
	],
	"./circle-k.svg": [
		43959,
		[
			43959
		]
	],
	"./circle-kip.svg": [
		23492,
		[
			23492
		]
	],
	"./circle-l.svg": [
		99032,
		[
			99032
		]
	],
	"./circle-lari.svg": [
		54658,
		[
			54658
		]
	],
	"./circle-left.svg": [
		49823,
		[
			49823
		]
	],
	"./circle-lira.svg": [
		21954,
		[
			21954
		]
	],
	"./circle-litecoin.svg": [
		99863,
		[
			22244
		]
	],
	"./circle-location-arrow.svg": [
		34805,
		[
			34805
		]
	],
	"./circle-m.svg": [
		24393,
		[
			24393
		]
	],
	"./circle-malaysian-ringgit.svg": [
		21376,
		[
			21376
		]
	],
	"./circle-manat.svg": [
		93231,
		[
			93231
		]
	],
	"./circle-microphone-lines.svg": [
		8978,
		[
			8978
		]
	],
	"./circle-microphone.svg": [
		48804,
		[
			48804
		]
	],
	"./circle-mill.svg": [
		64146,
		[
			64146
		]
	],
	"./circle-minus.svg": [
		71212,
		[
			71212
		]
	],
	"./circle-moon.svg": [
		62191,
		[
			62191
		]
	],
	"./circle-n.svg": [
		79578,
		[
			57197
		]
	],
	"./circle-naira.svg": [
		72123,
		[
			72123
		]
	],
	"./circle-nodes.svg": [
		69763,
		[
			69763
		]
	],
	"./circle-norwegian-krone.svg": [
		69770,
		[
			69770
		]
	],
	"./circle-notch.svg": [
		86362,
		[
			86362
		]
	],
	"./circle-o.svg": [
		57099,
		[
			57099
		]
	],
	"./circle-p.svg": [
		23356,
		[
			23356
		]
	],
	"./circle-parking.svg": [
		5324,
		[
			5324
		]
	],
	"./circle-pause.svg": [
		45546,
		[
			45546
		]
	],
	"./circle-peruvian-soles.svg": [
		13817,
		[
			13817
		]
	],
	"./circle-peseta.svg": [
		27192,
		[
			27192
		]
	],
	"./circle-peso.svg": [
		26639,
		[
			26639
		]
	],
	"./circle-phone-flip.svg": [
		37860,
		[
			37860
		]
	],
	"./circle-phone-hangup.svg": [
		64074,
		[
			64074
		]
	],
	"./circle-phone.svg": [
		41792,
		[
			41792
		]
	],
	"./circle-play.svg": [
		80650,
		[
			80650
		]
	],
	"./circle-plus.svg": [
		56164,
		[
			56164
		]
	],
	"./circle-polish-zloty.svg": [
		9712,
		[
			9712
		]
	],
	"./circle-q.svg": [
		35549,
		[
			35549
		]
	],
	"./circle-quarter-stroke.svg": [
		72365,
		[
			72365
		]
	],
	"./circle-quarter.svg": [
		49896,
		[
			49896
		]
	],
	"./circle-quarters.svg": [
		56667,
		[
			56667
		]
	],
	"./circle-question.svg": [
		25432,
		[
			25432
		]
	],
	"./circle-r.svg": [
		89278,
		[
			89278
		]
	],
	"./circle-radiation.svg": [
		19641,
		[
			19641
		]
	],
	"./circle-renminbi.svg": [
		66914,
		[
			66914
		]
	],
	"./circle-right.svg": [
		58458,
		[
			58458
		]
	],
	"./circle-ruble.svg": [
		72726,
		[
			72726
		]
	],
	"./circle-rupee.svg": [
		82667,
		[
			82667
		]
	],
	"./circle-rupiah.svg": [
		14817,
		[
			14817
		]
	],
	"./circle-s.svg": [
		9327,
		[
			9327
		]
	],
	"./circle-share-nodes.svg": [
		449,
		[
			449
		]
	],
	"./circle-shekel.svg": [
		29898,
		[
			29898
		]
	],
	"./circle-small.svg": [
		94569,
		[
			94569
		]
	],
	"./circle-sort-down.svg": [
		14049,
		[
			14049
		]
	],
	"./circle-sort-up.svg": [
		81374,
		[
			81374
		]
	],
	"./circle-sort.svg": [
		60416,
		[
			60416
		]
	],
	"./circle-star.svg": [
		79180,
		[
			79180
		]
	],
	"./circle-sterling.svg": [
		82596,
		[
			82596
		]
	],
	"./circle-stop.svg": [
		16044,
		[
			16044
		]
	],
	"./circle-swedish-krona.svg": [
		75185,
		[
			75185
		]
	],
	"./circle-t.svg": [
		15536,
		[
			15536
		]
	],
	"./circle-tenge.svg": [
		63225,
		[
			63225
		]
	],
	"./circle-three-quarters-stroke.svg": [
		51003,
		[
			51003
		]
	],
	"./circle-three-quarters.svg": [
		39738,
		[
			39738
		]
	],
	"./circle-trash.svg": [
		79642,
		[
			79642
		]
	],
	"./circle-tugrik.svg": [
		49414,
		[
			49414
		]
	],
	"./circle-turkish-lira.svg": [
		35211,
		[
			35211
		]
	],
	"./circle-u.svg": [
		6657,
		[
			6657
		]
	],
	"./circle-up-left.svg": [
		21495,
		[
			21495
		]
	],
	"./circle-up-right.svg": [
		86354,
		[
			86354
		]
	],
	"./circle-up.svg": [
		15971,
		[
			15971
		]
	],
	"./circle-user-circle-check.svg": [
		61969,
		[
			61969
		]
	],
	"./circle-user-circle-exclamation.svg": [
		13782,
		[
			13782
		]
	],
	"./circle-user-circle-minus.svg": [
		41545,
		[
			41545
		]
	],
	"./circle-user-circle-moon.svg": [
		23980,
		[
			23980
		]
	],
	"./circle-user-circle-plus.svg": [
		66811,
		[
			66811
		]
	],
	"./circle-user-circle-question.svg": [
		89459,
		[
			89459
		]
	],
	"./circle-user-circle-user.svg": [
		57197,
		[
			79578
		]
	],
	"./circle-user-circle-xmark.svg": [
		78458,
		[
			56077
		]
	],
	"./circle-user-clock.svg": [
		90256,
		[
			67875
		]
	],
	"./circle-user.svg": [
		81973,
		[
			81973
		]
	],
	"./circle-v.svg": [
		1618,
		[
			1618
		]
	],
	"./circle-video.svg": [
		22189,
		[
			22189
		]
	],
	"./circle-w.svg": [
		4931,
		[
			4931
		]
	],
	"./circle-waveform-lines.svg": [
		78487,
		[
			78487
		]
	],
	"./circle-wifi-circle-wifi.svg": [
		67406,
		[
			67406
		]
	],
	"./circle-wifi-group.svg": [
		18853,
		[
			18853
		]
	],
	"./circle-wifi.svg": [
		30235,
		[
			30235
		]
	],
	"./circle-won.svg": [
		41396,
		[
			41396
		]
	],
	"./circle-x.svg": [
		47892,
		[
			47892
		]
	],
	"./circle-xmark.svg": [
		53031,
		[
			53031
		]
	],
	"./circle-y.svg": [
		69525,
		[
			69525
		]
	],
	"./circle-yen.svg": [
		76376,
		[
			76376
		]
	],
	"./circle-z.svg": [
		49238,
		[
			49238
		]
	],
	"./circle.svg": [
		36987,
		[
			36987
		]
	],
	"./circleapore-dollar.svg": [
		34035,
		[
			34035
		]
	],
	"./circles-overlap-3.svg": [
		56416,
		[
			56416
		]
	],
	"./circles-overlap.svg": [
		52876,
		[
			30495
		]
	],
	"./citrus-slice.svg": [
		43244,
		[
			43244
		]
	],
	"./citrus.svg": [
		11701,
		[
			11701
		]
	],
	"./city.svg": [
		75702,
		[
			75702
		]
	],
	"./clapperboard-play.svg": [
		20337,
		[
			20337
		]
	],
	"./clapperboard.svg": [
		2166,
		[
			2166
		]
	],
	"./clarinet.svg": [
		13265,
		[
			13265
		]
	],
	"./claw-marks.svg": [
		93475,
		[
			93475
		]
	],
	"./clinic-medical.svg": [
		32389,
		[
			32389
		]
	],
	"./clipboard-check.svg": [
		28356,
		[
			28356
		]
	],
	"./clipboard-clock.svg": [
		92358,
		[
			92358
		]
	],
	"./clipboard-exclamation.svg": [
		25839,
		[
			25839
		]
	],
	"./clipboard-list-check.svg": [
		18951,
		[
			18951
		]
	],
	"./clipboard-list.svg": [
		38868,
		[
			38868
		]
	],
	"./clipboard-medical.svg": [
		51209,
		[
			51209
		]
	],
	"./clipboard-prescription.svg": [
		95284,
		[
			72903
		]
	],
	"./clipboard-question.svg": [
		82128,
		[
			82128
		]
	],
	"./clipboard-user.svg": [
		48733,
		[
			48733
		]
	],
	"./clipboard.svg": [
		81955,
		[
			81955
		]
	],
	"./clock-desk.svg": [
		13419,
		[
			13419
		]
	],
	"./clock-eight-thirty.svg": [
		89402,
		[
			89402
		]
	],
	"./clock-eight.svg": [
		88585,
		[
			88585
		]
	],
	"./clock-eleven-thirty.svg": [
		87600,
		[
			87600
		]
	],
	"./clock-eleven.svg": [
		66247,
		[
			66247
		]
	],
	"./clock-five-thirty.svg": [
		25249,
		[
			25249
		]
	],
	"./clock-five.svg": [
		47432,
		[
			47432
		]
	],
	"./clock-four-thirty.svg": [
		8093,
		[
			8093
		]
	],
	"./clock-four.svg": [
		10148,
		[
			10148
		]
	],
	"./clock-nine-thirty.svg": [
		88705,
		[
			88705
		]
	],
	"./clock-nine.svg": [
		9128,
		[
			9128
		]
	],
	"./clock-one-thirty.svg": [
		92389,
		[
			92389
		]
	],
	"./clock-one.svg": [
		36508,
		[
			36508
		]
	],
	"./clock-rotate-left.svg": [
		88441,
		[
			88441
		]
	],
	"./clock-seven-thirty.svg": [
		19939,
		[
			42320
		]
	],
	"./clock-seven.svg": [
		18631,
		[
			18631
		]
	],
	"./clock-six-thirty.svg": [
		89097,
		[
			89097
		]
	],
	"./clock-six.svg": [
		17088,
		[
			17088
		]
	],
	"./clock-ten-thirty.svg": [
		16502,
		[
			16502
		]
	],
	"./clock-ten.svg": [
		8581,
		[
			8581
		]
	],
	"./clock-three-thirty.svg": [
		56377,
		[
			56377
		]
	],
	"./clock-three.svg": [
		43248,
		[
			43248
		]
	],
	"./clock-twelve-thirty.svg": [
		46832,
		[
			46832
		]
	],
	"./clock-twelve.svg": [
		11079,
		[
			11079
		]
	],
	"./clock-two-thirty.svg": [
		80791,
		[
			80791
		]
	],
	"./clock-two.svg": [
		50302,
		[
			50302
		]
	],
	"./clock.svg": [
		54735,
		[
			54735
		]
	],
	"./clone-plus.svg": [
		34623,
		[
			34623
		]
	],
	"./clone.svg": [
		36758,
		[
			36758
		]
	],
	"./close.svg": [
		49961,
		[
			49961
		]
	],
	"./closed-captioning-slash.svg": [
		4490,
		[
			4490
		]
	],
	"./closed-captioning.svg": [
		38378,
		[
			38378
		]
	],
	"./clothes-hanger.svg": [
		51167,
		[
			51167
		]
	],
	"./cloud-arrow-down.svg": [
		80927,
		[
			80927
		]
	],
	"./cloud-arrow-up.svg": [
		16272,
		[
			16272
		]
	],
	"./cloud-binary.svg": [
		30176,
		[
			30176
		]
	],
	"./cloud-bolt-moon.svg": [
		21088,
		[
			21088
		]
	],
	"./cloud-bolt-sun.svg": [
		99963,
		[
			99963
		]
	],
	"./cloud-bolt.svg": [
		21606,
		[
			21606
		]
	],
	"./cloud-check.svg": [
		24753,
		[
			24753
		]
	],
	"./cloud-download-alt.svg": [
		61609,
		[
			61609
		]
	],
	"./cloud-download.svg": [
		62244,
		[
			62244
		]
	],
	"./cloud-drizzle.svg": [
		16931,
		[
			16931
		]
	],
	"./cloud-exclamation.svg": [
		43830,
		[
			21449
		]
	],
	"./cloud-fog.svg": [
		10025,
		[
			10025
		]
	],
	"./cloud-hail-mixed.svg": [
		75975,
		[
			75975
		]
	],
	"./cloud-hail.svg": [
		29865,
		[
			29865
		]
	],
	"./cloud-meatball.svg": [
		10901,
		[
			10901
		]
	],
	"./cloud-minus.svg": [
		68617,
		[
			68617
		]
	],
	"./cloud-moon-rain.svg": [
		87123,
		[
			87123
		]
	],
	"./cloud-moon.svg": [
		74124,
		[
			74124
		]
	],
	"./cloud-music.svg": [
		90872,
		[
			90872
		]
	],
	"./cloud-plus.svg": [
		5051,
		[
			5051
		]
	],
	"./cloud-question.svg": [
		81459,
		[
			81459
		]
	],
	"./cloud-rain.svg": [
		52053,
		[
			52053
		]
	],
	"./cloud-rainbow.svg": [
		81471,
		[
			81471
		]
	],
	"./cloud-showers-heavy.svg": [
		31314,
		[
			31314
		]
	],
	"./cloud-showers-water.svg": [
		82054,
		[
			82054
		]
	],
	"./cloud-showers.svg": [
		53204,
		[
			53204
		]
	],
	"./cloud-slash.svg": [
		59378,
		[
			59378
		]
	],
	"./cloud-sleet.svg": [
		91528,
		[
			91528
		]
	],
	"./cloud-snow.svg": [
		83842,
		[
			83842
		]
	],
	"./cloud-sun-rain.svg": [
		15938,
		[
			15938
		]
	],
	"./cloud-sun.svg": [
		3999,
		[
			3999
		]
	],
	"./cloud-upload-alt.svg": [
		78158,
		[
			78158
		]
	],
	"./cloud-upload.svg": [
		77304,
		[
			77304
		]
	],
	"./cloud-word.svg": [
		99563,
		[
			99563
		]
	],
	"./cloud-xmark.svg": [
		7386,
		[
			7386
		]
	],
	"./cloud.svg": [
		46306,
		[
			23925
		]
	],
	"./clouds-moon.svg": [
		70033,
		[
			70033
		]
	],
	"./clouds-sun.svg": [
		10112,
		[
			10112
		]
	],
	"./clouds.svg": [
		12029,
		[
			12029
		]
	],
	"./clover.svg": [
		7760,
		[
			7760
		]
	],
	"./club.svg": [
		41903,
		[
			41903
		]
	],
	"./cny.svg": [
		98861,
		[
			98861
		]
	],
	"./cocktail.svg": [
		75801,
		[
			75801
		]
	],
	"./coconut.svg": [
		15188,
		[
			15188
		]
	],
	"./code-branch.svg": [
		89209,
		[
			89209
		]
	],
	"./code-commit.svg": [
		35830,
		[
			35830
		]
	],
	"./code-compare.svg": [
		89694,
		[
			89694
		]
	],
	"./code-fork.svg": [
		78245,
		[
			78245
		]
	],
	"./code-merge.svg": [
		51659,
		[
			51659
		]
	],
	"./code-pull-request-closed.svg": [
		68005,
		[
			68005
		]
	],
	"./code-pull-request-draft.svg": [
		12538,
		[
			12538
		]
	],
	"./code-pull-request.svg": [
		31116,
		[
			31116
		]
	],
	"./code-simple.svg": [
		76939,
		[
			76939
		]
	],
	"./code.svg": [
		40412,
		[
			40412
		]
	],
	"./coffee-bean.svg": [
		94506,
		[
			94506
		]
	],
	"./coffee-beans.svg": [
		20949,
		[
			20949
		]
	],
	"./coffee-pot.svg": [
		40221,
		[
			40221
		]
	],
	"./coffee-togo.svg": [
		51401,
		[
			51401
		]
	],
	"./coffee.svg": [
		45443,
		[
			45443
		]
	],
	"./coffin-cross.svg": [
		30955,
		[
			30955
		]
	],
	"./coffin.svg": [
		31388,
		[
			31388
		]
	],
	"./cog.svg": [
		22168,
		[
			22168
		]
	],
	"./cogs.svg": [
		32075,
		[
			32075
		]
	],
	"./coin-blank.svg": [
		66677,
		[
			66677
		]
	],
	"./coin-front.svg": [
		1814,
		[
			1814
		]
	],
	"./coin-vertical.svg": [
		18199,
		[
			18199
		]
	],
	"./coin.svg": [
		10836,
		[
			10836
		]
	],
	"./coins.svg": [
		34719,
		[
			34719
		]
	],
	"./colon-sign.svg": [
		10930,
		[
			10930
		]
	],
	"./colon.svg": [
		49476,
		[
			49476
		]
	],
	"./columns-3.svg": [
		77384,
		[
			77384
		]
	],
	"./columns.svg": [
		54244,
		[
			54244
		]
	],
	"./comet.svg": [
		59141,
		[
			59141
		]
	],
	"./comma.svg": [
		93155,
		[
			93155
		]
	],
	"./command.svg": [
		72566,
		[
			72566
		]
	],
	"./comment-alt-arrow-down.svg": [
		58341,
		[
			58341
		]
	],
	"./comment-alt-arrow-up.svg": [
		71498,
		[
			71498
		]
	],
	"./comment-alt-captions.svg": [
		86076,
		[
			86076
		]
	],
	"./comment-alt-check.svg": [
		47443,
		[
			47443
		]
	],
	"./comment-alt-dollar.svg": [
		57675,
		[
			57675
		]
	],
	"./comment-alt-dots.svg": [
		70961,
		[
			70961
		]
	],
	"./comment-alt-edit.svg": [
		83001,
		[
			83001
		]
	],
	"./comment-alt-exclamation.svg": [
		11368,
		[
			11368
		]
	],
	"./comment-alt-image.svg": [
		88588,
		[
			88588
		]
	],
	"./comment-alt-lines.svg": [
		35422,
		[
			29393
		]
	],
	"./comment-alt-medical.svg": [
		40890,
		[
			40890
		]
	],
	"./comment-alt-minus.svg": [
		54983,
		[
			54983
		]
	],
	"./comment-alt-music.svg": [
		16998,
		[
			16998
		]
	],
	"./comment-alt-plus.svg": [
		36041,
		[
			36041
		]
	],
	"./comment-alt-quote.svg": [
		97307,
		[
			97307
		]
	],
	"./comment-alt-slash.svg": [
		90040,
		[
			90040
		]
	],
	"./comment-alt-smile.svg": [
		20659,
		[
			20659
		]
	],
	"./comment-alt-text.svg": [
		12816,
		[
			12816
		]
	],
	"./comment-alt-times.svg": [
		37085,
		[
			37085
		]
	],
	"./comment-alt.svg": [
		24544,
		[
			24544
		]
	],
	"./comment-arrow-down.svg": [
		8287,
		[
			8287
		]
	],
	"./comment-arrow-up-right.svg": [
		65569,
		[
			65569
		]
	],
	"./comment-arrow-up.svg": [
		58736,
		[
			58736
		]
	],
	"./comment-captions.svg": [
		84674,
		[
			84674
		]
	],
	"./comment-check.svg": [
		70513,
		[
			70513
		]
	],
	"./comment-code.svg": [
		50136,
		[
			50136
		]
	],
	"./comment-dollar.svg": [
		96425,
		[
			96425
		]
	],
	"./comment-dot.svg": [
		61980,
		[
			61980
		]
	],
	"./comment-dots.svg": [
		52567,
		[
			52567
		]
	],
	"./comment-edit.svg": [
		83327,
		[
			83327
		]
	],
	"./comment-exclamation.svg": [
		32406,
		[
			32406
		]
	],
	"./comment-heart.svg": [
		83221,
		[
			83221
		]
	],
	"./comment-image.svg": [
		98242,
		[
			98242
		]
	],
	"./comment-lines.svg": [
		30696,
		[
			30696
		]
	],
	"./comment-medical.svg": [
		59808,
		[
			59808
		]
	],
	"./comment-middle-alt.svg": [
		30650,
		[
			30650
		]
	],
	"./comment-middle-top-alt.svg": [
		24972,
		[
			24972
		]
	],
	"./comment-middle-top.svg": [
		8502,
		[
			8502
		]
	],
	"./comment-middle.svg": [
		25660,
		[
			25660
		]
	],
	"./comment-minus.svg": [
		585,
		[
			585
		]
	],
	"./comment-music.svg": [
		11480,
		[
			11480
		]
	],
	"./comment-nodes.svg": [
		8282,
		[
			8282
		]
	],
	"./comment-pen.svg": [
		7908,
		[
			7908
		]
	],
	"./comment-plus.svg": [
		30619,
		[
			30619
		]
	],
	"./comment-question.svg": [
		76371,
		[
			76371
		]
	],
	"./comment-quote.svg": [
		49849,
		[
			49849
		]
	],
	"./comment-slash.svg": [
		79186,
		[
			79186
		]
	],
	"./comment-smile.svg": [
		40265,
		[
			40265
		]
	],
	"./comment-sms.svg": [
		63330,
		[
			63330
		]
	],
	"./comment-text.svg": [
		3998,
		[
			3998
		]
	],
	"./comment-times.svg": [
		91323,
		[
			91323
		]
	],
	"./comment-waveform.svg": [
		44634,
		[
			22253
		]
	],
	"./comment-xmark.svg": [
		84826,
		[
			84826
		]
	],
	"./comment.svg": [
		41890,
		[
			41890
		]
	],
	"./commenting.svg": [
		18726,
		[
			18726
		]
	],
	"./comments-alt-dollar.svg": [
		31754,
		[
			31754
		]
	],
	"./comments-alt.svg": [
		21127,
		[
			21127
		]
	],
	"./comments-dollar.svg": [
		32580,
		[
			32580
		]
	],
	"./comments-question-check.svg": [
		64910,
		[
			64910
		]
	],
	"./comments-question.svg": [
		53522,
		[
			53522
		]
	],
	"./comments.svg": [
		59549,
		[
			59549
		]
	],
	"./compact-disc.svg": [
		99848,
		[
			99848
		]
	],
	"./compass-drafting.svg": [
		25665,
		[
			25665
		]
	],
	"./compass-slash.svg": [
		42593,
		[
			42593
		]
	],
	"./compass.svg": [
		73893,
		[
			73893
		]
	],
	"./compress-alt.svg": [
		56977,
		[
			56977
		]
	],
	"./compress-arrows-alt.svg": [
		64352,
		[
			64352
		]
	],
	"./compress-arrows.svg": [
		63362,
		[
			63362
		]
	],
	"./compress-wide.svg": [
		32421,
		[
			32421
		]
	],
	"./compress.svg": [
		67199,
		[
			67199
		]
	],
	"./computer-classic.svg": [
		83795,
		[
			83795
		]
	],
	"./computer-mouse-button-left.svg": [
		37447,
		[
			37447
		]
	],
	"./computer-mouse-button-right.svg": [
		80034,
		[
			80034
		]
	],
	"./computer-mouse-scrollwheel.svg": [
		9033,
		[
			9033
		]
	],
	"./computer-mouse.svg": [
		69902,
		[
			69902
		]
	],
	"./computer-speaker.svg": [
		77980,
		[
			77980
		]
	],
	"./computer.svg": [
		56528,
		[
			56528
		]
	],
	"./concierge-bell.svg": [
		74658,
		[
			74658
		]
	],
	"./construction.svg": [
		63380,
		[
			63380
		]
	],
	"./contact-book.svg": [
		82469,
		[
			82469
		]
	],
	"./contact-card.svg": [
		89704,
		[
			89704
		]
	],
	"./container-storage.svg": [
		78604,
		[
			78604
		]
	],
	"./conveyor-belt-alt.svg": [
		92212,
		[
			92212
		]
	],
	"./conveyor-belt-arm.svg": [
		40935,
		[
			40935
		]
	],
	"./conveyor-belt-boxes.svg": [
		21142,
		[
			21142
		]
	],
	"./conveyor-belt-empty.svg": [
		57586,
		[
			57586
		]
	],
	"./conveyor-belt.svg": [
		42910,
		[
			42910
		]
	],
	"./cookie-bite.svg": [
		94612,
		[
			94612
		]
	],
	"./cookie.svg": [
		76805,
		[
			76805
		]
	],
	"./copy.svg": [
		63836,
		[
			63836
		]
	],
	"./copyright.svg": [
		36194,
		[
			36194
		]
	],
	"./corn.svg": [
		46057,
		[
			46057
		]
	],
	"./corner.svg": [
		75848,
		[
			75848
		]
	],
	"./couch-small.svg": [
		2629,
		[
			2629
		]
	],
	"./couch.svg": [
		29575,
		[
			29575
		]
	],
	"./court-sport.svg": [
		32341,
		[
			32341
		]
	],
	"./cow.svg": [
		16840,
		[
			16840
		]
	],
	"./cowbell-circle-plus.svg": [
		3217,
		[
			3217
		]
	],
	"./cowbell-more.svg": [
		9831,
		[
			9831
		]
	],
	"./cowbell.svg": [
		44283,
		[
			44283
		]
	],
	"./crab.svg": [
		93241,
		[
			93241
		]
	],
	"./crate-apple.svg": [
		37871,
		[
			37871
		]
	],
	"./crate-empty.svg": [
		32124,
		[
			32124
		]
	],
	"./credit-card-alt.svg": [
		27569,
		[
			27569
		]
	],
	"./credit-card-blank.svg": [
		67018,
		[
			67018
		]
	],
	"./credit-card-front.svg": [
		50269,
		[
			50269
		]
	],
	"./credit-card.svg": [
		58079,
		[
			58079
		]
	],
	"./creemee.svg": [
		97209,
		[
			97209
		]
	],
	"./cricket-bat-ball.svg": [
		27836,
		[
			27836
		]
	],
	"./cricket.svg": [
		61208,
		[
			61208
		]
	],
	"./croissant.svg": [
		50033,
		[
			50033
		]
	],
	"./crop-alt.svg": [
		89207,
		[
			89207
		]
	],
	"./crop-simple.svg": [
		64972,
		[
			64972
		]
	],
	"./crop.svg": [
		68781,
		[
			68781
		]
	],
	"./cross.svg": [
		61041,
		[
			61041
		]
	],
	"./crosshairs-simple.svg": [
		94447,
		[
			94447
		]
	],
	"./crosshairs.svg": [
		80952,
		[
			80952
		]
	],
	"./crow.svg": [
		94114,
		[
			94114
		]
	],
	"./crown.svg": [
		10104,
		[
			10104
		]
	],
	"./crutch.svg": [
		24974,
		[
			24974
		]
	],
	"./crutches.svg": [
		65134,
		[
			65134
		]
	],
	"./cruzeiro-sign.svg": [
		35936,
		[
			35936
		]
	],
	"./crystal-ball.svg": [
		66739,
		[
			66739
		]
	],
	"./cube.svg": [
		67064,
		[
			67064
		]
	],
	"./cubes-stacked.svg": [
		24359,
		[
			24359
		]
	],
	"./cubes.svg": [
		50027,
		[
			50027
		]
	],
	"./cucumber.svg": [
		61499,
		[
			61499
		]
	],
	"./cup-straw-swoosh.svg": [
		68073,
		[
			68073
		]
	],
	"./cup-straw.svg": [
		9199,
		[
			9199
		]
	],
	"./cup-togo.svg": [
		48547,
		[
			48547
		]
	],
	"./cupcake.svg": [
		8017,
		[
			8017
		]
	],
	"./curling-stone.svg": [
		16151,
		[
			16151
		]
	],
	"./curling.svg": [
		61007,
		[
			61007
		]
	],
	"./currency-sign.svg": [
		53704,
		[
			53704
		]
	],
	"./custard.svg": [
		61253,
		[
			61253
		]
	],
	"./cut.svg": [
		83657,
		[
			83657
		]
	],
	"./cutlery.svg": [
		77687,
		[
			77687
		]
	],
	"./d.svg": [
		22329,
		[
			22329
		]
	],
	"./dagger.svg": [
		77809,
		[
			77809
		]
	],
	"./danish-krone-sign.svg": [
		13508,
		[
			13508
		]
	],
	"./dash.svg": [
		78199,
		[
			78199
		]
	],
	"./dashboard.svg": [
		8801,
		[
			8801
		]
	],
	"./database.svg": [
		20560,
		[
			20560
		]
	],
	"./deaf.svg": [
		24671,
		[
			24671
		]
	],
	"./deafness.svg": [
		37798,
		[
			37798
		]
	],
	"./debug.svg": [
		53152,
		[
			53152
		]
	],
	"./dedent.svg": [
		95173,
		[
			17554
		]
	],
	"./deer-rudolph.svg": [
		23748,
		[
			23748
		]
	],
	"./deer.svg": [
		55335,
		[
			55335
		]
	],
	"./delete-left.svg": [
		24360,
		[
			24360
		]
	],
	"./delete-right.svg": [
		69271,
		[
			69271
		]
	],
	"./democrat.svg": [
		20518,
		[
			20518
		]
	],
	"./desktop-alt.svg": [
		42843,
		[
			42843
		]
	],
	"./desktop-arrow-down.svg": [
		810,
		[
			810
		]
	],
	"./desktop-code.svg": [
		66493,
		[
			66493
		]
	],
	"./desktop-medical.svg": [
		81931,
		[
			81931
		]
	],
	"./desktop-slash.svg": [
		20485,
		[
			20485
		]
	],
	"./desktop.svg": [
		7705,
		[
			7705
		]
	],
	"./dewpoint.svg": [
		97821,
		[
			97821
		]
	],
	"./dharmachakra.svg": [
		46817,
		[
			69198
		]
	],
	"./diagnoses.svg": [
		16702,
		[
			16702
		]
	],
	"./diagram-cells.svg": [
		90114,
		[
			90114
		]
	],
	"./diagram-lean-canvas.svg": [
		29560,
		[
			29560
		]
	],
	"./diagram-nested.svg": [
		36210,
		[
			36210
		]
	],
	"./diagram-next.svg": [
		23652,
		[
			23652
		]
	],
	"./diagram-predecessor.svg": [
		25510,
		[
			25510
		]
	],
	"./diagram-previous.svg": [
		95196,
		[
			72815
		]
	],
	"./diagram-project.svg": [
		43758,
		[
			43758
		]
	],
	"./diagram-sankey.svg": [
		49680,
		[
			49680
		]
	],
	"./diagram-subtask.svg": [
		85384,
		[
			85384
		]
	],
	"./diagram-successor.svg": [
		47179,
		[
			47179
		]
	],
	"./diagram-venn.svg": [
		64788,
		[
			64788
		]
	],
	"./dial-high.svg": [
		85302,
		[
			85302
		]
	],
	"./dial-low.svg": [
		78872,
		[
			78872
		]
	],
	"./dial-max.svg": [
		40868,
		[
			40868
		]
	],
	"./dial-med-high.svg": [
		26581,
		[
			26581
		]
	],
	"./dial-med-low.svg": [
		11337,
		[
			11337
		]
	],
	"./dial-med.svg": [
		66436,
		[
			66436
		]
	],
	"./dial-min.svg": [
		5202,
		[
			5202
		]
	],
	"./dial-off.svg": [
		58637,
		[
			58637
		]
	],
	"./dial.svg": [
		91385,
		[
			91385
		]
	],
	"./dialpad.svg": [
		15932,
		[
			15932
		]
	],
	"./diamond-exclamation.svg": [
		58117,
		[
			58117
		]
	],
	"./diamond-half-stroke.svg": [
		27602,
		[
			27602
		]
	],
	"./diamond-half.svg": [
		57809,
		[
			57809
		]
	],
	"./diamond-turn-right.svg": [
		65950,
		[
			65950
		]
	],
	"./diamond.svg": [
		8925,
		[
			8925
		]
	],
	"./diamonds-4.svg": [
		39255,
		[
			39255
		]
	],
	"./dice-d10.svg": [
		64802,
		[
			64802
		]
	],
	"./dice-d12.svg": [
		65568,
		[
			65568
		]
	],
	"./dice-d20.svg": [
		55287,
		[
			55287
		]
	],
	"./dice-d4.svg": [
		81523,
		[
			81523
		]
	],
	"./dice-d6.svg": [
		73425,
		[
			73425
		]
	],
	"./dice-d8.svg": [
		86103,
		[
			86103
		]
	],
	"./dice-five.svg": [
		88091,
		[
			88091
		]
	],
	"./dice-four.svg": [
		97547,
		[
			97547
		]
	],
	"./dice-one.svg": [
		88993,
		[
			88993
		]
	],
	"./dice-six.svg": [
		22197,
		[
			22197
		]
	],
	"./dice-three.svg": [
		41189,
		[
			41189
		]
	],
	"./dice-two.svg": [
		15175,
		[
			15175
		]
	],
	"./dice.svg": [
		85901,
		[
			85901
		]
	],
	"./digging.svg": [
		65356,
		[
			65356
		]
	],
	"./digital-tachograph.svg": [
		12759,
		[
			12759
		]
	],
	"./dinosaur.svg": [
		73118,
		[
			73118
		]
	],
	"./diploma.svg": [
		72031,
		[
			72031
		]
	],
	"./direction-left-right.svg": [
		19721,
		[
			19721
		]
	],
	"./direction-up-down.svg": [
		86761,
		[
			86761
		]
	],
	"./directions.svg": [
		34321,
		[
			34321
		]
	],
	"./disc-drive.svg": [
		60203,
		[
			60203
		]
	],
	"./disease.svg": [
		21079,
		[
			21079
		]
	],
	"./display-arrow-down.svg": [
		58824,
		[
			58824
		]
	],
	"./display-chart-up-circle-currency.svg": [
		8141,
		[
			8141
		]
	],
	"./display-chart-up-circle-dollar.svg": [
		59958,
		[
			59958
		]
	],
	"./display-chart-up.svg": [
		57846,
		[
			57846
		]
	],
	"./display-code.svg": [
		35663,
		[
			35663
		]
	],
	"./display-medical.svg": [
		18517,
		[
			18517
		]
	],
	"./display-slash.svg": [
		24403,
		[
			24403
		]
	],
	"./display.svg": [
		38759,
		[
			38759
		]
	],
	"./distribute-spacing-horizontal.svg": [
		70459,
		[
			70459
		]
	],
	"./distribute-spacing-vertical.svg": [
		54913,
		[
			54913
		]
	],
	"./ditto.svg": [
		29305,
		[
			29305
		]
	],
	"./divide.svg": [
		41576,
		[
			41576
		]
	],
	"./dizzy.svg": [
		42771,
		[
			42771
		]
	],
	"./dna.svg": [
		22873,
		[
			45254
		]
	],
	"./do-not-enter.svg": [
		43645,
		[
			43645
		]
	],
	"./dog-leashed.svg": [
		42392,
		[
			42392
		]
	],
	"./dog.svg": [
		87931,
		[
			87931
		]
	],
	"./dollar-circle.svg": [
		14946,
		[
			14946
		]
	],
	"./dollar-sign.svg": [
		53353,
		[
			53353
		]
	],
	"./dollar-square.svg": [
		25927,
		[
			25927
		]
	],
	"./dollar.svg": [
		19893,
		[
			19893
		]
	],
	"./dolly-box.svg": [
		94185,
		[
			94185
		]
	],
	"./dolly-empty.svg": [
		8769,
		[
			8769
		]
	],
	"./dolly-flatbed-alt.svg": [
		17278,
		[
			17278
		]
	],
	"./dolly-flatbed-empty.svg": [
		8796,
		[
			8796
		]
	],
	"./dolly-flatbed.svg": [
		22888,
		[
			22888
		]
	],
	"./dolly.svg": [
		68677,
		[
			68677
		]
	],
	"./dolphin.svg": [
		74885,
		[
			74885
		]
	],
	"./donate.svg": [
		97374,
		[
			97374
		]
	],
	"./dong-sign.svg": [
		94533,
		[
			94533
		]
	],
	"./donut.svg": [
		14053,
		[
			14053
		]
	],
	"./door-closed.svg": [
		88308,
		[
			88308
		]
	],
	"./door-open.svg": [
		56932,
		[
			56932
		]
	],
	"./dot-circle.svg": [
		35685,
		[
			35685
		]
	],
	"./dot.svg": [
		58872,
		[
			58872
		]
	],
	"./doughnut.svg": [
		37997,
		[
			37997
		]
	],
	"./dove.svg": [
		43611,
		[
			43611
		]
	],
	"./down-from-bracket.svg": [
		83219,
		[
			83219
		]
	],
	"./down-from-dotted-line.svg": [
		77592,
		[
			77592
		]
	],
	"./down-from-line.svg": [
		39183,
		[
			39183
		]
	],
	"./down-left-and-up-right-to-center.svg": [
		54106,
		[
			54106
		]
	],
	"./down-left.svg": [
		36635,
		[
			36635
		]
	],
	"./down-long-to-line.svg": [
		34407,
		[
			34407
		]
	],
	"./down-long.svg": [
		14554,
		[
			14554
		]
	],
	"./down-right.svg": [
		79422,
		[
			79422
		]
	],
	"./down-to-bracket.svg": [
		30704,
		[
			30704
		]
	],
	"./down-to-dotted-line.svg": [
		70035,
		[
			70035
		]
	],
	"./down-to-line.svg": [
		70826,
		[
			70826
		]
	],
	"./down-up.svg": [
		39495,
		[
			39495
		]
	],
	"./down.svg": [
		87911,
		[
			87911
		]
	],
	"./download.svg": [
		61675,
		[
			61675
		]
	],
	"./drafting-compass.svg": [
		2491,
		[
			2491
		]
	],
	"./dragon.svg": [
		21650,
		[
			21650
		]
	],
	"./draw-circle.svg": [
		43878,
		[
			43878
		]
	],
	"./draw-polygon.svg": [
		34068,
		[
			34068
		]
	],
	"./draw-square.svg": [
		38619,
		[
			38619
		]
	],
	"./dreidel.svg": [
		27450,
		[
			27450
		]
	],
	"./dress.svg": [
		68984,
		[
			68984
		]
	],
	"./drivers-license.svg": [
		40206,
		[
			40206
		]
	],
	"./drone-alt.svg": [
		53357,
		[
			53357
		]
	],
	"./drone-front.svg": [
		6409,
		[
			6409
		]
	],
	"./drone.svg": [
		31571,
		[
			31571
		]
	],
	"./droplet-degree.svg": [
		55348,
		[
			55348
		]
	],
	"./droplet-percent.svg": [
		28748,
		[
			28748
		]
	],
	"./droplet-plus.svg": [
		54924,
		[
			54924
		]
	],
	"./droplet-slash.svg": [
		37407,
		[
			37407
		]
	],
	"./droplet.svg": [
		83571,
		[
			83571
		]
	],
	"./drum-steelpan.svg": [
		68770,
		[
			68770
		]
	],
	"./drum.svg": [
		58415,
		[
			58415
		]
	],
	"./drumstick-bite.svg": [
		99412,
		[
			99412
		]
	],
	"./drumstick.svg": [
		5765,
		[
			5765
		]
	],
	"./dryer-alt.svg": [
		34133,
		[
			34133
		]
	],
	"./dryer-heat.svg": [
		82978,
		[
			82978
		]
	],
	"./dryer.svg": [
		88123,
		[
			88123
		]
	],
	"./duck.svg": [
		80320,
		[
			80320
		]
	],
	"./dumbbell.svg": [
		49784,
		[
			49784
		]
	],
	"./dumpster-fire.svg": [
		57998,
		[
			57998
		]
	],
	"./dumpster.svg": [
		83301,
		[
			83301
		]
	],
	"./dungeon.svg": [
		65343,
		[
			65343
		]
	],
	"./e.svg": [
		56936,
		[
			56936
		]
	],
	"./ear-circle-checkmark.svg": [
		50910,
		[
			50910
		]
	],
	"./ear-deaf.svg": [
		76714,
		[
			76714
		]
	],
	"./ear-listen.svg": [
		14935,
		[
			14935
		]
	],
	"./ear-muffs.svg": [
		77695,
		[
			77695
		]
	],
	"./ear-triangle-exclamation.svg": [
		56562,
		[
			56562
		]
	],
	"./ear-waveform.svg": [
		99467,
		[
			99467
		]
	],
	"./ear.svg": [
		68825,
		[
			68825
		]
	],
	"./earth-africa.svg": [
		49360,
		[
			49360
		]
	],
	"./earth-america.svg": [
		17026,
		[
			17026
		]
	],
	"./earth-americas.svg": [
		58717,
		[
			58717
		]
	],
	"./earth-asia.svg": [
		9872,
		[
			9872
		]
	],
	"./earth-europe.svg": [
		8768,
		[
			8768
		]
	],
	"./earth-oceania.svg": [
		17070,
		[
			17070
		]
	],
	"./earth.svg": [
		9053,
		[
			9053
		]
	],
	"./eclipse-alt.svg": [
		62112,
		[
			62112
		]
	],
	"./eclipse.svg": [
		23010,
		[
			23010
		]
	],
	"./edit.svg": [
		93299,
		[
			93299
		]
	],
	"./egg-fried.svg": [
		57143,
		[
			57143
		]
	],
	"./egg.svg": [
		96106,
		[
			96106
		]
	],
	"./eggplant.svg": [
		5521,
		[
			5521
		]
	],
	"./eject.svg": [
		13386,
		[
			13386
		]
	],
	"./elephant.svg": [
		83372,
		[
			83372
		]
	],
	"./elevator.svg": [
		85533,
		[
			85533
		]
	],
	"./ellipsis-h-alt.svg": [
		5567,
		[
			5567
		]
	],
	"./ellipsis-h.svg": [
		53301,
		[
			53301
		]
	],
	"./ellipsis-stroke-vertical.svg": [
		54494,
		[
			54494
		]
	],
	"./ellipsis-stroke.svg": [
		79871,
		[
			79871
		]
	],
	"./ellipsis-v-alt.svg": [
		90061,
		[
			90061
		]
	],
	"./ellipsis-v.svg": [
		20211,
		[
			20211
		]
	],
	"./ellipsis-vertical.svg": [
		3465,
		[
			3465
		]
	],
	"./ellipsis.svg": [
		73558,
		[
			73558
		]
	],
	"./empty-set.svg": [
		4341,
		[
			4341
		]
	],
	"./engine-exclamation.svg": [
		42945,
		[
			42945
		]
	],
	"./engine-warning.svg": [
		1669,
		[
			24050
		]
	],
	"./engine.svg": [
		46017,
		[
			46017
		]
	],
	"./envelope-badge.svg": [
		40489,
		[
			40489
		]
	],
	"./envelope-certificate.svg": [
		91413,
		[
			91413
		]
	],
	"./envelope-circle-check.svg": [
		15015,
		[
			15015
		]
	],
	"./envelope-circle-user.svg": [
		34776,
		[
			34776
		]
	],
	"./envelope-circle.svg": [
		82324,
		[
			82324
		]
	],
	"./envelope-dot.svg": [
		22229,
		[
			22229
		]
	],
	"./envelope-open-dollar.svg": [
		96883,
		[
			96883
		]
	],
	"./envelope-open-text.svg": [
		50936,
		[
			50936
		]
	],
	"./envelope-open.svg": [
		38840,
		[
			38840
		]
	],
	"./envelope-ribbon.svg": [
		82792,
		[
			82792
		]
	],
	"./envelope-square.svg": [
		63485,
		[
			63485
		]
	],
	"./envelope.svg": [
		4695,
		[
			4695
		]
	],
	"./envelopes-bulk.svg": [
		34215,
		[
			34215
		]
	],
	"./envelopes.svg": [
		76934,
		[
			76934
		]
	],
	"./equals.svg": [
		72860,
		[
			72860
		]
	],
	"./eraser.svg": [
		43895,
		[
			43895
		]
	],
	"./escalator.svg": [
		4609,
		[
			4609
		]
	],
	"./ethernet.svg": [
		31586,
		[
			31586
		]
	],
	"./eur.svg": [
		68701,
		[
			68701
		]
	],
	"./euro-sign.svg": [
		4142,
		[
			4142
		]
	],
	"./euro.svg": [
		97824,
		[
			97824
		]
	],
	"./eurozone-sign.svg": [
		76832,
		[
			76832
		]
	],
	"./excavator.svg": [
		71970,
		[
			71970
		]
	],
	"./exchange-alt.svg": [
		80222,
		[
			80222
		]
	],
	"./exchange.svg": [
		45544,
		[
			45544
		]
	],
	"./exclamation-circle.svg": [
		26823,
		[
			26823
		]
	],
	"./exclamation-square.svg": [
		93334,
		[
			93334
		]
	],
	"./exclamation-triangle.svg": [
		77275,
		[
			77275
		]
	],
	"./exclamation.svg": [
		84058,
		[
			84058
		]
	],
	"./expand-alt.svg": [
		14381,
		[
			14381
		]
	],
	"./expand-arrows-alt.svg": [
		92092,
		[
			92092
		]
	],
	"./expand-arrows.svg": [
		23910,
		[
			23910
		]
	],
	"./expand-wide.svg": [
		19505,
		[
			19505
		]
	],
	"./expand.svg": [
		13811,
		[
			13811
		]
	],
	"./exploding-head.svg": [
		96810,
		[
			96810
		]
	],
	"./explosion.svg": [
		14824,
		[
			14824
		]
	],
	"./external-link-alt.svg": [
		22853,
		[
			22853
		]
	],
	"./external-link-square-alt.svg": [
		22483,
		[
			22483
		]
	],
	"./external-link-square.svg": [
		23313,
		[
			23313
		]
	],
	"./external-link.svg": [
		1867,
		[
			1867
		]
	],
	"./eye-dropper-empty.svg": [
		50213,
		[
			50213
		]
	],
	"./eye-dropper-full.svg": [
		88617,
		[
			88617
		]
	],
	"./eye-dropper-half.svg": [
		38125,
		[
			38125
		]
	],
	"./eye-dropper.svg": [
		265,
		[
			265
		]
	],
	"./eye-evil.svg": [
		12061,
		[
			12061
		]
	],
	"./eye-low-vision.svg": [
		23244,
		[
			23244
		]
	],
	"./eye-slash.svg": [
		26046,
		[
			26046
		]
	],
	"./eye.svg": [
		75406,
		[
			75406
		]
	],
	"./eyedropper.svg": [
		85826,
		[
			85826
		]
	],
	"./eyes.svg": [
		13777,
		[
			13777
		]
	],
	"./f.svg": [
		38299,
		[
			38299
		]
	],
	"./face-angry-horns.svg": [
		97545,
		[
			97545
		]
	],
	"./face-angry.svg": [
		57284,
		[
			57284
		]
	],
	"./face-anguished.svg": [
		13515,
		[
			13515
		]
	],
	"./face-anxious-sweat.svg": [
		14803,
		[
			14803
		]
	],
	"./face-astonished.svg": [
		86247,
		[
			86247
		]
	],
	"./face-awesome.svg": [
		73726,
		[
			73726
		]
	],
	"./face-beam-hand-over-mouth.svg": [
		1979,
		[
			1979
		]
	],
	"./face-clouds.svg": [
		73347,
		[
			73347
		]
	],
	"./face-confounded.svg": [
		83766,
		[
			83766
		]
	],
	"./face-confused.svg": [
		74688,
		[
			74688
		]
	],
	"./face-cowboy-hat.svg": [
		46432,
		[
			46432
		]
	],
	"./face-diagonal-mouth.svg": [
		13870,
		[
			13870
		]
	],
	"./face-disappointed.svg": [
		36897,
		[
			36897
		]
	],
	"./face-disguise.svg": [
		15884,
		[
			15884
		]
	],
	"./face-dizzy.svg": [
		41633,
		[
			41633
		]
	],
	"./face-dotted.svg": [
		91477,
		[
			91477
		]
	],
	"./face-downcast-sweat.svg": [
		41915,
		[
			41915
		]
	],
	"./face-drooling.svg": [
		10150,
		[
			87769
		]
	],
	"./face-exhaling.svg": [
		55115,
		[
			55115
		]
	],
	"./face-explode.svg": [
		33676,
		[
			33676
		]
	],
	"./face-expressionless.svg": [
		10384,
		[
			10384
		]
	],
	"./face-eyes-xmarks.svg": [
		66514,
		[
			66514
		]
	],
	"./face-fearful.svg": [
		3336,
		[
			3336
		]
	],
	"./face-flushed.svg": [
		94970,
		[
			94970
		]
	],
	"./face-frown-open.svg": [
		22116,
		[
			22116
		]
	],
	"./face-frown-slight.svg": [
		58061,
		[
			58061
		]
	],
	"./face-frown.svg": [
		52219,
		[
			52219
		]
	],
	"./face-glasses.svg": [
		53671,
		[
			53671
		]
	],
	"./face-grimace.svg": [
		5729,
		[
			5729
		]
	],
	"./face-grin-beam-sweat.svg": [
		1918,
		[
			1918
		]
	],
	"./face-grin-beam.svg": [
		86653,
		[
			86653
		]
	],
	"./face-grin-hearts.svg": [
		88903,
		[
			88903
		]
	],
	"./face-grin-squint-tears.svg": [
		63972,
		[
			63972
		]
	],
	"./face-grin-squint.svg": [
		44888,
		[
			44888
		]
	],
	"./face-grin-stars.svg": [
		34707,
		[
			34707
		]
	],
	"./face-grin-tears.svg": [
		71023,
		[
			71023
		]
	],
	"./face-grin-tongue-squint.svg": [
		49633,
		[
			49633
		]
	],
	"./face-grin-tongue-wink.svg": [
		10640,
		[
			10640
		]
	],
	"./face-grin-tongue.svg": [
		9364,
		[
			9364
		]
	],
	"./face-grin-wide.svg": [
		46349,
		[
			46349
		]
	],
	"./face-grin-wink.svg": [
		22973,
		[
			22973
		]
	],
	"./face-grin.svg": [
		30615,
		[
			30615
		]
	],
	"./face-hand-over-mouth.svg": [
		5483,
		[
			5483
		]
	],
	"./face-hand-peeking.svg": [
		21366,
		[
			21366
		]
	],
	"./face-hand-yawn.svg": [
		37270,
		[
			37270
		]
	],
	"./face-head-bandage.svg": [
		20142,
		[
			20142
		]
	],
	"./face-holding-back-tears.svg": [
		27598,
		[
			27598
		]
	],
	"./face-hushed.svg": [
		44690,
		[
			44690
		]
	],
	"./face-icicles.svg": [
		11099,
		[
			11099
		]
	],
	"./face-kiss-beam.svg": [
		977,
		[
			977
		]
	],
	"./face-kiss-closed-eyes.svg": [
		63183,
		[
			63183
		]
	],
	"./face-kiss-wink-heart.svg": [
		15018,
		[
			15018
		]
	],
	"./face-kiss.svg": [
		11051,
		[
			11051
		]
	],
	"./face-laugh-beam.svg": [
		76948,
		[
			76948
		]
	],
	"./face-laugh-squint.svg": [
		55345,
		[
			55345
		]
	],
	"./face-laugh-wink.svg": [
		7040,
		[
			7040
		]
	],
	"./face-laugh.svg": [
		26468,
		[
			26468
		]
	],
	"./face-lying.svg": [
		75476,
		[
			53095
		]
	],
	"./face-mask.svg": [
		23101,
		[
			23101
		]
	],
	"./face-meh-blank.svg": [
		47532,
		[
			47532
		]
	],
	"./face-meh.svg": [
		47973,
		[
			47973
		]
	],
	"./face-melting.svg": [
		47953,
		[
			47953
		]
	],
	"./face-monocle.svg": [
		42302,
		[
			42302
		]
	],
	"./face-nauseated.svg": [
		38443,
		[
			38443
		]
	],
	"./face-nose-steam.svg": [
		30891,
		[
			30891
		]
	],
	"./face-party.svg": [
		53847,
		[
			53847
		]
	],
	"./face-pensive.svg": [
		97145,
		[
			97145
		]
	],
	"./face-persevering.svg": [
		99199,
		[
			99199
		]
	],
	"./face-pleading.svg": [
		91455,
		[
			91455
		]
	],
	"./face-pouting.svg": [
		20679,
		[
			20679
		]
	],
	"./face-raised-eyebrow.svg": [
		35851,
		[
			35851
		]
	],
	"./face-relieved.svg": [
		83357,
		[
			83357
		]
	],
	"./face-rolling-eyes.svg": [
		14751,
		[
			14751
		]
	],
	"./face-sad-cry.svg": [
		98584,
		[
			98584
		]
	],
	"./face-sad-sweat.svg": [
		25904,
		[
			25904
		]
	],
	"./face-sad-tear.svg": [
		69812,
		[
			69812
		]
	],
	"./face-saluting.svg": [
		85852,
		[
			85852
		]
	],
	"./face-scream.svg": [
		56498,
		[
			56498
		]
	],
	"./face-shaking-horizontal.svg": [
		2677,
		[
			2677
		]
	],
	"./face-shaking-vertical.svg": [
		50499,
		[
			50499
		]
	],
	"./face-shaking.svg": [
		24496,
		[
			24496
		]
	],
	"./face-shush.svg": [
		9828,
		[
			9828
		]
	],
	"./face-sleeping.svg": [
		78702,
		[
			78702
		]
	],
	"./face-sleepy.svg": [
		31423,
		[
			31423
		]
	],
	"./face-smile-beam.svg": [
		24013,
		[
			24013
		]
	],
	"./face-smile-halo.svg": [
		81290,
		[
			81290
		]
	],
	"./face-smile-hearts.svg": [
		29527,
		[
			29527
		]
	],
	"./face-smile-horns.svg": [
		71362,
		[
			71362
		]
	],
	"./face-smile-plus.svg": [
		17504,
		[
			17504
		]
	],
	"./face-smile-relaxed.svg": [
		31413,
		[
			31413
		]
	],
	"./face-smile-tear.svg": [
		35732,
		[
			35732
		]
	],
	"./face-smile-tongue.svg": [
		75396,
		[
			75396
		]
	],
	"./face-smile-upside-down.svg": [
		55083,
		[
			55083
		]
	],
	"./face-smile-wink.svg": [
		30445,
		[
			30445
		]
	],
	"./face-smile.svg": [
		9127,
		[
			9127
		]
	],
	"./face-smiling-hands.svg": [
		56788,
		[
			56788
		]
	],
	"./face-smirking.svg": [
		75997,
		[
			75997
		]
	],
	"./face-spiral-eyes.svg": [
		86461,
		[
			86461
		]
	],
	"./face-sunglasses.svg": [
		68679,
		[
			68679
		]
	],
	"./face-surprise.svg": [
		60520,
		[
			60520
		]
	],
	"./face-swear.svg": [
		70329,
		[
			70329
		]
	],
	"./face-thermometer.svg": [
		25711,
		[
			25711
		]
	],
	"./face-thinking.svg": [
		51505,
		[
			51505
		]
	],
	"./face-tired.svg": [
		72921,
		[
			72921
		]
	],
	"./face-tissue.svg": [
		57016,
		[
			57016
		]
	],
	"./face-tongue-money.svg": [
		8234,
		[
			8234
		]
	],
	"./face-tongue-sweat.svg": [
		46406,
		[
			46406
		]
	],
	"./face-unamused.svg": [
		94053,
		[
			94053
		]
	],
	"./face-viewfinder.svg": [
		14142,
		[
			14142
		]
	],
	"./face-vomit.svg": [
		28574,
		[
			6193
		]
	],
	"./face-weary.svg": [
		6109,
		[
			6109
		]
	],
	"./face-woozy.svg": [
		10169,
		[
			10169
		]
	],
	"./face-worried.svg": [
		89475,
		[
			89475
		]
	],
	"./face-zany.svg": [
		89505,
		[
			89505
		]
	],
	"./face-zipper.svg": [
		47939,
		[
			47939
		]
	],
	"./falafel.svg": [
		55902,
		[
			55902
		]
	],
	"./family-dress.svg": [
		14933,
		[
			14933
		]
	],
	"./family-pants.svg": [
		6262,
		[
			6262
		]
	],
	"./family.svg": [
		61819,
		[
			61819
		]
	],
	"./fan-table.svg": [
		58669,
		[
			58669
		]
	],
	"./fan.svg": [
		48422,
		[
			48422
		]
	],
	"./farm.svg": [
		75707,
		[
			75707
		]
	],
	"./fast-backward.svg": [
		80361,
		[
			80361
		]
	],
	"./fast-forward.svg": [
		95374,
		[
			95374
		]
	],
	"./faucet-drip.svg": [
		18593,
		[
			18593
		]
	],
	"./faucet.svg": [
		75487,
		[
			75487
		]
	],
	"./fax.svg": [
		3496,
		[
			3496
		]
	],
	"./feather-alt.svg": [
		79894,
		[
			79894
		]
	],
	"./feather-pointed.svg": [
		78826,
		[
			78826
		]
	],
	"./feather.svg": [
		31488,
		[
			31488
		]
	],
	"./feed.svg": [
		52855,
		[
			52855
		]
	],
	"./female.svg": [
		10443,
		[
			10443
		]
	],
	"./fence.svg": [
		58922,
		[
			58922
		]
	],
	"./ferris-wheel.svg": [
		24778,
		[
			24778
		]
	],
	"./ferry.svg": [
		15185,
		[
			15185
		]
	],
	"./field-hockey-stick-ball.svg": [
		96476,
		[
			96476
		]
	],
	"./field-hockey.svg": [
		67665,
		[
			67665
		]
	],
	"./fighter-jet.svg": [
		6292,
		[
			6292
		]
	],
	"./file-aiff.svg": [
		59628,
		[
			59628
		]
	],
	"./file-alt.svg": [
		26971,
		[
			26971
		]
	],
	"./file-archive.svg": [
		53336,
		[
			8574
		]
	],
	"./file-arrow-down.svg": [
		78218,
		[
			78218
		]
	],
	"./file-arrow-up.svg": [
		26649,
		[
			26649
		]
	],
	"./file-audio.svg": [
		89004,
		[
			89004
		]
	],
	"./file-award.svg": [
		71893,
		[
			71893
		]
	],
	"./file-ban.svg": [
		67349,
		[
			67349
		]
	],
	"./file-binary.svg": [
		37393,
		[
			37393
		]
	],
	"./file-brackets-curly.svg": [
		67525,
		[
			67525
		]
	],
	"./file-cad.svg": [
		36946,
		[
			36946
		]
	],
	"./file-caret-down.svg": [
		14700,
		[
			14700
		]
	],
	"./file-caret-up.svg": [
		56295,
		[
			56295
		]
	],
	"./file-certificate.svg": [
		35431,
		[
			35431
		]
	],
	"./file-chart-column.svg": [
		67097,
		[
			67097
		]
	],
	"./file-chart-line.svg": [
		4649,
		[
			4649
		]
	],
	"./file-chart-pie.svg": [
		1131,
		[
			1131
		]
	],
	"./file-check.svg": [
		51710,
		[
			51710
		]
	],
	"./file-circle-check.svg": [
		64549,
		[
			64549
		]
	],
	"./file-circle-exclamation.svg": [
		35938,
		[
			35938
		]
	],
	"./file-circle-info.svg": [
		59247,
		[
			59247
		]
	],
	"./file-circle-minus.svg": [
		30989,
		[
			30989
		]
	],
	"./file-circle-plus.svg": [
		66591,
		[
			66591
		]
	],
	"./file-circle-question.svg": [
		41519,
		[
			41519
		]
	],
	"./file-circle-xmark.svg": [
		66878,
		[
			66878
		]
	],
	"./file-clipboard.svg": [
		82812,
		[
			82812
		]
	],
	"./file-code.svg": [
		6877,
		[
			6877
		]
	],
	"./file-contract.svg": [
		62384,
		[
			62384
		]
	],
	"./file-csv.svg": [
		11070,
		[
			11070
		]
	],
	"./file-dashed-line.svg": [
		73128,
		[
			73128
		]
	],
	"./file-doc.svg": [
		58380,
		[
			58380
		]
	],
	"./file-download.svg": [
		3950,
		[
			3950
		]
	],
	"./file-edit.svg": [
		56106,
		[
			56106
		]
	],
	"./file-eps.svg": [
		72628,
		[
			72628
		]
	],
	"./file-excel.svg": [
		91167,
		[
			91167
		]
	],
	"./file-exclamation.svg": [
		49545,
		[
			49545
		]
	],
	"./file-export.svg": [
		4672,
		[
			4672
		]
	],
	"./file-fragment.svg": [
		93086,
		[
			93086
		]
	],
	"./file-gif.svg": [
		64364,
		[
			64364
		]
	],
	"./file-half-dashed.svg": [
		19917,
		[
			19917
		]
	],
	"./file-heart.svg": [
		52002,
		[
			52002
		]
	],
	"./file-image.svg": [
		54485,
		[
			54485
		]
	],
	"./file-import.svg": [
		26989,
		[
			26989
		]
	],
	"./file-invoice-dollar.svg": [
		64894,
		[
			64894
		]
	],
	"./file-invoice.svg": [
		78539,
		[
			78539
		]
	],
	"./file-jpg.svg": [
		53415,
		[
			53415
		]
	],
	"./file-lines.svg": [
		57235,
		[
			57235
		]
	],
	"./file-lock.svg": [
		52295,
		[
			52295
		]
	],
	"./file-magnifying-glass.svg": [
		99354,
		[
			99354
		]
	],
	"./file-medical-alt.svg": [
		12197,
		[
			12197
		]
	],
	"./file-medical.svg": [
		73227,
		[
			73227
		]
	],
	"./file-midi.svg": [
		56433,
		[
			56433
		]
	],
	"./file-minus.svg": [
		24922,
		[
			24922
		]
	],
	"./file-mov.svg": [
		54912,
		[
			54912
		]
	],
	"./file-mp3.svg": [
		75980,
		[
			75980
		]
	],
	"./file-mp4.svg": [
		32723,
		[
			32723
		]
	],
	"./file-music.svg": [
		93899,
		[
			93899
		]
	],
	"./file-odf.svg": [
		55575,
		[
			55575
		]
	],
	"./file-pdf.svg": [
		45808,
		[
			23427
		]
	],
	"./file-pen.svg": [
		7423,
		[
			7423
		]
	],
	"./file-plus-minus.svg": [
		22169,
		[
			22169
		]
	],
	"./file-plus.svg": [
		36178,
		[
			36178
		]
	],
	"./file-png.svg": [
		82359,
		[
			82359
		]
	],
	"./file-powerpoint.svg": [
		25209,
		[
			25209
		]
	],
	"./file-ppt.svg": [
		36398,
		[
			36398
		]
	],
	"./file-prescription.svg": [
		6598,
		[
			6598
		]
	],
	"./file-search.svg": [
		7238,
		[
			7238
		]
	],
	"./file-shield.svg": [
		22221,
		[
			22221
		]
	],
	"./file-signature.svg": [
		3848,
		[
			3848
		]
	],
	"./file-slash.svg": [
		18725,
		[
			18725
		]
	],
	"./file-spreadsheet.svg": [
		3148,
		[
			3148
		]
	],
	"./file-svg.svg": [
		80984,
		[
			80984
		]
	],
	"./file-tex.svg": [
		58965,
		[
			58965
		]
	],
	"./file-text.svg": [
		2755,
		[
			2755
		]
	],
	"./file-times.svg": [
		6032,
		[
			6032
		]
	],
	"./file-upload.svg": [
		74501,
		[
			74501
		]
	],
	"./file-user.svg": [
		94783,
		[
			94783
		]
	],
	"./file-vector.svg": [
		4259,
		[
			4259
		]
	],
	"./file-video.svg": [
		5955,
		[
			5955
		]
	],
	"./file-wav.svg": [
		58516,
		[
			58516
		]
	],
	"./file-waveform.svg": [
		57387,
		[
			57387
		]
	],
	"./file-word.svg": [
		51666,
		[
			51666
		]
	],
	"./file-xls.svg": [
		41149,
		[
			41149
		]
	],
	"./file-xmark.svg": [
		46669,
		[
			46669
		]
	],
	"./file-xml.svg": [
		11114,
		[
			88733
		]
	],
	"./file-zip.svg": [
		10899,
		[
			10899
		]
	],
	"./file-zipper.svg": [
		18184,
		[
			18184
		]
	],
	"./file.svg": [
		81337,
		[
			81337
		]
	],
	"./files-medical.svg": [
		41874,
		[
			41874
		]
	],
	"./files.svg": [
		17080,
		[
			17080
		]
	],
	"./fill-drip.svg": [
		87784,
		[
			87784
		]
	],
	"./fill.svg": [
		90800,
		[
			90800
		]
	],
	"./film-alt.svg": [
		21251,
		[
			21251
		]
	],
	"./film-canister.svg": [
		89457,
		[
			89457
		]
	],
	"./film-cannister.svg": [
		61715,
		[
			61715
		]
	],
	"./film-music.svg": [
		57955,
		[
			57955
		]
	],
	"./film-simple.svg": [
		49608,
		[
			49608
		]
	],
	"./film-slash.svg": [
		30941,
		[
			30941
		]
	],
	"./film-stack.svg": [
		35094,
		[
			35094
		]
	],
	"./film.svg": [
		81921,
		[
			81921
		]
	],
	"./films.svg": [
		74544,
		[
			74544
		]
	],
	"./filter-circle-dollar.svg": [
		58529,
		[
			58529
		]
	],
	"./filter-circle-xmark.svg": [
		71330,
		[
			71330
		]
	],
	"./filter-list.svg": [
		29966,
		[
			29966
		]
	],
	"./filter-slash.svg": [
		16553,
		[
			16553
		]
	],
	"./filter.svg": [
		11293,
		[
			11293
		]
	],
	"./filters.svg": [
		46228,
		[
			46228
		]
	],
	"./fingerprint.svg": [
		2689,
		[
			2689
		]
	],
	"./fire-alt.svg": [
		9717,
		[
			9717
		]
	],
	"./fire-burner.svg": [
		39702,
		[
			39702
		]
	],
	"./fire-extinguisher.svg": [
		16601,
		[
			16601
		]
	],
	"./fire-flame-curved.svg": [
		80117,
		[
			80117
		]
	],
	"./fire-flame-simple.svg": [
		27404,
		[
			27404
		]
	],
	"./fire-flame.svg": [
		83117,
		[
			83117
		]
	],
	"./fire-hydrant.svg": [
		40262,
		[
			40262
		]
	],
	"./fire-smoke.svg": [
		48055,
		[
			48055
		]
	],
	"./fire.svg": [
		94619,
		[
			94619
		]
	],
	"./fireplace.svg": [
		29552,
		[
			29552
		]
	],
	"./firewall.svg": [
		26515,
		[
			26515
		]
	],
	"./first-aid.svg": [
		54342,
		[
			54342
		]
	],
	"./fish-bones.svg": [
		62223,
		[
			62223
		]
	],
	"./fish-cooked.svg": [
		82701,
		[
			82701
		]
	],
	"./fish-fins.svg": [
		24752,
		[
			24752
		]
	],
	"./fish.svg": [
		15705,
		[
			15705
		]
	],
	"./fishing-rod.svg": [
		4887,
		[
			4887
		]
	],
	"./fist-raised.svg": [
		85446,
		[
			85446
		]
	],
	"./flag-alt.svg": [
		21015,
		[
			21015
		]
	],
	"./flag-checkered.svg": [
		8574,
		[
			53336
		]
	],
	"./flag-pennant.svg": [
		37130,
		[
			37130
		]
	],
	"./flag-swallowtail.svg": [
		16781,
		[
			16781
		]
	],
	"./flag-usa.svg": [
		26343,
		[
			26343
		]
	],
	"./flag.svg": [
		78605,
		[
			78605
		]
	],
	"./flame.svg": [
		71176,
		[
			71176
		]
	],
	"./flashlight.svg": [
		40249,
		[
			40249
		]
	],
	"./flask-gear.svg": [
		32736,
		[
			32736
		]
	],
	"./flask-poison.svg": [
		67873,
		[
			67873
		]
	],
	"./flask-potion.svg": [
		94744,
		[
			94744
		]
	],
	"./flask-round-poison.svg": [
		70712,
		[
			70712
		]
	],
	"./flask-round-potion.svg": [
		96477,
		[
			96477
		]
	],
	"./flask-vial.svg": [
		91206,
		[
			91206
		]
	],
	"./flask.svg": [
		94296,
		[
			94296
		]
	],
	"./flatbread-stuffed.svg": [
		89814,
		[
			89814
		]
	],
	"./flatbread.svg": [
		97236,
		[
			97236
		]
	],
	"./floppy-disk-circle-arrow-right.svg": [
		83847,
		[
			83847
		]
	],
	"./floppy-disk-circle-xmark.svg": [
		60642,
		[
			60642
		]
	],
	"./floppy-disk-pen.svg": [
		80459,
		[
			80459
		]
	],
	"./floppy-disk-times.svg": [
		67460,
		[
			67460
		]
	],
	"./floppy-disk.svg": [
		82717,
		[
			82717
		]
	],
	"./floppy-disks.svg": [
		81684,
		[
			81684
		]
	],
	"./florin-sign.svg": [
		42671,
		[
			42671
		]
	],
	"./flower-daffodil.svg": [
		73176,
		[
			73176
		]
	],
	"./flower-tulip.svg": [
		5501,
		[
			5501
		]
	],
	"./flower.svg": [
		92442,
		[
			70061
		]
	],
	"./flushed.svg": [
		62572,
		[
			62572
		]
	],
	"./flute.svg": [
		99107,
		[
			99107
		]
	],
	"./flux-capacitor.svg": [
		23829,
		[
			23829
		]
	],
	"./flying-disc.svg": [
		57472,
		[
			57472
		]
	],
	"./fog.svg": [
		60869,
		[
			60869
		]
	],
	"./folder-arrow-down.svg": [
		33328,
		[
			33328
		]
	],
	"./folder-arrow-left.svg": [
		64799,
		[
			64799
		]
	],
	"./folder-arrow-right.svg": [
		35514,
		[
			35514
		]
	],
	"./folder-arrow-up.svg": [
		19811,
		[
			19811
		]
	],
	"./folder-blank.svg": [
		98426,
		[
			98426
		]
	],
	"./folder-bookmark.svg": [
		30872,
		[
			30872
		]
	],
	"./folder-check.svg": [
		1776,
		[
			1776
		]
	],
	"./folder-closed.svg": [
		1224,
		[
			1224
		]
	],
	"./folder-cog.svg": [
		10485,
		[
			10485
		]
	],
	"./folder-download.svg": [
		11736,
		[
			11736
		]
	],
	"./folder-gear.svg": [
		34553,
		[
			34553
		]
	],
	"./folder-grid.svg": [
		94344,
		[
			94344
		]
	],
	"./folder-heart.svg": [
		5892,
		[
			5892
		]
	],
	"./folder-image.svg": [
		2767,
		[
			2767
		]
	],
	"./folder-magnifying-glass.svg": [
		96380,
		[
			96380
		]
	],
	"./folder-medical.svg": [
		91421,
		[
			91421
		]
	],
	"./folder-minus.svg": [
		28944,
		[
			28944
		]
	],
	"./folder-music.svg": [
		54457,
		[
			54457
		]
	],
	"./folder-open.svg": [
		66512,
		[
			66512
		]
	],
	"./folder-plus.svg": [
		43640,
		[
			43640
		]
	],
	"./folder-search.svg": [
		25396,
		[
			25396
		]
	],
	"./folder-times.svg": [
		23730,
		[
			23730
		]
	],
	"./folder-tree.svg": [
		66480,
		[
			66480
		]
	],
	"./folder-upload.svg": [
		24371,
		[
			24371
		]
	],
	"./folder-user.svg": [
		45641,
		[
			45641
		]
	],
	"./folder-xmark.svg": [
		63051,
		[
			63051
		]
	],
	"./folder.svg": [
		92751,
		[
			92751
		]
	],
	"./folders.svg": [
		33262,
		[
			33262
		]
	],
	"./fondue-pot.svg": [
		72976,
		[
			72976
		]
	],
	"./font-awesome-flag.svg": [
		30921,
		[
			30921
		]
	],
	"./font-awesome-logo-full.svg": [
		1816,
		[
			1816
		]
	],
	"./font-awesome.svg": [
		62050,
		[
			62050
		]
	],
	"./font-case.svg": [
		49857,
		[
			49857
		]
	],
	"./font.svg": [
		89896,
		[
			89896
		]
	],
	"./foot-wing.svg": [
		48501,
		[
			48501
		]
	],
	"./football-ball.svg": [
		64102,
		[
			64102
		]
	],
	"./football-helmet.svg": [
		66238,
		[
			66238
		]
	],
	"./football.svg": [
		44912,
		[
			44912
		]
	],
	"./fork-knife.svg": [
		46599,
		[
			46599
		]
	],
	"./fork.svg": [
		76403,
		[
			76403
		]
	],
	"./forklift.svg": [
		63896,
		[
			63896
		]
	],
	"./fort.svg": [
		61620,
		[
			61620
		]
	],
	"./forward-fast.svg": [
		41477,
		[
			41477
		]
	],
	"./forward-step.svg": [
		74917,
		[
			74917
		]
	],
	"./forward.svg": [
		84782,
		[
			84782
		]
	],
	"./fragile.svg": [
		76781,
		[
			76781
		]
	],
	"./frame.svg": [
		74714,
		[
			74714
		]
	],
	"./franc-sign.svg": [
		25877,
		[
			25877
		]
	],
	"./french-fries.svg": [
		64137,
		[
			64137
		]
	],
	"./frog.svg": [
		85149,
		[
			85149
		]
	],
	"./frosty-head.svg": [
		1275,
		[
			1275
		]
	],
	"./frown-open.svg": [
		71406,
		[
			71406
		]
	],
	"./frown.svg": [
		13601,
		[
			13601
		]
	],
	"./function.svg": [
		81275,
		[
			81275
		]
	],
	"./funnel-dollar.svg": [
		72910,
		[
			72910
		]
	],
	"./futbol-ball.svg": [
		98175,
		[
			98175
		]
	],
	"./futbol.svg": [
		63175,
		[
			63175
		]
	],
	"./g.svg": [
		96330,
		[
			96330
		]
	],
	"./galaxy.svg": [
		98675,
		[
			98675
		]
	],
	"./gallery-thumbnails.svg": [
		95503,
		[
			95503
		]
	],
	"./game-board-alt.svg": [
		14456,
		[
			14456
		]
	],
	"./game-board-simple.svg": [
		11193,
		[
			11193
		]
	],
	"./game-board.svg": [
		96282,
		[
			96282
		]
	],
	"./game-console-handheld-crank.svg": [
		92565,
		[
			92565
		]
	],
	"./game-console-handheld.svg": [
		8916,
		[
			8916
		]
	],
	"./gamepad-alt.svg": [
		84790,
		[
			84790
		]
	],
	"./gamepad-modern.svg": [
		51320,
		[
			51320
		]
	],
	"./gamepad.svg": [
		21248,
		[
			21248
		]
	],
	"./garage-car.svg": [
		48777,
		[
			48777
		]
	],
	"./garage-empty.svg": [
		1064,
		[
			1064
		]
	],
	"./garage-open.svg": [
		43205,
		[
			43205
		]
	],
	"./garage.svg": [
		55204,
		[
			32823
		]
	],
	"./garlic.svg": [
		75381,
		[
			75381
		]
	],
	"./gas-pump-left.svg": [
		43437,
		[
			43437
		]
	],
	"./gas-pump-right.svg": [
		5072,
		[
			5072
		]
	],
	"./gas-pump-slash.svg": [
		83253,
		[
			83253
		]
	],
	"./gas-pump.svg": [
		88137,
		[
			88137
		]
	],
	"./gauge-circle-bolt.svg": [
		82691,
		[
			82691
		]
	],
	"./gauge-circle-minus.svg": [
		65190,
		[
			65190
		]
	],
	"./gauge-circle-plus.svg": [
		22542,
		[
			22542
		]
	],
	"./gauge-high.svg": [
		94593,
		[
			94593
		]
	],
	"./gauge-low.svg": [
		48157,
		[
			48157
		]
	],
	"./gauge-max.svg": [
		33941,
		[
			33941
		]
	],
	"./gauge-med.svg": [
		96213,
		[
			96213
		]
	],
	"./gauge-min.svg": [
		83971,
		[
			83971
		]
	],
	"./gauge-simple-high.svg": [
		84036,
		[
			84036
		]
	],
	"./gauge-simple-low.svg": [
		9126,
		[
			9126
		]
	],
	"./gauge-simple-max.svg": [
		49986,
		[
			49986
		]
	],
	"./gauge-simple-med.svg": [
		39418,
		[
			39418
		]
	],
	"./gauge-simple-min.svg": [
		21892,
		[
			21892
		]
	],
	"./gauge-simple.svg": [
		85807,
		[
			85807
		]
	],
	"./gauge.svg": [
		10040,
		[
			10040
		]
	],
	"./gave-dandy.svg": [
		49415,
		[
			49415
		]
	],
	"./gavel.svg": [
		11312,
		[
			11312
		]
	],
	"./gbp.svg": [
		88764,
		[
			88764
		]
	],
	"./gear-code.svg": [
		80664,
		[
			80664
		]
	],
	"./gear-complex-code.svg": [
		37069,
		[
			37069
		]
	],
	"./gear-complex.svg": [
		3433,
		[
			3433
		]
	],
	"./gear.svg": [
		67714,
		[
			67714
		]
	],
	"./gears.svg": [
		58333,
		[
			58333
		]
	],
	"./gem.svg": [
		22676,
		[
			22676
		]
	],
	"./genderless.svg": [
		91547,
		[
			91547
		]
	],
	"./ghost.svg": [
		43320,
		[
			43320
		]
	],
	"./gif.svg": [
		8147,
		[
			8147
		]
	],
	"./gift-card.svg": [
		57852,
		[
			57852
		]
	],
	"./gift.svg": [
		97349,
		[
			97349
		]
	],
	"./gifts.svg": [
		8460,
		[
			8460
		]
	],
	"./gingerbread-man.svg": [
		37276,
		[
			37276
		]
	],
	"./glass-champagne.svg": [
		81568,
		[
			81568
		]
	],
	"./glass-cheers.svg": [
		92048,
		[
			92048
		]
	],
	"./glass-citrus.svg": [
		96760,
		[
			96760
		]
	],
	"./glass-empty.svg": [
		81773,
		[
			81773
		]
	],
	"./glass-half-empty.svg": [
		82561,
		[
			82561
		]
	],
	"./glass-half-full.svg": [
		2021,
		[
			2021
		]
	],
	"./glass-half.svg": [
		91365,
		[
			91365
		]
	],
	"./glass-martini-alt.svg": [
		16338,
		[
			16338
		]
	],
	"./glass-martini.svg": [
		93812,
		[
			93812
		]
	],
	"./glass-water-droplet.svg": [
		83046,
		[
			83046
		]
	],
	"./glass-water.svg": [
		10207,
		[
			10207
		]
	],
	"./glass-whiskey-rocks.svg": [
		16257,
		[
			16257
		]
	],
	"./glass-whiskey.svg": [
		80756,
		[
			80756
		]
	],
	"./glass.svg": [
		12737,
		[
			12737
		]
	],
	"./glasses-alt.svg": [
		80275,
		[
			80275
		]
	],
	"./glasses-round.svg": [
		39910,
		[
			39910
		]
	],
	"./glasses.svg": [
		51793,
		[
			51793
		]
	],
	"./globe-africa.svg": [
		10261,
		[
			10261
		]
	],
	"./globe-americas.svg": [
		1832,
		[
			1832
		]
	],
	"./globe-asia.svg": [
		99877,
		[
			99877
		]
	],
	"./globe-europe.svg": [
		15893,
		[
			15893
		]
	],
	"./globe-oceania.svg": [
		62761,
		[
			62761
		]
	],
	"./globe-pointer.svg": [
		88582,
		[
			88582
		]
	],
	"./globe-snow.svg": [
		78926,
		[
			78926
		]
	],
	"./globe-stand.svg": [
		99361,
		[
			99361
		]
	],
	"./globe-wifi.svg": [
		39880,
		[
			39880
		]
	],
	"./globe.svg": [
		56806,
		[
			56806
		]
	],
	"./glove-boxing.svg": [
		69422,
		[
			69422
		]
	],
	"./goal-net.svg": [
		12396,
		[
			12396
		]
	],
	"./golf-ball-tee.svg": [
		47490,
		[
			47490
		]
	],
	"./golf-ball.svg": [
		69491,
		[
			69491
		]
	],
	"./golf-club.svg": [
		99960,
		[
			99960
		]
	],
	"./golf-flag-hole.svg": [
		75221,
		[
			75221
		]
	],
	"./gopuram.svg": [
		63804,
		[
			63804
		]
	],
	"./graduation-cap.svg": [
		45532,
		[
			45532
		]
	],
	"./gramophone.svg": [
		40499,
		[
			40499
		]
	],
	"./grapes.svg": [
		45099,
		[
			45099
		]
	],
	"./grate-droplet.svg": [
		26609,
		[
			26609
		]
	],
	"./grate.svg": [
		13183,
		[
			35564
		]
	],
	"./greater-than-equal.svg": [
		8182,
		[
			8182
		]
	],
	"./greater-than.svg": [
		95661,
		[
			95661
		]
	],
	"./grid-2-minus.svg": [
		4893,
		[
			4893
		]
	],
	"./grid-2-plus.svg": [
		8335,
		[
			8335
		]
	],
	"./grid-2.svg": [
		60326,
		[
			60326
		]
	],
	"./grid-3.svg": [
		47863,
		[
			47863
		]
	],
	"./grid-4.svg": [
		28056,
		[
			28056
		]
	],
	"./grid-5.svg": [
		62921,
		[
			62921
		]
	],
	"./grid-dividers.svg": [
		27422,
		[
			27422
		]
	],
	"./grid-horizontal.svg": [
		11060,
		[
			11060
		]
	],
	"./grid-round-2-minus.svg": [
		91170,
		[
			91170
		]
	],
	"./grid-round-2-plus.svg": [
		51562,
		[
			51562
		]
	],
	"./grid-round-2.svg": [
		57377,
		[
			57377
		]
	],
	"./grid-round-4.svg": [
		76399,
		[
			76399
		]
	],
	"./grid-round-5.svg": [
		39998,
		[
			39998
		]
	],
	"./grid-round.svg": [
		83516,
		[
			83516
		]
	],
	"./grid-vertical.svg": [
		80498,
		[
			80498
		]
	],
	"./grid.svg": [
		38387,
		[
			38387
		]
	],
	"./grill-fire.svg": [
		80318,
		[
			80318
		]
	],
	"./grill-hot.svg": [
		76019,
		[
			76019
		]
	],
	"./grill.svg": [
		30581,
		[
			30581
		]
	],
	"./grimace.svg": [
		37623,
		[
			37623
		]
	],
	"./grin-alt.svg": [
		37579,
		[
			37579
		]
	],
	"./grin-beam-sweat.svg": [
		41112,
		[
			41112
		]
	],
	"./grin-beam.svg": [
		9279,
		[
			9279
		]
	],
	"./grin-hearts.svg": [
		1197,
		[
			1197
		]
	],
	"./grin-squint-tears.svg": [
		18690,
		[
			18690
		]
	],
	"./grin-squint.svg": [
		90870,
		[
			90870
		]
	],
	"./grin-stars.svg": [
		64745,
		[
			64745
		]
	],
	"./grin-tears.svg": [
		67635,
		[
			67635
		]
	],
	"./grin-tongue-squint.svg": [
		29871,
		[
			29871
		]
	],
	"./grin-tongue-wink.svg": [
		17066,
		[
			17066
		]
	],
	"./grin-tongue.svg": [
		92942,
		[
			92942
		]
	],
	"./grin-wink.svg": [
		7351,
		[
			7351
		]
	],
	"./grin.svg": [
		84873,
		[
			84873
		]
	],
	"./grip-dots-vertical.svg": [
		12551,
		[
			12551
		]
	],
	"./grip-dots.svg": [
		87780,
		[
			87780
		]
	],
	"./grip-horizontal.svg": [
		41528,
		[
			41528
		]
	],
	"./grip-lines-vertical.svg": [
		78944,
		[
			78944
		]
	],
	"./grip-lines.svg": [
		97649,
		[
			97649
		]
	],
	"./grip-vertical.svg": [
		60654,
		[
			60654
		]
	],
	"./grip.svg": [
		64284,
		[
			64284
		]
	],
	"./group-arrows-rotate.svg": [
		33945,
		[
			33945
		]
	],
	"./guarani-sign.svg": [
		31366,
		[
			31366
		]
	],
	"./guitar-electric.svg": [
		86531,
		[
			86531
		]
	],
	"./guitar.svg": [
		96133,
		[
			96133
		]
	],
	"./guitars.svg": [
		20076,
		[
			20076
		]
	],
	"./gun-slash.svg": [
		39171,
		[
			39171
		]
	],
	"./gun-squirt.svg": [
		50660,
		[
			50660
		]
	],
	"./gun.svg": [
		36151,
		[
			36151
		]
	],
	"./h-square.svg": [
		98671,
		[
			98671
		]
	],
	"./h.svg": [
		64605,
		[
			64605
		]
	],
	"./h1.svg": [
		12406,
		[
			12406
		]
	],
	"./h2.svg": [
		84277,
		[
			84277
		]
	],
	"./h3.svg": [
		11668,
		[
			11668
		]
	],
	"./h4.svg": [
		37787,
		[
			37787
		]
	],
	"./h5.svg": [
		77418,
		[
			77418
		]
	],
	"./h6.svg": [
		68793,
		[
			68793
		]
	],
	"./hamburger.svg": [
		39248,
		[
			39248
		]
	],
	"./hammer-brush.svg": [
		15298,
		[
			15298
		]
	],
	"./hammer-crash.svg": [
		70987,
		[
			70987
		]
	],
	"./hammer-war.svg": [
		47292,
		[
			47292
		]
	],
	"./hammer.svg": [
		28893,
		[
			28893
		]
	],
	"./hamsa.svg": [
		33747,
		[
			33747
		]
	],
	"./hand-back-fist.svg": [
		61227,
		[
			61227
		]
	],
	"./hand-back-point-down.svg": [
		12626,
		[
			12626
		]
	],
	"./hand-back-point-left.svg": [
		45081,
		[
			45081
		]
	],
	"./hand-back-point-ribbon.svg": [
		91998,
		[
			91998
		]
	],
	"./hand-back-point-right.svg": [
		25316,
		[
			25316
		]
	],
	"./hand-back-point-up.svg": [
		32801,
		[
			32801
		]
	],
	"./hand-dots.svg": [
		29241,
		[
			29241
		]
	],
	"./hand-fingers-crossed.svg": [
		86861,
		[
			86861
		]
	],
	"./hand-fist.svg": [
		6555,
		[
			6555
		]
	],
	"./hand-heart.svg": [
		43263,
		[
			43263
		]
	],
	"./hand-holding-box.svg": [
		49150,
		[
			49150
		]
	],
	"./hand-holding-circle-dollar.svg": [
		8278,
		[
			8278
		]
	],
	"./hand-holding-dollar.svg": [
		80413,
		[
			80413
		]
	],
	"./hand-holding-droplet.svg": [
		70107,
		[
			70107
		]
	],
	"./hand-holding-hand.svg": [
		6928,
		[
			6928
		]
	],
	"./hand-holding-heart.svg": [
		48689,
		[
			48689
		]
	],
	"./hand-holding-magic.svg": [
		97628,
		[
			97628
		]
	],
	"./hand-holding-medical.svg": [
		53708,
		[
			53708
		]
	],
	"./hand-holding-seedling.svg": [
		45176,
		[
			45176
		]
	],
	"./hand-holding-skull.svg": [
		30710,
		[
			30710
		]
	],
	"./hand-holding-star.svg": [
		34715,
		[
			34715
		]
	],
	"./hand-holding-usd.svg": [
		37989,
		[
			37989
		]
	],
	"./hand-holding-water.svg": [
		55584,
		[
			55584
		]
	],
	"./hand-holding.svg": [
		45206,
		[
			45206
		]
	],
	"./hand-horns.svg": [
		60261,
		[
			60261
		]
	],
	"./hand-lizard.svg": [
		28777,
		[
			28777
		]
	],
	"./hand-love.svg": [
		57369,
		[
			57369
		]
	],
	"./hand-middle-finger.svg": [
		72820,
		[
			72820
		]
	],
	"./hand-paper.svg": [
		51785,
		[
			51785
		]
	],
	"./hand-peace.svg": [
		61701,
		[
			61701
		]
	],
	"./hand-point-down.svg": [
		5282,
		[
			5282
		]
	],
	"./hand-point-left.svg": [
		44457,
		[
			44457
		]
	],
	"./hand-point-ribbon.svg": [
		90158,
		[
			90158
		]
	],
	"./hand-point-right.svg": [
		30516,
		[
			30516
		]
	],
	"./hand-point-up.svg": [
		14865,
		[
			14865
		]
	],
	"./hand-pointer.svg": [
		55996,
		[
			55996
		]
	],
	"./hand-receiving.svg": [
		53317,
		[
			53317
		]
	],
	"./hand-rock.svg": [
		9946,
		[
			9946
		]
	],
	"./hand-scissors.svg": [
		50148,
		[
			27767
		]
	],
	"./hand-shaka.svg": [
		56741,
		[
			56741
		]
	],
	"./hand-sparkles.svg": [
		7700,
		[
			7700
		]
	],
	"./hand-spock.svg": [
		83309,
		[
			83309
		]
	],
	"./hand-wave.svg": [
		58210,
		[
			58210
		]
	],
	"./hand.svg": [
		70776,
		[
			70776
		]
	],
	"./handcuffs.svg": [
		56939,
		[
			56939
		]
	],
	"./hands-american-sign-language-interpreting.svg": [
		52246,
		[
			52246
		]
	],
	"./hands-asl-interpreting.svg": [
		33948,
		[
			33948
		]
	],
	"./hands-bound.svg": [
		69940,
		[
			69940
		]
	],
	"./hands-bubbles.svg": [
		84809,
		[
			84809
		]
	],
	"./hands-clapping.svg": [
		43630,
		[
			43630
		]
	],
	"./hands-heart.svg": [
		84120,
		[
			84120
		]
	],
	"./hands-helping.svg": [
		91771,
		[
			91771
		]
	],
	"./hands-holding-child.svg": [
		23660,
		[
			23660
		]
	],
	"./hands-holding-circle.svg": [
		88818,
		[
			88818
		]
	],
	"./hands-holding-diamond.svg": [
		32266,
		[
			32266
		]
	],
	"./hands-holding-dollar.svg": [
		45340,
		[
			45340
		]
	],
	"./hands-holding-heart.svg": [
		67350,
		[
			67350
		]
	],
	"./hands-holding.svg": [
		45637,
		[
			45637
		]
	],
	"./hands-praying.svg": [
		46688,
		[
			46688
		]
	],
	"./hands-usd.svg": [
		38988,
		[
			38988
		]
	],
	"./hands-wash.svg": [
		55465,
		[
			55465
		]
	],
	"./hands.svg": [
		9035,
		[
			9035
		]
	],
	"./handshake-alt-slash.svg": [
		62704,
		[
			62704
		]
	],
	"./handshake-alt.svg": [
		63272,
		[
			63272
		]
	],
	"./handshake-angle.svg": [
		82004,
		[
			82004
		]
	],
	"./handshake-simple-slash.svg": [
		34517,
		[
			34517
		]
	],
	"./handshake-simple.svg": [
		9257,
		[
			9257
		]
	],
	"./handshake-slash.svg": [
		84010,
		[
			84010
		]
	],
	"./handshake.svg": [
		75274,
		[
			75274
		]
	],
	"./hanukiah.svg": [
		31470,
		[
			31470
		]
	],
	"./hard-drive.svg": [
		76891,
		[
			76891
		]
	],
	"./hard-hat.svg": [
		97780,
		[
			97780
		]
	],
	"./hard-of-hearing.svg": [
		27901,
		[
			27901
		]
	],
	"./hashtag-lock.svg": [
		54539,
		[
			54539
		]
	],
	"./hashtag.svg": [
		45117,
		[
			45117
		]
	],
	"./hat-beach.svg": [
		66552,
		[
			66552
		]
	],
	"./hat-chef.svg": [
		30527,
		[
			30527
		]
	],
	"./hat-cowboy-side.svg": [
		92646,
		[
			92646
		]
	],
	"./hat-cowboy.svg": [
		43730,
		[
			43730
		]
	],
	"./hat-hard.svg": [
		34124,
		[
			34124
		]
	],
	"./hat-santa.svg": [
		43938,
		[
			43938
		]
	],
	"./hat-winter.svg": [
		68860,
		[
			68860
		]
	],
	"./hat-witch.svg": [
		90352,
		[
			90352
		]
	],
	"./hat-wizard.svg": [
		26102,
		[
			26102
		]
	],
	"./haykal.svg": [
		14217,
		[
			14217
		]
	],
	"./hdd.svg": [
		37661,
		[
			37661
		]
	],
	"./head-side-brain.svg": [
		31040,
		[
			31040
		]
	],
	"./head-side-circuit.svg": [
		31965,
		[
			31965
		]
	],
	"./head-side-cough-slash.svg": [
		70061,
		[
			92442
		]
	],
	"./head-side-cough.svg": [
		81434,
		[
			81434
		]
	],
	"./head-side-gear.svg": [
		20405,
		[
			20405
		]
	],
	"./head-side-goggles.svg": [
		57928,
		[
			57928
		]
	],
	"./head-side-headphones.svg": [
		861,
		[
			861
		]
	],
	"./head-side-heart.svg": [
		1544,
		[
			1544
		]
	],
	"./head-side-mask.svg": [
		35188,
		[
			35188
		]
	],
	"./head-side-medical.svg": [
		35297,
		[
			35297
		]
	],
	"./head-side-speak.svg": [
		13041,
		[
			35422
		]
	],
	"./head-side-virus.svg": [
		87483,
		[
			87483
		]
	],
	"./head-side.svg": [
		51963,
		[
			51963
		]
	],
	"./head-vr.svg": [
		2870,
		[
			2870
		]
	],
	"./header.svg": [
		92904,
		[
			92904
		]
	],
	"./heading.svg": [
		42023,
		[
			42023
		]
	],
	"./headphones-alt.svg": [
		35352,
		[
			35352
		]
	],
	"./headphones-simple.svg": [
		18521,
		[
			18521
		]
	],
	"./headphones-slash.svg": [
		50906,
		[
			50906
		]
	],
	"./headphones.svg": [
		34298,
		[
			34298
		]
	],
	"./headset.svg": [
		82163,
		[
			82163
		]
	],
	"./heart-broken.svg": [
		48113,
		[
			48113
		]
	],
	"./heart-circle-bolt.svg": [
		42962,
		[
			42962
		]
	],
	"./heart-circle-check.svg": [
		20645,
		[
			20645
		]
	],
	"./heart-circle-exclamation.svg": [
		80706,
		[
			80706
		]
	],
	"./heart-circle-minus.svg": [
		46157,
		[
			46157
		]
	],
	"./heart-circle-plus.svg": [
		65503,
		[
			65503
		]
	],
	"./heart-circle-xmark.svg": [
		17150,
		[
			17150
		]
	],
	"./heart-circle.svg": [
		21449,
		[
			43830
		]
	],
	"./heart-crack.svg": [
		48556,
		[
			48556
		]
	],
	"./heart-half-alt.svg": [
		50887,
		[
			50887
		]
	],
	"./heart-half-stroke.svg": [
		11254,
		[
			11254
		]
	],
	"./heart-half.svg": [
		84125,
		[
			84125
		]
	],
	"./heart-music-camera-bolt.svg": [
		91047,
		[
			91047
		]
	],
	"./heart-pulse.svg": [
		19361,
		[
			19361
		]
	],
	"./heart-rate.svg": [
		67875,
		[
			90256
		]
	],
	"./heart-slash.svg": [
		5893,
		[
			5893
		]
	],
	"./heart-square.svg": [
		15371,
		[
			15371
		]
	],
	"./heart.svg": [
		20537,
		[
			20537
		]
	],
	"./heartbeat.svg": [
		27965,
		[
			27965
		]
	],
	"./hearts.svg": [
		86456,
		[
			64075
		]
	],
	"./heat.svg": [
		74681,
		[
			74681
		]
	],
	"./helicopter-symbol.svg": [
		13445,
		[
			13445
		]
	],
	"./helicopter.svg": [
		20136,
		[
			20136
		]
	],
	"./helmet-battle.svg": [
		57031,
		[
			57031
		]
	],
	"./helmet-safety.svg": [
		80515,
		[
			80515
		]
	],
	"./helmet-un.svg": [
		96752,
		[
			96752
		]
	],
	"./heptagon.svg": [
		18857,
		[
			18857
		]
	],
	"./hexagon-check.svg": [
		66646,
		[
			66646
		]
	],
	"./hexagon-divide.svg": [
		34181,
		[
			34181
		]
	],
	"./hexagon-equals.svg": [
		13586,
		[
			91205
		]
	],
	"./hexagon-exclamation.svg": [
		27873,
		[
			27873
		]
	],
	"./hexagon-image.svg": [
		2093,
		[
			2093
		]
	],
	"./hexagon-minus.svg": [
		23925,
		[
			46306
		]
	],
	"./hexagon-nodes-bolt.svg": [
		6203,
		[
			6203
		]
	],
	"./hexagon-nodes.svg": [
		90045,
		[
			90045
		]
	],
	"./hexagon-plus.svg": [
		45994,
		[
			45994
		]
	],
	"./hexagon-vertical-nft-slanted.svg": [
		54159,
		[
			54159
		]
	],
	"./hexagon-vertical-nft.svg": [
		7731,
		[
			7731
		]
	],
	"./hexagon-xmark.svg": [
		39573,
		[
			39573
		]
	],
	"./hexagon.svg": [
		83585,
		[
			83585
		]
	],
	"./high-definition.svg": [
		72051,
		[
			72051
		]
	],
	"./highlighter-line.svg": [
		37947,
		[
			37947
		]
	],
	"./highlighter.svg": [
		27767,
		[
			50148
		]
	],
	"./hiking.svg": [
		5271,
		[
			5271
		]
	],
	"./hill-avalanche.svg": [
		7390,
		[
			7390
		]
	],
	"./hill-rockslide.svg": [
		76827,
		[
			76827
		]
	],
	"./hippo.svg": [
		67813,
		[
			67813
		]
	],
	"./history.svg": [
		9397,
		[
			9397
		]
	],
	"./hockey-mask.svg": [
		3425,
		[
			3425
		]
	],
	"./hockey-puck.svg": [
		27154,
		[
			27154
		]
	],
	"./hockey-stick-puck.svg": [
		77171,
		[
			77171
		]
	],
	"./hockey-stick.svg": [
		37131,
		[
			37131
		]
	],
	"./hockey-sticks.svg": [
		74050,
		[
			74050
		]
	],
	"./holly-berry.svg": [
		91942,
		[
			69561
		]
	],
	"./home-alt.svg": [
		84592,
		[
			84592
		]
	],
	"./home-blank.svg": [
		31903,
		[
			31903
		]
	],
	"./home-heart.svg": [
		98501,
		[
			98501
		]
	],
	"./home-lg-alt.svg": [
		93030,
		[
			93030
		]
	],
	"./home-lg.svg": [
		83024,
		[
			83024
		]
	],
	"./home-user.svg": [
		10090,
		[
			10090
		]
	],
	"./home.svg": [
		32146,
		[
			32146
		]
	],
	"./honey-pot.svg": [
		23998,
		[
			23998
		]
	],
	"./hood-cloak.svg": [
		2278,
		[
			2278
		]
	],
	"./horizontal-rule.svg": [
		51494,
		[
			51494
		]
	],
	"./horse-head.svg": [
		34245,
		[
			34245
		]
	],
	"./horse-saddle.svg": [
		57838,
		[
			57838
		]
	],
	"./horse.svg": [
		43658,
		[
			43658
		]
	],
	"./horseshoe.svg": [
		3235,
		[
			3235
		]
	],
	"./hose-reel.svg": [
		86097,
		[
			86097
		]
	],
	"./hose.svg": [
		46436,
		[
			46436
		]
	],
	"./hospital-alt.svg": [
		52715,
		[
			52715
		]
	],
	"./hospital-symbol.svg": [
		5502,
		[
			5502
		]
	],
	"./hospital-user.svg": [
		80367,
		[
			80367
		]
	],
	"./hospital-wide.svg": [
		9839,
		[
			9839
		]
	],
	"./hospital.svg": [
		44553,
		[
			44553
		]
	],
	"./hospitals.svg": [
		92840,
		[
			92840
		]
	],
	"./hot-tub-person.svg": [
		6980,
		[
			6980
		]
	],
	"./hot-tub.svg": [
		4162,
		[
			4162
		]
	],
	"./hotdog.svg": [
		21570,
		[
			21570
		]
	],
	"./hotel.svg": [
		6159,
		[
			6159
		]
	],
	"./hourglass-1.svg": [
		50265,
		[
			50265
		]
	],
	"./hourglass-2.svg": [
		970,
		[
			970
		]
	],
	"./hourglass-3.svg": [
		69787,
		[
			69787
		]
	],
	"./hourglass-clock.svg": [
		29146,
		[
			29146
		]
	],
	"./hourglass-empty.svg": [
		90019,
		[
			90019
		]
	],
	"./hourglass-end.svg": [
		24807,
		[
			24807
		]
	],
	"./hourglass-half.svg": [
		27659,
		[
			27659
		]
	],
	"./hourglass-start.svg": [
		29076,
		[
			29076
		]
	],
	"./hourglass.svg": [
		61564,
		[
			61564
		]
	],
	"./house-blank.svg": [
		66720,
		[
			66720
		]
	],
	"./house-building.svg": [
		66090,
		[
			66090
		]
	],
	"./house-chimney-blank.svg": [
		10086,
		[
			10086
		]
	],
	"./house-chimney-crack.svg": [
		69430,
		[
			69430
		]
	],
	"./house-chimney-heart.svg": [
		34160,
		[
			34160
		]
	],
	"./house-chimney-medical.svg": [
		67593,
		[
			67593
		]
	],
	"./house-chimney-user.svg": [
		99933,
		[
			99933
		]
	],
	"./house-chimney-window.svg": [
		64336,
		[
			64336
		]
	],
	"./house-chimney.svg": [
		5667,
		[
			5667
		]
	],
	"./house-circle-check.svg": [
		73757,
		[
			73757
		]
	],
	"./house-circle-exclamation.svg": [
		51258,
		[
			51258
		]
	],
	"./house-circle-xmark.svg": [
		76678,
		[
			76678
		]
	],
	"./house-crack.svg": [
		56724,
		[
			34343
		]
	],
	"./house-damage.svg": [
		75957,
		[
			75957
		]
	],
	"./house-day.svg": [
		36760,
		[
			36760
		]
	],
	"./house-fire.svg": [
		22890,
		[
			22890
		]
	],
	"./house-flag.svg": [
		96948,
		[
			96948
		]
	],
	"./house-flood-water-circle-arrow-right.svg": [
		660,
		[
			660
		]
	],
	"./house-flood-water.svg": [
		38724,
		[
			38724
		]
	],
	"./house-flood.svg": [
		37338,
		[
			37338
		]
	],
	"./house-heart.svg": [
		12509,
		[
			34890
		]
	],
	"./house-laptop.svg": [
		59534,
		[
			59534
		]
	],
	"./house-leave.svg": [
		20411,
		[
			20411
		]
	],
	"./house-lock.svg": [
		45951,
		[
			45951
		]
	],
	"./house-medical-circle-check.svg": [
		93059,
		[
			93059
		]
	],
	"./house-medical-circle-exclamation.svg": [
		34552,
		[
			34552
		]
	],
	"./house-medical-circle-xmark.svg": [
		74056,
		[
			74056
		]
	],
	"./house-medical-flag.svg": [
		48514,
		[
			48514
		]
	],
	"./house-medical.svg": [
		73619,
		[
			73619
		]
	],
	"./house-night.svg": [
		34524,
		[
			34524
		]
	],
	"./house-person-arrive.svg": [
		27387,
		[
			27387
		]
	],
	"./house-person-depart.svg": [
		79640,
		[
			79640
		]
	],
	"./house-person-leave.svg": [
		15687,
		[
			15687
		]
	],
	"./house-person-return.svg": [
		23720,
		[
			23720
		]
	],
	"./house-return.svg": [
		63524,
		[
			63524
		]
	],
	"./house-signal.svg": [
		69094,
		[
			69094
		]
	],
	"./house-tree.svg": [
		67554,
		[
			67554
		]
	],
	"./house-tsunami.svg": [
		74799,
		[
			74799
		]
	],
	"./house-turret.svg": [
		88884,
		[
			88884
		]
	],
	"./house-unlock.svg": [
		3602,
		[
			3602
		]
	],
	"./house-user.svg": [
		79719,
		[
			79719
		]
	],
	"./house-water.svg": [
		44543,
		[
			44543
		]
	],
	"./house-window.svg": [
		73346,
		[
			73346
		]
	],
	"./house.svg": [
		62305,
		[
			62305
		]
	],
	"./hryvnia-sign.svg": [
		46570,
		[
			46570
		]
	],
	"./hryvnia.svg": [
		35612,
		[
			35612
		]
	],
	"./humidity.svg": [
		72104,
		[
			72104
		]
	],
	"./hundred-points.svg": [
		9295,
		[
			9295
		]
	],
	"./hurricane.svg": [
		53724,
		[
			53724
		]
	],
	"./hydra.svg": [
		93073,
		[
			93073
		]
	],
	"./hyphen.svg": [
		95379,
		[
			95379
		]
	],
	"./i-cursor.svg": [
		77339,
		[
			77339
		]
	],
	"./i.svg": [
		36060,
		[
			36060
		]
	],
	"./ice-cream.svg": [
		27793,
		[
			27793
		]
	],
	"./ice-skate.svg": [
		75933,
		[
			75933
		]
	],
	"./icicles.svg": [
		4465,
		[
			4465
		]
	],
	"./icons-alt.svg": [
		25221,
		[
			25221
		]
	],
	"./icons.svg": [
		56491,
		[
			56491
		]
	],
	"./id-badge.svg": [
		57898,
		[
			57898
		]
	],
	"./id-card-alt.svg": [
		16845,
		[
			16845
		]
	],
	"./id-card-clip.svg": [
		45750,
		[
			45750
		]
	],
	"./id-card.svg": [
		62259,
		[
			62259
		]
	],
	"./igloo.svg": [
		5663,
		[
			5663
		]
	],
	"./ils.svg": [
		9235,
		[
			9235
		]
	],
	"./image-circle-arrow-down.svg": [
		16676,
		[
			16676
		]
	],
	"./image-circle-check.svg": [
		32076,
		[
			32076
		]
	],
	"./image-circle-plus.svg": [
		32823,
		[
			55204
		]
	],
	"./image-circle-xmark.svg": [
		55431,
		[
			55431
		]
	],
	"./image-landscape.svg": [
		17449,
		[
			39830
		]
	],
	"./image-music.svg": [
		8668,
		[
			8668
		]
	],
	"./image-polaroid-user.svg": [
		69185,
		[
			69185
		]
	],
	"./image-polaroid.svg": [
		92455,
		[
			92455
		]
	],
	"./image-portrait.svg": [
		33038,
		[
			33038
		]
	],
	"./image-slash.svg": [
		95854,
		[
			95854
		]
	],
	"./image-stack.svg": [
		24741,
		[
			24741
		]
	],
	"./image-user.svg": [
		2662,
		[
			2662
		]
	],
	"./image.svg": [
		46110,
		[
			46110
		]
	],
	"./images-user.svg": [
		53319,
		[
			53319
		]
	],
	"./images.svg": [
		86145,
		[
			86145
		]
	],
	"./inbox-arrow-down.svg": [
		31410,
		[
			31410
		]
	],
	"./inbox-arrow-up.svg": [
		72257,
		[
			72257
		]
	],
	"./inbox-full.svg": [
		43041,
		[
			43041
		]
	],
	"./inbox-in.svg": [
		31663,
		[
			31663
		]
	],
	"./inbox-out.svg": [
		70810,
		[
			70810
		]
	],
	"./inbox.svg": [
		7649,
		[
			7649
		]
	],
	"./inboxes.svg": [
		47473,
		[
			47473
		]
	],
	"./indent.svg": [
		72129,
		[
			72129
		]
	],
	"./indian-rupee-sign.svg": [
		69564,
		[
			69564
		]
	],
	"./indian-rupee.svg": [
		40350,
		[
			40350
		]
	],
	"./industry-alt.svg": [
		71327,
		[
			71327
		]
	],
	"./industry-windows.svg": [
		23265,
		[
			23265
		]
	],
	"./industry.svg": [
		64597,
		[
			64597
		]
	],
	"./infinity.svg": [
		43435,
		[
			43435
		]
	],
	"./info-circle.svg": [
		42660,
		[
			42660
		]
	],
	"./info-square.svg": [
		37389,
		[
			37389
		]
	],
	"./info.svg": [
		74567,
		[
			74567
		]
	],
	"./inhaler.svg": [
		86316,
		[
			86316
		]
	],
	"./input-numeric.svg": [
		943,
		[
			943
		]
	],
	"./input-pipe.svg": [
		87482,
		[
			87482
		]
	],
	"./input-text.svg": [
		50939,
		[
			50939
		]
	],
	"./inr.svg": [
		28780,
		[
			28780
		]
	],
	"./institution.svg": [
		40839,
		[
			40839
		]
	],
	"./integral.svg": [
		12751,
		[
			12751
		]
	],
	"./interrobang.svg": [
		4032,
		[
			4032
		]
	],
	"./intersection.svg": [
		67248,
		[
			67248
		]
	],
	"./inventory.svg": [
		43813,
		[
			43813
		]
	],
	"./island-tree-palm.svg": [
		83914,
		[
			83914
		]
	],
	"./island-tropical.svg": [
		87625,
		[
			87625
		]
	],
	"./italic.svg": [
		99663,
		[
			99663
		]
	],
	"./j.svg": [
		15087,
		[
			15087
		]
	],
	"./jack-o-lantern.svg": [
		61081,
		[
			61081
		]
	],
	"./jar-wheat.svg": [
		37616,
		[
			37616
		]
	],
	"./jar.svg": [
		21798,
		[
			21798
		]
	],
	"./jeans-straight.svg": [
		10235,
		[
			10235
		]
	],
	"./jeans.svg": [
		74732,
		[
			74732
		]
	],
	"./jedi.svg": [
		11837,
		[
			11837
		]
	],
	"./jet-fighter-up.svg": [
		17502,
		[
			17502
		]
	],
	"./jet-fighter.svg": [
		24704,
		[
			24704
		]
	],
	"./joint.svg": [
		28557,
		[
			28557
		]
	],
	"./journal-whills.svg": [
		45904,
		[
			45904
		]
	],
	"./joystick.svg": [
		13157,
		[
			13157
		]
	],
	"./jpy.svg": [
		86222,
		[
			86222
		]
	],
	"./jug-bottle.svg": [
		97896,
		[
			97896
		]
	],
	"./jug-detergent.svg": [
		50928,
		[
			50928
		]
	],
	"./jug.svg": [
		15935,
		[
			15935
		]
	],
	"./k.svg": [
		52510,
		[
			52510
		]
	],
	"./kaaba.svg": [
		59943,
		[
			59943
		]
	],
	"./kazoo.svg": [
		89637,
		[
			89637
		]
	],
	"./kerning.svg": [
		28237,
		[
			28237
		]
	],
	"./kettlebell.svg": [
		96389,
		[
			96389
		]
	],
	"./key-skeleton-left-right.svg": [
		32231,
		[
			32231
		]
	],
	"./key-skeleton.svg": [
		89716,
		[
			89716
		]
	],
	"./key.svg": [
		57012,
		[
			57012
		]
	],
	"./keyboard-brightness-low.svg": [
		29005,
		[
			29005
		]
	],
	"./keyboard-brightness.svg": [
		5352,
		[
			5352
		]
	],
	"./keyboard-down.svg": [
		73293,
		[
			73293
		]
	],
	"./keyboard-left.svg": [
		95542,
		[
			95542
		]
	],
	"./keyboard.svg": [
		34044,
		[
			34044
		]
	],
	"./keynote.svg": [
		60544,
		[
			60544
		]
	],
	"./khanda.svg": [
		45198,
		[
			45198
		]
	],
	"./kidneys.svg": [
		66578,
		[
			66578
		]
	],
	"./kip-sign.svg": [
		20085,
		[
			20085
		]
	],
	"./kiss-beam.svg": [
		76003,
		[
			76003
		]
	],
	"./kiss-wink-heart.svg": [
		6280,
		[
			6280
		]
	],
	"./kiss.svg": [
		13181,
		[
			13181
		]
	],
	"./kit-medical.svg": [
		93127,
		[
			93127
		]
	],
	"./kitchen-set.svg": [
		98994,
		[
			98994
		]
	],
	"./kite.svg": [
		82282,
		[
			82282
		]
	],
	"./kiwi-bird.svg": [
		72997,
		[
			72997
		]
	],
	"./kiwi-fruit.svg": [
		12850,
		[
			12850
		]
	],
	"./knife-kitchen.svg": [
		49845,
		[
			49845
		]
	],
	"./knife.svg": [
		67342,
		[
			67342
		]
	],
	"./krw.svg": [
		32639,
		[
			32639
		]
	],
	"./l.svg": [
		12417,
		[
			12417
		]
	],
	"./lacrosse-stick-ball.svg": [
		19986,
		[
			19986
		]
	],
	"./lacrosse-stick.svg": [
		83884,
		[
			83884
		]
	],
	"./ladder-water.svg": [
		26817,
		[
			26817
		]
	],
	"./lambda.svg": [
		18558,
		[
			18558
		]
	],
	"./lamp-desk.svg": [
		26433,
		[
			26433
		]
	],
	"./lamp-floor.svg": [
		95076,
		[
			95076
		]
	],
	"./lamp-street.svg": [
		64163,
		[
			64163
		]
	],
	"./lamp.svg": [
		34897,
		[
			34897
		]
	],
	"./land-mine-on.svg": [
		19462,
		[
			19462
		]
	],
	"./landmark-alt.svg": [
		70681,
		[
			70681
		]
	],
	"./landmark-dome.svg": [
		43161,
		[
			43161
		]
	],
	"./landmark-flag.svg": [
		54766,
		[
			54766
		]
	],
	"./landmark-magnifying-glass.svg": [
		95444,
		[
			95444
		]
	],
	"./landmark.svg": [
		23239,
		[
			23239
		]
	],
	"./landscape.svg": [
		74582,
		[
			74582
		]
	],
	"./language.svg": [
		69137,
		[
			69137
		]
	],
	"./laptop-arrow-down.svg": [
		31808,
		[
			31808
		]
	],
	"./laptop-binary.svg": [
		10887,
		[
			10887
		]
	],
	"./laptop-code.svg": [
		68567,
		[
			68567
		]
	],
	"./laptop-file.svg": [
		1034,
		[
			1034
		]
	],
	"./laptop-house.svg": [
		60428,
		[
			60428
		]
	],
	"./laptop-medical.svg": [
		32109,
		[
			32109
		]
	],
	"./laptop-mobile.svg": [
		29390,
		[
			29390
		]
	],
	"./laptop-slash.svg": [
		2331,
		[
			2331
		]
	],
	"./laptop.svg": [
		94623,
		[
			94623
		]
	],
	"./lari-sign.svg": [
		41105,
		[
			41105
		]
	],
	"./lasso-sparkles.svg": [
		49397,
		[
			49397
		]
	],
	"./lasso.svg": [
		88699,
		[
			11080
		]
	],
	"./laugh-beam.svg": [
		65938,
		[
			65938
		]
	],
	"./laugh-squint.svg": [
		78155,
		[
			78155
		]
	],
	"./laugh-wink.svg": [
		39454,
		[
			39454
		]
	],
	"./laugh.svg": [
		52322,
		[
			52322
		]
	],
	"./layer-group-minus.svg": [
		67623,
		[
			67623
		]
	],
	"./layer-group-plus.svg": [
		89801,
		[
			89801
		]
	],
	"./layer-group.svg": [
		98624,
		[
			98624
		]
	],
	"./layer-minus.svg": [
		63617,
		[
			63617
		]
	],
	"./layer-plus.svg": [
		42467,
		[
			42467
		]
	],
	"./leaf-heart.svg": [
		81612,
		[
			81612
		]
	],
	"./leaf-maple.svg": [
		77371,
		[
			77371
		]
	],
	"./leaf-oak.svg": [
		14711,
		[
			14711
		]
	],
	"./leaf.svg": [
		27095,
		[
			27095
		]
	],
	"./leafy-green.svg": [
		49486,
		[
			49486
		]
	],
	"./left-from-bracket.svg": [
		33086,
		[
			33086
		]
	],
	"./left-from-dotted-line.svg": [
		19985,
		[
			19985
		]
	],
	"./left-from-line.svg": [
		6184,
		[
			6184
		]
	],
	"./left-long-to-line.svg": [
		13006,
		[
			13006
		]
	],
	"./left-long.svg": [
		90163,
		[
			90163
		]
	],
	"./left-right.svg": [
		33369,
		[
			33369
		]
	],
	"./left-to-bracket.svg": [
		26846,
		[
			26846
		]
	],
	"./left-to-dotted-line.svg": [
		86710,
		[
			86710
		]
	],
	"./left-to-line.svg": [
		55605,
		[
			55605
		]
	],
	"./left.svg": [
		85496,
		[
			85496
		]
	],
	"./legal.svg": [
		86350,
		[
			86350
		]
	],
	"./lemon.svg": [
		46616,
		[
			46616
		]
	],
	"./less-than-equal.svg": [
		38255,
		[
			38255
		]
	],
	"./less-than.svg": [
		32312,
		[
			32312
		]
	],
	"./level-down-alt.svg": [
		48994,
		[
			48994
		]
	],
	"./level-down.svg": [
		99812,
		[
			99812
		]
	],
	"./level-up-alt.svg": [
		78961,
		[
			78961
		]
	],
	"./level-up.svg": [
		73119,
		[
			73119
		]
	],
	"./life-ring.svg": [
		20196,
		[
			20196
		]
	],
	"./light-ceiling.svg": [
		5167,
		[
			5167
		]
	],
	"./light-emergency-on.svg": [
		70917,
		[
			70917
		]
	],
	"./light-emergency.svg": [
		95413,
		[
			95413
		]
	],
	"./light-switch-off.svg": [
		66290,
		[
			66290
		]
	],
	"./light-switch-on.svg": [
		17212,
		[
			17212
		]
	],
	"./light-switch.svg": [
		1122,
		[
			1122
		]
	],
	"./lightbulb-cfl-on.svg": [
		45600,
		[
			45600
		]
	],
	"./lightbulb-cfl.svg": [
		98774,
		[
			98774
		]
	],
	"./lightbulb-dollar.svg": [
		16119,
		[
			16119
		]
	],
	"./lightbulb-exclamation-on.svg": [
		34506,
		[
			34506
		]
	],
	"./lightbulb-exclamation.svg": [
		20012,
		[
			20012
		]
	],
	"./lightbulb-gear.svg": [
		76100,
		[
			76100
		]
	],
	"./lightbulb-message.svg": [
		33702,
		[
			33702
		]
	],
	"./lightbulb-on.svg": [
		12410,
		[
			12410
		]
	],
	"./lightbulb-slash.svg": [
		39700,
		[
			39700
		]
	],
	"./lightbulb.svg": [
		10396,
		[
			10396
		]
	],
	"./lighthouse.svg": [
		9307,
		[
			9307
		]
	],
	"./lights-holiday.svg": [
		44003,
		[
			44003
		]
	],
	"./line-chart.svg": [
		46678,
		[
			46678
		]
	],
	"./line-columns.svg": [
		46295,
		[
			46295
		]
	],
	"./line-height.svg": [
		16647,
		[
			16647
		]
	],
	"./lines-leaning.svg": [
		48763,
		[
			48763
		]
	],
	"./link-horizontal-slash.svg": [
		25572,
		[
			25572
		]
	],
	"./link-horizontal.svg": [
		44300,
		[
			44300
		]
	],
	"./link-simple-slash.svg": [
		32946,
		[
			32946
		]
	],
	"./link-simple.svg": [
		13890,
		[
			13890
		]
	],
	"./link-slash.svg": [
		1751,
		[
			1751
		]
	],
	"./link.svg": [
		42299,
		[
			42299
		]
	],
	"./lips.svg": [
		54489,
		[
			54489
		]
	],
	"./lira-sign.svg": [
		26177,
		[
			26177
		]
	],
	"./list-1-2.svg": [
		48148,
		[
			48148
		]
	],
	"./list-alt.svg": [
		1709,
		[
			1709
		]
	],
	"./list-check.svg": [
		71124,
		[
			71124
		]
	],
	"./list-dots.svg": [
		98096,
		[
			98096
		]
	],
	"./list-dropdown.svg": [
		90051,
		[
			90051
		]
	],
	"./list-music.svg": [
		39989,
		[
			39989
		]
	],
	"./list-numeric.svg": [
		72461,
		[
			72461
		]
	],
	"./list-ol.svg": [
		15117,
		[
			15117
		]
	],
	"./list-radio.svg": [
		98549,
		[
			98549
		]
	],
	"./list-squares.svg": [
		93547,
		[
			93547
		]
	],
	"./list-timeline.svg": [
		24349,
		[
			24349
		]
	],
	"./list-tree.svg": [
		31084,
		[
			31084
		]
	],
	"./list-ul.svg": [
		20543,
		[
			20543
		]
	],
	"./list.svg": [
		81939,
		[
			81939
		]
	],
	"./litecoin-sign.svg": [
		42182,
		[
			42182
		]
	],
	"./loader.svg": [
		30070,
		[
			30070
		]
	],
	"./lobster.svg": [
		3666,
		[
			3666
		]
	],
	"./location-arrow-slash.svg": [
		61134,
		[
			61134
		]
	],
	"./location-arrow-up.svg": [
		37560,
		[
			37560
		]
	],
	"./location-arrow.svg": [
		66846,
		[
			66846
		]
	],
	"./location-check.svg": [
		85385,
		[
			85385
		]
	],
	"./location-circle.svg": [
		22775,
		[
			22775
		]
	],
	"./location-crosshairs-slash.svg": [
		33940,
		[
			33940
		]
	],
	"./location-crosshairs.svg": [
		99612,
		[
			99612
		]
	],
	"./location-dot-slash.svg": [
		34444,
		[
			12063
		]
	],
	"./location-dot.svg": [
		80996,
		[
			80996
		]
	],
	"./location-exclamation.svg": [
		17966,
		[
			17966
		]
	],
	"./location-minus.svg": [
		40337,
		[
			40337
		]
	],
	"./location-pen.svg": [
		30495,
		[
			52876
		]
	],
	"./location-pin-lock.svg": [
		65160,
		[
			65160
		]
	],
	"./location-pin-slash.svg": [
		28928,
		[
			28928
		]
	],
	"./location-pin.svg": [
		50040,
		[
			50040
		]
	],
	"./location-plus.svg": [
		46784,
		[
			46784
		]
	],
	"./location-question.svg": [
		58219,
		[
			58219
		]
	],
	"./location-slash.svg": [
		83274,
		[
			83274
		]
	],
	"./location-smile.svg": [
		92017,
		[
			92017
		]
	],
	"./location-xmark.svg": [
		2850,
		[
			2850
		]
	],
	"./location.svg": [
		34090,
		[
			34090
		]
	],
	"./lock-a.svg": [
		46988,
		[
			46988
		]
	],
	"./lock-alt.svg": [
		8988,
		[
			8988
		]
	],
	"./lock-hashtag.svg": [
		10933,
		[
			10933
		]
	],
	"./lock-keyhole-open.svg": [
		78671,
		[
			78671
		]
	],
	"./lock-keyhole.svg": [
		64794,
		[
			64794
		]
	],
	"./lock-open-alt.svg": [
		37373,
		[
			37373
		]
	],
	"./lock-open.svg": [
		13315,
		[
			13315
		]
	],
	"./lock.svg": [
		63654,
		[
			63654
		]
	],
	"./locust.svg": [
		84293,
		[
			84293
		]
	],
	"./lollipop.svg": [
		49758,
		[
			49758
		]
	],
	"./lollypop.svg": [
		86734,
		[
			86734
		]
	],
	"./long-arrow-alt-down.svg": [
		52044,
		[
			52044
		]
	],
	"./long-arrow-alt-left.svg": [
		11080,
		[
			88699
		]
	],
	"./long-arrow-alt-right.svg": [
		382,
		[
			382
		]
	],
	"./long-arrow-alt-up.svg": [
		36583,
		[
			36583
		]
	],
	"./long-arrow-down.svg": [
		95242,
		[
			95242
		]
	],
	"./long-arrow-left.svg": [
		4065,
		[
			4065
		]
	],
	"./long-arrow-right.svg": [
		33804,
		[
			33804
		]
	],
	"./long-arrow-up.svg": [
		2489,
		[
			2489
		]
	],
	"./loveseat.svg": [
		93292,
		[
			93292
		]
	],
	"./low-vision.svg": [
		54300,
		[
			54300
		]
	],
	"./luchador-mask.svg": [
		67556,
		[
			67556
		]
	],
	"./luchador.svg": [
		11019,
		[
			11019
		]
	],
	"./luggage-cart.svg": [
		70752,
		[
			70752
		]
	],
	"./lungs-virus.svg": [
		75910,
		[
			53529
		]
	],
	"./lungs.svg": [
		3162,
		[
			3162
		]
	],
	"./lychee.svg": [
		87445,
		[
			87445
		]
	],
	"./m.svg": [
		97616,
		[
			97616
		]
	],
	"./mace.svg": [
		76045,
		[
			76045
		]
	],
	"./magic-wand-sparkles.svg": [
		98745,
		[
			98745
		]
	],
	"./magic.svg": [
		70580,
		[
			70580
		]
	],
	"./magnet.svg": [
		96293,
		[
			96293
		]
	],
	"./magnifying-glass-arrow-right.svg": [
		42986,
		[
			42986
		]
	],
	"./magnifying-glass-arrows-rotate.svg": [
		82450,
		[
			82450
		]
	],
	"./magnifying-glass-chart.svg": [
		74480,
		[
			74480
		]
	],
	"./magnifying-glass-dollar.svg": [
		45266,
		[
			45266
		]
	],
	"./magnifying-glass-location.svg": [
		34013,
		[
			34013
		]
	],
	"./magnifying-glass-minus.svg": [
		82496,
		[
			82496
		]
	],
	"./magnifying-glass-music.svg": [
		89353,
		[
			89353
		]
	],
	"./magnifying-glass-play.svg": [
		25718,
		[
			25718
		]
	],
	"./magnifying-glass-plus.svg": [
		69608,
		[
			69608
		]
	],
	"./magnifying-glass-waveform.svg": [
		18017,
		[
			18017
		]
	],
	"./magnifying-glass.svg": [
		77151,
		[
			77151
		]
	],
	"./mail-bulk.svg": [
		5347,
		[
			5347
		]
	],
	"./mail-forward.svg": [
		42058,
		[
			42058
		]
	],
	"./mail-reply-all.svg": [
		14851,
		[
			14851
		]
	],
	"./mail-reply.svg": [
		27977,
		[
			27977
		]
	],
	"./mailbox-flag-up.svg": [
		35594,
		[
			35594
		]
	],
	"./mailbox-open-empty.svg": [
		73282,
		[
			73282
		]
	],
	"./mailbox-open-letter.svg": [
		36591,
		[
			36591
		]
	],
	"./mailbox.svg": [
		90337,
		[
			90337
		]
	],
	"./maki-roll.svg": [
		52607,
		[
			52607
		]
	],
	"./makizushi.svg": [
		95456,
		[
			95456
		]
	],
	"./malaysian-ringgit-sign.svg": [
		59869,
		[
			59869
		]
	],
	"./male.svg": [
		20424,
		[
			20424
		]
	],
	"./manat-sign.svg": [
		5244,
		[
			5244
		]
	],
	"./mandolin.svg": [
		72063,
		[
			72063
		]
	],
	"./mango.svg": [
		17223,
		[
			17223
		]
	],
	"./manhole.svg": [
		73563,
		[
			73563
		]
	],
	"./map-location-dot.svg": [
		66771,
		[
			66771
		]
	],
	"./map-location.svg": [
		77257,
		[
			77257
		]
	],
	"./map-marked-alt.svg": [
		39018,
		[
			39018
		]
	],
	"./map-marked.svg": [
		48940,
		[
			48940
		]
	],
	"./map-marker-alt-slash.svg": [
		82984,
		[
			82984
		]
	],
	"./map-marker-alt.svg": [
		11024,
		[
			11024
		]
	],
	"./map-marker-check.svg": [
		19905,
		[
			19905
		]
	],
	"./map-marker-edit.svg": [
		92015,
		[
			92015
		]
	],
	"./map-marker-exclamation.svg": [
		6950,
		[
			6950
		]
	],
	"./map-marker-minus.svg": [
		9977,
		[
			9977
		]
	],
	"./map-marker-plus.svg": [
		50155,
		[
			50155
		]
	],
	"./map-marker-question.svg": [
		81507,
		[
			81507
		]
	],
	"./map-marker-slash.svg": [
		79170,
		[
			79170
		]
	],
	"./map-marker-smile.svg": [
		22937,
		[
			22937
		]
	],
	"./map-marker-times.svg": [
		9195,
		[
			9195
		]
	],
	"./map-marker-xmark.svg": [
		81610,
		[
			81610
		]
	],
	"./map-marker.svg": [
		46514,
		[
			46514
		]
	],
	"./map-pin.svg": [
		65321,
		[
			65321
		]
	],
	"./map-signs.svg": [
		10006,
		[
			10006
		]
	],
	"./map.svg": [
		92355,
		[
			92355
		]
	],
	"./marker.svg": [
		75453,
		[
			75453
		]
	],
	"./mars-and-venus-burst.svg": [
		89985,
		[
			89985
		]
	],
	"./mars-and-venus.svg": [
		17376,
		[
			17376
		]
	],
	"./mars-double.svg": [
		50902,
		[
			50902
		]
	],
	"./mars-stroke-h.svg": [
		49566,
		[
			49566
		]
	],
	"./mars-stroke-right.svg": [
		33588,
		[
			33588
		]
	],
	"./mars-stroke-up.svg": [
		34161,
		[
			34161
		]
	],
	"./mars-stroke-v.svg": [
		32024,
		[
			32024
		]
	],
	"./mars-stroke.svg": [
		76629,
		[
			76629
		]
	],
	"./mars.svg": [
		90896,
		[
			90896
		]
	],
	"./martini-glass-citrus.svg": [
		88211,
		[
			88211
		]
	],
	"./martini-glass-empty.svg": [
		10248,
		[
			10248
		]
	],
	"./martini-glass.svg": [
		50052,
		[
			50052
		]
	],
	"./mask-face.svg": [
		83119,
		[
			83119
		]
	],
	"./mask-luchador.svg": [
		78640,
		[
			78640
		]
	],
	"./mask-snorkel.svg": [
		2312,
		[
			2312
		]
	],
	"./mask-ventilator.svg": [
		73326,
		[
			73326
		]
	],
	"./mask.svg": [
		73019,
		[
			73019
		]
	],
	"./masks-theater.svg": [
		97330,
		[
			97330
		]
	],
	"./mattress-pillow.svg": [
		66086,
		[
			66086
		]
	],
	"./maximize.svg": [
		26005,
		[
			26005
		]
	],
	"./meat.svg": [
		33974,
		[
			33974
		]
	],
	"./medal.svg": [
		50932,
		[
			50932
		]
	],
	"./medkit.svg": [
		74977,
		[
			74977
		]
	],
	"./megaphone.svg": [
		33123,
		[
			33123
		]
	],
	"./meh-blank.svg": [
		81578,
		[
			81578
		]
	],
	"./meh-rolling-eyes.svg": [
		45382,
		[
			45382
		]
	],
	"./meh.svg": [
		48831,
		[
			48831
		]
	],
	"./melon-slice.svg": [
		33345,
		[
			33345
		]
	],
	"./melon.svg": [
		20132,
		[
			20132
		]
	],
	"./memo-circle-check.svg": [
		66101,
		[
			66101
		]
	],
	"./memo-circle-info.svg": [
		12927,
		[
			12927
		]
	],
	"./memo-pad.svg": [
		43761,
		[
			43761
		]
	],
	"./memo.svg": [
		80073,
		[
			80073
		]
	],
	"./memory.svg": [
		14818,
		[
			14818
		]
	],
	"./menorah.svg": [
		19473,
		[
			19473
		]
	],
	"./mercury.svg": [
		60946,
		[
			60946
		]
	],
	"./merge.svg": [
		877,
		[
			877
		]
	],
	"./message-arrow-down.svg": [
		49177,
		[
			49177
		]
	],
	"./message-arrow-up-right.svg": [
		1487,
		[
			1487
		]
	],
	"./message-arrow-up.svg": [
		31062,
		[
			31062
		]
	],
	"./message-bot.svg": [
		79424,
		[
			79424
		]
	],
	"./message-captions.svg": [
		28576,
		[
			28576
		]
	],
	"./message-check.svg": [
		81503,
		[
			81503
		]
	],
	"./message-code.svg": [
		22678,
		[
			22678
		]
	],
	"./message-dollar.svg": [
		16727,
		[
			16727
		]
	],
	"./message-dot.svg": [
		21274,
		[
			21274
		]
	],
	"./message-dots.svg": [
		93221,
		[
			93221
		]
	],
	"./message-edit.svg": [
		66733,
		[
			66733
		]
	],
	"./message-exclamation.svg": [
		59788,
		[
			59788
		]
	],
	"./message-heart.svg": [
		57787,
		[
			57787
		]
	],
	"./message-image.svg": [
		20760,
		[
			20760
		]
	],
	"./message-lines.svg": [
		18474,
		[
			18474
		]
	],
	"./message-medical.svg": [
		57646,
		[
			57646
		]
	],
	"./message-middle-top.svg": [
		94424,
		[
			94424
		]
	],
	"./message-middle.svg": [
		63674,
		[
			63674
		]
	],
	"./message-minus.svg": [
		28291,
		[
			28291
		]
	],
	"./message-music.svg": [
		26810,
		[
			26810
		]
	],
	"./message-pen.svg": [
		90586,
		[
			90586
		]
	],
	"./message-plus.svg": [
		13957,
		[
			13957
		]
	],
	"./message-question.svg": [
		36101,
		[
			36101
		]
	],
	"./message-quote.svg": [
		9887,
		[
			9887
		]
	],
	"./message-slash.svg": [
		83444,
		[
			83444
		]
	],
	"./message-smile.svg": [
		26703,
		[
			26703
		]
	],
	"./message-sms.svg": [
		75644,
		[
			75644
		]
	],
	"./message-text.svg": [
		24356,
		[
			24356
		]
	],
	"./message-times.svg": [
		37654,
		[
			37654
		]
	],
	"./message-waveform.svg": [
		43140,
		[
			43140
		]
	],
	"./message-xmark.svg": [
		80500,
		[
			80500
		]
	],
	"./message.svg": [
		16124,
		[
			16124
		]
	],
	"./messages-dollar.svg": [
		65178,
		[
			65178
		]
	],
	"./messages-question.svg": [
		70060,
		[
			70060
		]
	],
	"./messages.svg": [
		32279,
		[
			32279
		]
	],
	"./messaging.svg": [
		60925,
		[
			60925
		]
	],
	"./meteor.svg": [
		91179,
		[
			91179
		]
	],
	"./meter-bolt.svg": [
		95538,
		[
			95538
		]
	],
	"./meter-droplet.svg": [
		57531,
		[
			57531
		]
	],
	"./meter-fire.svg": [
		80419,
		[
			80419
		]
	],
	"./meter.svg": [
		64566,
		[
			64566
		]
	],
	"./microchip-ai.svg": [
		15046,
		[
			15046
		]
	],
	"./microchip.svg": [
		93651,
		[
			93651
		]
	],
	"./microphone-alt-slash.svg": [
		94801,
		[
			94801
		]
	],
	"./microphone-alt.svg": [
		3765,
		[
			3765
		]
	],
	"./microphone-circle-alt.svg": [
		37998,
		[
			37998
		]
	],
	"./microphone-circle-plus.svg": [
		47153,
		[
			47153
		]
	],
	"./microphone-circle-xmark.svg": [
		88240,
		[
			88240
		]
	],
	"./microphone-circle.svg": [
		23000,
		[
			23000
		]
	],
	"./microphone-lines-slash.svg": [
		13657,
		[
			13657
		]
	],
	"./microphone-lines.svg": [
		28397,
		[
			28397
		]
	],
	"./microphone-signal-meter.svg": [
		80212,
		[
			80212
		]
	],
	"./microphone-slash.svg": [
		35703,
		[
			35703
		]
	],
	"./microphone-stand.svg": [
		79140,
		[
			79140
		]
	],
	"./microphone.svg": [
		99355,
		[
			99355
		]
	],
	"./microscope.svg": [
		72099,
		[
			72099
		]
	],
	"./microwave.svg": [
		44702,
		[
			44702
		]
	],
	"./midi.svg": [
		6380,
		[
			6380
		]
	],
	"./mill-sign.svg": [
		48829,
		[
			48829
		]
	],
	"./mind-share.svg": [
		7325,
		[
			7325
		]
	],
	"./minimize.svg": [
		863,
		[
			863
		]
	],
	"./minus-circle.svg": [
		30690,
		[
			30690
		]
	],
	"./minus-hexagon.svg": [
		30310,
		[
			30310
		]
	],
	"./minus-large.svg": [
		41267,
		[
			41267
		]
	],
	"./minus-octagon.svg": [
		16771,
		[
			16771
		]
	],
	"./minus-square.svg": [
		25607,
		[
			25607
		]
	],
	"./minus.svg": [
		20021,
		[
			20021
		]
	],
	"./mistletoe.svg": [
		28815,
		[
			28815
		]
	],
	"./mitten.svg": [
		64428,
		[
			64428
		]
	],
	"./mobile-alt.svg": [
		18471,
		[
			18471
		]
	],
	"./mobile-android-alt.svg": [
		13873,
		[
			13873
		]
	],
	"./mobile-android.svg": [
		22815,
		[
			22815
		]
	],
	"./mobile-arrow-down.svg": [
		36966,
		[
			36966
		]
	],
	"./mobile-button.svg": [
		19010,
		[
			19010
		]
	],
	"./mobile-iphone.svg": [
		57493,
		[
			57493
		]
	],
	"./mobile-notch.svg": [
		78696,
		[
			78696
		]
	],
	"./mobile-phone.svg": [
		91794,
		[
			91794
		]
	],
	"./mobile-retro.svg": [
		6290,
		[
			6290
		]
	],
	"./mobile-rotate-reverse.svg": [
		906,
		[
			906
		]
	],
	"./mobile-rotate.svg": [
		34543,
		[
			34543
		]
	],
	"./mobile-screen-button.svg": [
		85432,
		[
			85432
		]
	],
	"./mobile-screen.svg": [
		96345,
		[
			96345
		]
	],
	"./mobile-signal-out.svg": [
		23409,
		[
			23409
		]
	],
	"./mobile-signal.svg": [
		74570,
		[
			74570
		]
	],
	"./mobile-slash.svg": [
		38729,
		[
			38729
		]
	],
	"./mobile-vibrate-slash.svg": [
		30903,
		[
			30903
		]
	],
	"./mobile-vibrate.svg": [
		30395,
		[
			30395
		]
	],
	"./mobile.svg": [
		84733,
		[
			84733
		]
	],
	"./money-bill-1-wave.svg": [
		41051,
		[
			41051
		]
	],
	"./money-bill-1.svg": [
		76551,
		[
			76551
		]
	],
	"./money-bill-alt.svg": [
		49807,
		[
			49807
		]
	],
	"./money-bill-simple-wave.svg": [
		42118,
		[
			42118
		]
	],
	"./money-bill-simple.svg": [
		72903,
		[
			95284
		]
	],
	"./money-bill-transfer.svg": [
		23103,
		[
			23103
		]
	],
	"./money-bill-trend-up.svg": [
		51083,
		[
			51083
		]
	],
	"./money-bill-wave-alt.svg": [
		57916,
		[
			57916
		]
	],
	"./money-bill-wave.svg": [
		87205,
		[
			87205
		]
	],
	"./money-bill-wheat.svg": [
		93611,
		[
			93611
		]
	],
	"./money-bill.svg": [
		37829,
		[
			37829
		]
	],
	"./money-bills-alt.svg": [
		37258,
		[
			37258
		]
	],
	"./money-bills-simple.svg": [
		21147,
		[
			21147
		]
	],
	"./money-bills.svg": [
		67788,
		[
			67788
		]
	],
	"./money-check-alt.svg": [
		45560,
		[
			45560
		]
	],
	"./money-check-dollar-pen.svg": [
		99095,
		[
			99095
		]
	],
	"./money-check-dollar.svg": [
		1361,
		[
			1361
		]
	],
	"./money-check-edit-alt.svg": [
		7385,
		[
			7385
		]
	],
	"./money-check-edit.svg": [
		88039,
		[
			88039
		]
	],
	"./money-check-pen.svg": [
		38876,
		[
			38876
		]
	],
	"./money-check.svg": [
		84346,
		[
			84346
		]
	],
	"./money-from-bracket.svg": [
		94545,
		[
			94545
		]
	],
	"./money-simple-from-bracket.svg": [
		4522,
		[
			4522
		]
	],
	"./monitor-heart-rate.svg": [
		8687,
		[
			8687
		]
	],
	"./monitor-waveform.svg": [
		80714,
		[
			80714
		]
	],
	"./monkey.svg": [
		5424,
		[
			5424
		]
	],
	"./monument.svg": [
		46920,
		[
			46920
		]
	],
	"./moon-cloud.svg": [
		99628,
		[
			99628
		]
	],
	"./moon-over-sun.svg": [
		92082,
		[
			92082
		]
	],
	"./moon-star.svg": [
		2801,
		[
			2801
		]
	],
	"./moon-stars.svg": [
		37856,
		[
			37856
		]
	],
	"./moon.svg": [
		39512,
		[
			39512
		]
	],
	"./moped.svg": [
		84322,
		[
			84322
		]
	],
	"./mortar-board.svg": [
		68779,
		[
			68779
		]
	],
	"./mortar-pestle.svg": [
		14400,
		[
			14400
		]
	],
	"./mosque.svg": [
		95049,
		[
			95049
		]
	],
	"./mosquito-net.svg": [
		9576,
		[
			9576
		]
	],
	"./mosquito.svg": [
		53910,
		[
			53910
		]
	],
	"./motorcycle.svg": [
		3988,
		[
			3988
		]
	],
	"./mound.svg": [
		15281,
		[
			37662
		]
	],
	"./mountain-city.svg": [
		94366,
		[
			94366
		]
	],
	"./mountain-sun.svg": [
		64603,
		[
			64603
		]
	],
	"./mountain.svg": [
		28134,
		[
			28134
		]
	],
	"./mountains.svg": [
		14393,
		[
			14393
		]
	],
	"./mouse-alt.svg": [
		6026,
		[
			6026
		]
	],
	"./mouse-field.svg": [
		56167,
		[
			56167
		]
	],
	"./mouse-pointer.svg": [
		19928,
		[
			19928
		]
	],
	"./mouse.svg": [
		55436,
		[
			55436
		]
	],
	"./mp3-player.svg": [
		73320,
		[
			73320
		]
	],
	"./mug-hot.svg": [
		34474,
		[
			34474
		]
	],
	"./mug-marshmallows.svg": [
		18037,
		[
			18037
		]
	],
	"./mug-saucer.svg": [
		12956,
		[
			12956
		]
	],
	"./mug-tea-saucer.svg": [
		15439,
		[
			15439
		]
	],
	"./mug-tea.svg": [
		95829,
		[
			95829
		]
	],
	"./mug.svg": [
		18472,
		[
			18472
		]
	],
	"./multiply.svg": [
		67271,
		[
			67271
		]
	],
	"./museum.svg": [
		67143,
		[
			67143
		]
	],
	"./mushroom.svg": [
		33549,
		[
			33549
		]
	],
	"./music-alt-slash.svg": [
		6042,
		[
			6042
		]
	],
	"./music-alt.svg": [
		5850,
		[
			5850
		]
	],
	"./music-magnifying-glass.svg": [
		98017,
		[
			98017
		]
	],
	"./music-note-slash.svg": [
		98077,
		[
			98077
		]
	],
	"./music-note.svg": [
		95617,
		[
			95617
		]
	],
	"./music-slash.svg": [
		34196,
		[
			34196
		]
	],
	"./music.svg": [
		85820,
		[
			85820
		]
	],
	"./mustache.svg": [
		95989,
		[
			95989
		]
	],
	"./n.svg": [
		80067,
		[
			80067
		]
	],
	"./naira-sign.svg": [
		8832,
		[
			8832
		]
	],
	"./narwhal.svg": [
		36780,
		[
			36780
		]
	],
	"./navicon.svg": [
		53589,
		[
			53589
		]
	],
	"./nesting-dolls.svg": [
		61522,
		[
			61522
		]
	],
	"./network-wired.svg": [
		25041,
		[
			25041
		]
	],
	"./neuter.svg": [
		71490,
		[
			71490
		]
	],
	"./newspaper.svg": [
		9536,
		[
			9536
		]
	],
	"./nfc-lock.svg": [
		99694,
		[
			99694
		]
	],
	"./nfc-magnifying-glass.svg": [
		16503,
		[
			16503
		]
	],
	"./nfc-pen.svg": [
		21312,
		[
			21312
		]
	],
	"./nfc-signal.svg": [
		73139,
		[
			73139
		]
	],
	"./nfc-slash.svg": [
		8214,
		[
			8214
		]
	],
	"./nfc-symbol.svg": [
		83867,
		[
			83867
		]
	],
	"./nfc-trash.svg": [
		57935,
		[
			57935
		]
	],
	"./nfc.svg": [
		77558,
		[
			77558
		]
	],
	"./nigiri.svg": [
		98219,
		[
			98219
		]
	],
	"./non-binary.svg": [
		63970,
		[
			63970
		]
	],
	"./norwegian-krone-sign.svg": [
		28703,
		[
			28703
		]
	],
	"./nose.svg": [
		58846,
		[
			58846
		]
	],
	"./not-equal.svg": [
		80933,
		[
			80933
		]
	],
	"./notdef.svg": [
		27379,
		[
			27379
		]
	],
	"./note-medical.svg": [
		71773,
		[
			71773
		]
	],
	"./note-sticky.svg": [
		62897,
		[
			62897
		]
	],
	"./note.svg": [
		35023,
		[
			35023
		]
	],
	"./notebook.svg": [
		90024,
		[
			90024
		]
	],
	"./notes-medical.svg": [
		83012,
		[
			83012
		]
	],
	"./notes-sticky.svg": [
		94254,
		[
			94254
		]
	],
	"./notes.svg": [
		30990,
		[
			30990
		]
	],
	"./o.svg": [
		30674,
		[
			30674
		]
	],
	"./object-exclude.svg": [
		21371,
		[
			21371
		]
	],
	"./object-group.svg": [
		1044,
		[
			1044
		]
	],
	"./object-intersect.svg": [
		84282,
		[
			84282
		]
	],
	"./object-subtract.svg": [
		29923,
		[
			29923
		]
	],
	"./object-ungroup.svg": [
		22303,
		[
			22303
		]
	],
	"./object-union.svg": [
		15244,
		[
			15244
		]
	],
	"./objects-align-bottom.svg": [
		68571,
		[
			68571
		]
	],
	"./objects-align-center-horizontal.svg": [
		24590,
		[
			24590
		]
	],
	"./objects-align-center-vertical.svg": [
		68916,
		[
			68916
		]
	],
	"./objects-align-left.svg": [
		42413,
		[
			42413
		]
	],
	"./objects-align-right.svg": [
		66544,
		[
			66544
		]
	],
	"./objects-align-top.svg": [
		67023,
		[
			67023
		]
	],
	"./objects-column.svg": [
		39336,
		[
			39336
		]
	],
	"./octagon-check.svg": [
		51587,
		[
			51587
		]
	],
	"./octagon-divide.svg": [
		32394,
		[
			32394
		]
	],
	"./octagon-equals.svg": [
		82582,
		[
			82582
		]
	],
	"./octagon-exclamation.svg": [
		90424,
		[
			90424
		]
	],
	"./octagon-minus.svg": [
		48567,
		[
			48567
		]
	],
	"./octagon-plus.svg": [
		40281,
		[
			40281
		]
	],
	"./octagon-xmark.svg": [
		32584,
		[
			32584
		]
	],
	"./octagon.svg": [
		68880,
		[
			68880
		]
	],
	"./octopus.svg": [
		82642,
		[
			82642
		]
	],
	"./oil-can-drip.svg": [
		83992,
		[
			83992
		]
	],
	"./oil-can.svg": [
		31648,
		[
			31648
		]
	],
	"./oil-temp.svg": [
		992,
		[
			992
		]
	],
	"./oil-temperature.svg": [
		8512,
		[
			8512
		]
	],
	"./oil-well.svg": [
		90082,
		[
			90082
		]
	],
	"./olive-branch.svg": [
		10145,
		[
			10145
		]
	],
	"./olive.svg": [
		89444,
		[
			89444
		]
	],
	"./om.svg": [
		60168,
		[
			60168
		]
	],
	"./omega.svg": [
		87120,
		[
			87120
		]
	],
	"./onion.svg": [
		30858,
		[
			30858
		]
	],
	"./open-captioning.svg": [
		13734,
		[
			13734
		]
	],
	"./option.svg": [
		80940,
		[
			80940
		]
	],
	"./ornament.svg": [
		20423,
		[
			20423
		]
	],
	"./otter.svg": [
		97339,
		[
			97339
		]
	],
	"./outdent.svg": [
		76218,
		[
			76218
		]
	],
	"./outlet.svg": [
		42504,
		[
			42504
		]
	],
	"./oven.svg": [
		81025,
		[
			81025
		]
	],
	"./overline.svg": [
		98623,
		[
			98623
		]
	],
	"./p.svg": [
		73285,
		[
			73285
		]
	],
	"./page-break.svg": [
		21532,
		[
			21532
		]
	],
	"./page-caret-down.svg": [
		73541,
		[
			73541
		]
	],
	"./page-caret-up.svg": [
		22474,
		[
			22474
		]
	],
	"./page.svg": [
		62474,
		[
			40093
		]
	],
	"./pager.svg": [
		53095,
		[
			75476
		]
	],
	"./paint-brush-alt.svg": [
		27252,
		[
			27252
		]
	],
	"./paint-brush-fine.svg": [
		35423,
		[
			35423
		]
	],
	"./paint-brush.svg": [
		17438,
		[
			17438
		]
	],
	"./paint-roller.svg": [
		55194,
		[
			55194
		]
	],
	"./paintbrush-alt.svg": [
		16461,
		[
			16461
		]
	],
	"./paintbrush-fine-slash.svg": [
		33012,
		[
			33012
		]
	],
	"./paintbrush-fine.svg": [
		58268,
		[
			58268
		]
	],
	"./paintbrush-pencil.svg": [
		54947,
		[
			54947
		]
	],
	"./paintbrush-slash.svg": [
		23231,
		[
			23231
		]
	],
	"./paintbrush.svg": [
		66163,
		[
			66163
		]
	],
	"./palette-boxes.svg": [
		2804,
		[
			2804
		]
	],
	"./palette.svg": [
		62200,
		[
			62200
		]
	],
	"./pallet-alt.svg": [
		83251,
		[
			83251
		]
	],
	"./pallet-box.svg": [
		36181,
		[
			36181
		]
	],
	"./pallet-boxes.svg": [
		13693,
		[
			13693
		]
	],
	"./pallet.svg": [
		34257,
		[
			34257
		]
	],
	"./pan-food.svg": [
		94161,
		[
			94161
		]
	],
	"./pan-frying.svg": [
		3946,
		[
			3946
		]
	],
	"./pancakes.svg": [
		39011,
		[
			39011
		]
	],
	"./panel-ews.svg": [
		96395,
		[
			96395
		]
	],
	"./panel-fire.svg": [
		4644,
		[
			4644
		]
	],
	"./panorama.svg": [
		25142,
		[
			25142
		]
	],
	"./panties.svg": [
		63113,
		[
			63113
		]
	],
	"./pants-straight.svg": [
		76182,
		[
			76182
		]
	],
	"./pants.svg": [
		4787,
		[
			4787
		]
	],
	"./paper-plane-alt.svg": [
		71696,
		[
			71696
		]
	],
	"./paper-plane-top.svg": [
		33680,
		[
			33680
		]
	],
	"./paper-plane.svg": [
		74770,
		[
			74770
		]
	],
	"./paperclip-vertical.svg": [
		11004,
		[
			11004
		]
	],
	"./paperclip.svg": [
		7789,
		[
			7789
		]
	],
	"./parachute-box.svg": [
		18668,
		[
			18668
		]
	],
	"./paragraph-left.svg": [
		23183,
		[
			23183
		]
	],
	"./paragraph-rtl.svg": [
		12726,
		[
			12726
		]
	],
	"./paragraph.svg": [
		68971,
		[
			68971
		]
	],
	"./parentheses.svg": [
		22453,
		[
			22453
		]
	],
	"./parenthesis.svg": [
		83489,
		[
			83489
		]
	],
	"./parking-circle-slash.svg": [
		22253,
		[
			44634
		]
	],
	"./parking-circle.svg": [
		62426,
		[
			62426
		]
	],
	"./parking-slash.svg": [
		70873,
		[
			70873
		]
	],
	"./parking.svg": [
		70765,
		[
			70765
		]
	],
	"./party-back.svg": [
		72175,
		[
			72175
		]
	],
	"./party-bell.svg": [
		4105,
		[
			4105
		]
	],
	"./party-horn.svg": [
		29561,
		[
			29561
		]
	],
	"./passport.svg": [
		40425,
		[
			40425
		]
	],
	"./pastafarianism.svg": [
		37890,
		[
			37890
		]
	],
	"./paste.svg": [
		19088,
		[
			19088
		]
	],
	"./pause-circle.svg": [
		91596,
		[
			91596
		]
	],
	"./pause.svg": [
		57583,
		[
			57583
		]
	],
	"./paw-alt.svg": [
		33895,
		[
			33895
		]
	],
	"./paw-claws.svg": [
		34310,
		[
			34310
		]
	],
	"./paw-simple.svg": [
		47484,
		[
			47484
		]
	],
	"./paw.svg": [
		96637,
		[
			96637
		]
	],
	"./peace.svg": [
		9183,
		[
			9183
		]
	],
	"./peach.svg": [
		42426,
		[
			42426
		]
	],
	"./peanut.svg": [
		84408,
		[
			84408
		]
	],
	"./peanuts.svg": [
		12952,
		[
			90571
		]
	],
	"./peapod.svg": [
		99004,
		[
			99004
		]
	],
	"./pear.svg": [
		27903,
		[
			27903
		]
	],
	"./pedestal.svg": [
		71681,
		[
			71681
		]
	],
	"./pegasus.svg": [
		4373,
		[
			4373
		]
	],
	"./pen-alt-slash.svg": [
		51310,
		[
			51310
		]
	],
	"./pen-alt.svg": [
		90046,
		[
			90046
		]
	],
	"./pen-circle.svg": [
		86549,
		[
			86549
		]
	],
	"./pen-clip-slash.svg": [
		61605,
		[
			61605
		]
	],
	"./pen-clip.svg": [
		94419,
		[
			94419
		]
	],
	"./pen-fancy-slash.svg": [
		33944,
		[
			33944
		]
	],
	"./pen-fancy.svg": [
		56032,
		[
			56032
		]
	],
	"./pen-field.svg": [
		18971,
		[
			18971
		]
	],
	"./pen-line.svg": [
		71255,
		[
			71255
		]
	],
	"./pen-nib-slash.svg": [
		41724,
		[
			41724
		]
	],
	"./pen-nib.svg": [
		75924,
		[
			75924
		]
	],
	"./pen-paintbrush.svg": [
		72889,
		[
			72889
		]
	],
	"./pen-ruler.svg": [
		73283,
		[
			73283
		]
	],
	"./pen-slash.svg": [
		14224,
		[
			14224
		]
	],
	"./pen-square.svg": [
		98408,
		[
			98408
		]
	],
	"./pen-swirl.svg": [
		52330,
		[
			52330
		]
	],
	"./pen-to-square.svg": [
		8882,
		[
			8882
		]
	],
	"./pen.svg": [
		61480,
		[
			61480
		]
	],
	"./pencil-alt.svg": [
		25514,
		[
			25514
		]
	],
	"./pencil-line.svg": [
		36627,
		[
			36627
		]
	],
	"./pencil-mechanical.svg": [
		44052,
		[
			44052
		]
	],
	"./pencil-paintbrush.svg": [
		52181,
		[
			52181
		]
	],
	"./pencil-ruler.svg": [
		52999,
		[
			52999
		]
	],
	"./pencil-slash.svg": [
		41028,
		[
			41028
		]
	],
	"./pencil-square.svg": [
		56732,
		[
			56732
		]
	],
	"./pencil.svg": [
		84524,
		[
			84524
		]
	],
	"./pennant.svg": [
		36449,
		[
			36449
		]
	],
	"./pentagon.svg": [
		45179,
		[
			45179
		]
	],
	"./people-arrows-left-right.svg": [
		30172,
		[
			30172
		]
	],
	"./people-arrows.svg": [
		46729,
		[
			46729
		]
	],
	"./people-carry-box.svg": [
		72815,
		[
			95196
		]
	],
	"./people-carry.svg": [
		83492,
		[
			83492
		]
	],
	"./people-dress-simple.svg": [
		25395,
		[
			25395
		]
	],
	"./people-dress.svg": [
		16180,
		[
			16180
		]
	],
	"./people-group.svg": [
		98920,
		[
			98920
		]
	],
	"./people-line.svg": [
		21737,
		[
			21737
		]
	],
	"./people-pants-simple.svg": [
		7310,
		[
			7310
		]
	],
	"./people-pants.svg": [
		87519,
		[
			87519
		]
	],
	"./people-pulling.svg": [
		51098,
		[
			51098
		]
	],
	"./people-robbery.svg": [
		24984,
		[
			24984
		]
	],
	"./people-roof.svg": [
		60833,
		[
			60833
		]
	],
	"./people-simple.svg": [
		25777,
		[
			25777
		]
	],
	"./people.svg": [
		80469,
		[
			80469
		]
	],
	"./pepper-hot.svg": [
		28189,
		[
			28189
		]
	],
	"./pepper.svg": [
		69931,
		[
			69931
		]
	],
	"./percent.svg": [
		66030,
		[
			66030
		]
	],
	"./percentage.svg": [
		65431,
		[
			65431
		]
	],
	"./period.svg": [
		23164,
		[
			23164
		]
	],
	"./person-arms-raised.svg": [
		42129,
		[
			42129
		]
	],
	"./person-arrow-down-to-line.svg": [
		78960,
		[
			78960
		]
	],
	"./person-arrow-up-from-line.svg": [
		33674,
		[
			33674
		]
	],
	"./person-basketball.svg": [
		51496,
		[
			51496
		]
	],
	"./person-biking-mountain.svg": [
		47089,
		[
			47089
		]
	],
	"./person-biking.svg": [
		70255,
		[
			70255
		]
	],
	"./person-booth.svg": [
		74155,
		[
			74155
		]
	],
	"./person-breastfeeding.svg": [
		21146,
		[
			21146
		]
	],
	"./person-burst.svg": [
		89897,
		[
			89897
		]
	],
	"./person-cane.svg": [
		76238,
		[
			76238
		]
	],
	"./person-carry-box.svg": [
		25542,
		[
			25542
		]
	],
	"./person-carry-empty.svg": [
		81538,
		[
			81538
		]
	],
	"./person-carry.svg": [
		39150,
		[
			39150
		]
	],
	"./person-chalkboard.svg": [
		81562,
		[
			81562
		]
	],
	"./person-circle-check.svg": [
		48634,
		[
			48634
		]
	],
	"./person-circle-exclamation.svg": [
		55261,
		[
			55261
		]
	],
	"./person-circle-minus.svg": [
		20550,
		[
			20550
		]
	],
	"./person-circle-plus.svg": [
		70465,
		[
			92846
		]
	],
	"./person-circle-question.svg": [
		4746,
		[
			4746
		]
	],
	"./person-circle-xmark.svg": [
		94969,
		[
			94969
		]
	],
	"./person-digging.svg": [
		84926,
		[
			84926
		]
	],
	"./person-dolly-empty.svg": [
		83095,
		[
			83095
		]
	],
	"./person-dolly.svg": [
		41763,
		[
			41763
		]
	],
	"./person-dots-from-line.svg": [
		34153,
		[
			34153
		]
	],
	"./person-dress-burst.svg": [
		84963,
		[
			84963
		]
	],
	"./person-dress-fairy.svg": [
		12258,
		[
			12258
		]
	],
	"./person-dress-simple.svg": [
		81922,
		[
			81922
		]
	],
	"./person-dress.svg": [
		45566,
		[
			45566
		]
	],
	"./person-drowning.svg": [
		88959,
		[
			88959
		]
	],
	"./person-fairy.svg": [
		15924,
		[
			15924
		]
	],
	"./person-falling-burst.svg": [
		56067,
		[
			56067
		]
	],
	"./person-falling.svg": [
		87134,
		[
			87134
		]
	],
	"./person-from-portal.svg": [
		11360,
		[
			11360
		]
	],
	"./person-golfing.svg": [
		61323,
		[
			61323
		]
	],
	"./person-half-dress.svg": [
		42472,
		[
			42472
		]
	],
	"./person-harassing.svg": [
		12627,
		[
			12627
		]
	],
	"./person-hiking.svg": [
		40321,
		[
			40321
		]
	],
	"./person-limbs-wide.svg": [
		70708,
		[
			70708
		]
	],
	"./person-meditating.svg": [
		77379,
		[
			77379
		]
	],
	"./person-military-pointing.svg": [
		34695,
		[
			34695
		]
	],
	"./person-military-rifle.svg": [
		54409,
		[
			54409
		]
	],
	"./person-military-to-person.svg": [
		56268,
		[
			56268
		]
	],
	"./person-pinball.svg": [
		36421,
		[
			36421
		]
	],
	"./person-praying.svg": [
		2603,
		[
			2603
		]
	],
	"./person-pregnant.svg": [
		94318,
		[
			94318
		]
	],
	"./person-rays.svg": [
		16482,
		[
			16482
		]
	],
	"./person-rifle.svg": [
		63925,
		[
			63925
		]
	],
	"./person-running-fast.svg": [
		75313,
		[
			75313
		]
	],
	"./person-running.svg": [
		29514,
		[
			29514
		]
	],
	"./person-seat-reclined.svg": [
		55123,
		[
			55123
		]
	],
	"./person-seat-window.svg": [
		96187,
		[
			96187
		]
	],
	"./person-seat.svg": [
		6002,
		[
			6002
		]
	],
	"./person-shelter.svg": [
		47272,
		[
			47272
		]
	],
	"./person-sign.svg": [
		83398,
		[
			83398
		]
	],
	"./person-simple.svg": [
		17647,
		[
			17647
		]
	],
	"./person-skating.svg": [
		93944,
		[
			93944
		]
	],
	"./person-ski-jumping.svg": [
		7651,
		[
			7651
		]
	],
	"./person-ski-lift.svg": [
		29754,
		[
			29754
		]
	],
	"./person-skiing-nordic.svg": [
		98350,
		[
			98350
		]
	],
	"./person-skiing.svg": [
		49964,
		[
			49964
		]
	],
	"./person-sledding.svg": [
		90811,
		[
			90811
		]
	],
	"./person-snowboarding.svg": [
		98724,
		[
			98724
		]
	],
	"./person-snowmobiling.svg": [
		77387,
		[
			77387
		]
	],
	"./person-soccer.svg": [
		3028,
		[
			3028
		]
	],
	"./person-swimming-pool.svg": [
		24409,
		[
			24409
		]
	],
	"./person-swimming-water.svg": [
		91304,
		[
			91304
		]
	],
	"./person-swimming.svg": [
		68142,
		[
			68142
		]
	],
	"./person-through-window.svg": [
		1681,
		[
			1681
		]
	],
	"./person-to-door.svg": [
		26371,
		[
			26371
		]
	],
	"./person-to-portal.svg": [
		64713,
		[
			64713
		]
	],
	"./person-walking-arrow-loop-left.svg": [
		85101,
		[
			85101
		]
	],
	"./person-walking-arrow-right.svg": [
		86943,
		[
			86943
		]
	],
	"./person-walking-dashed-line-arrow-right.svg": [
		80570,
		[
			80570
		]
	],
	"./person-walking-luggage.svg": [
		87501,
		[
			87501
		]
	],
	"./person-walking-with-cane.svg": [
		50663,
		[
			50663
		]
	],
	"./person-walking.svg": [
		56530,
		[
			56530
		]
	],
	"./person-water-arms-raised.svg": [
		70355,
		[
			70355
		]
	],
	"./person-waving.svg": [
		35787,
		[
			35787
		]
	],
	"./person.svg": [
		81368,
		[
			81368
		]
	],
	"./peruvian-soles-sign.svg": [
		62564,
		[
			62564
		]
	],
	"./peseta-sign.svg": [
		52411,
		[
			52411
		]
	],
	"./peso-sign.svg": [
		53950,
		[
			53950
		]
	],
	"./phone-alt.svg": [
		38815,
		[
			38815
		]
	],
	"./phone-arrow-down-left.svg": [
		23032,
		[
			23032
		]
	],
	"./phone-arrow-down.svg": [
		15710,
		[
			15710
		]
	],
	"./phone-arrow-right.svg": [
		60536,
		[
			60536
		]
	],
	"./phone-arrow-up-right.svg": [
		6260,
		[
			6260
		]
	],
	"./phone-arrow-up.svg": [
		66837,
		[
			66837
		]
	],
	"./phone-circle-alt.svg": [
		60736,
		[
			60736
		]
	],
	"./phone-circle-down.svg": [
		79707,
		[
			79707
		]
	],
	"./phone-circle.svg": [
		13026,
		[
			13026
		]
	],
	"./phone-connection.svg": [
		96246,
		[
			96246
		]
	],
	"./phone-flip.svg": [
		27383,
		[
			27383
		]
	],
	"./phone-hangup.svg": [
		50217,
		[
			50217
		]
	],
	"./phone-incoming.svg": [
		13930,
		[
			13930
		]
	],
	"./phone-intercom.svg": [
		62435,
		[
			62435
		]
	],
	"./phone-laptop.svg": [
		36378,
		[
			36378
		]
	],
	"./phone-missed.svg": [
		91645,
		[
			91645
		]
	],
	"./phone-office.svg": [
		71674,
		[
			71674
		]
	],
	"./phone-outgoing.svg": [
		31672,
		[
			31672
		]
	],
	"./phone-plus.svg": [
		82718,
		[
			82718
		]
	],
	"./phone-rotary.svg": [
		18641,
		[
			18641
		]
	],
	"./phone-slash.svg": [
		25681,
		[
			25681
		]
	],
	"./phone-square-alt.svg": [
		57433,
		[
			57433
		]
	],
	"./phone-square-down.svg": [
		51308,
		[
			51308
		]
	],
	"./phone-square.svg": [
		24295,
		[
			24295
		]
	],
	"./phone-volume.svg": [
		38944,
		[
			38944
		]
	],
	"./phone-waveform.svg": [
		11655,
		[
			11655
		]
	],
	"./phone-xmark.svg": [
		66441,
		[
			66441
		]
	],
	"./phone.svg": [
		46069,
		[
			46069
		]
	],
	"./photo-film-music.svg": [
		59594,
		[
			59594
		]
	],
	"./photo-film.svg": [
		43532,
		[
			43532
		]
	],
	"./photo-video.svg": [
		31203,
		[
			31203
		]
	],
	"./pi.svg": [
		53942,
		[
			53942
		]
	],
	"./piano-keyboard.svg": [
		90632,
		[
			90632
		]
	],
	"./piano.svg": [
		20690,
		[
			20690
		]
	],
	"./pickaxe.svg": [
		87404,
		[
			87404
		]
	],
	"./pickleball.svg": [
		59746,
		[
			59746
		]
	],
	"./picture-in-picture.svg": [
		91624,
		[
			91624
		]
	],
	"./pie-chart.svg": [
		18072,
		[
			18072
		]
	],
	"./pie.svg": [
		95111,
		[
			95111
		]
	],
	"./pig.svg": [
		68533,
		[
			68533
		]
	],
	"./piggy-bank.svg": [
		13444,
		[
			13444
		]
	],
	"./pills.svg": [
		95449,
		[
			95449
		]
	],
	"./pinata.svg": [
		64075,
		[
			86456
		]
	],
	"./pinball.svg": [
		13883,
		[
			13883
		]
	],
	"./pineapple.svg": [
		9155,
		[
			9155
		]
	],
	"./ping-pong-paddle-ball.svg": [
		97523,
		[
			97523
		]
	],
	"./pipe-circle-check.svg": [
		72923,
		[
			72923
		]
	],
	"./pipe-collar.svg": [
		10551,
		[
			10551
		]
	],
	"./pipe-section.svg": [
		99745,
		[
			99745
		]
	],
	"./pipe-smoking.svg": [
		57810,
		[
			57810
		]
	],
	"./pipe-valve.svg": [
		22514,
		[
			22514
		]
	],
	"./pipe.svg": [
		32315,
		[
			32315
		]
	],
	"./pizza-slice.svg": [
		82414,
		[
			82414
		]
	],
	"./pizza.svg": [
		12247,
		[
			12247
		]
	],
	"./place-of-worship.svg": [
		61271,
		[
			61271
		]
	],
	"./plane-alt.svg": [
		33193,
		[
			33193
		]
	],
	"./plane-arrival.svg": [
		40751,
		[
			40751
		]
	],
	"./plane-circle-check.svg": [
		96743,
		[
			96743
		]
	],
	"./plane-circle-exclamation.svg": [
		99988,
		[
			99988
		]
	],
	"./plane-circle-xmark.svg": [
		46796,
		[
			46796
		]
	],
	"./plane-departure.svg": [
		6428,
		[
			6428
		]
	],
	"./plane-engines.svg": [
		67393,
		[
			67393
		]
	],
	"./plane-flying.svg": [
		96773,
		[
			96773
		]
	],
	"./plane-landing-gear.svg": [
		51271,
		[
			51271
		]
	],
	"./plane-lock.svg": [
		40805,
		[
			40805
		]
	],
	"./plane-prop.svg": [
		59371,
		[
			59371
		]
	],
	"./plane-slash.svg": [
		73059,
		[
			73059
		]
	],
	"./plane-tail.svg": [
		39102,
		[
			39102
		]
	],
	"./plane-up-slash.svg": [
		75491,
		[
			75491
		]
	],
	"./plane-up.svg": [
		56215,
		[
			56215
		]
	],
	"./plane.svg": [
		10007,
		[
			10007
		]
	],
	"./planet-moon.svg": [
		40781,
		[
			40781
		]
	],
	"./planet-ringed.svg": [
		73955,
		[
			73955
		]
	],
	"./plant-wilt.svg": [
		6095,
		[
			6095
		]
	],
	"./plate-utensils.svg": [
		15419,
		[
			15419
		]
	],
	"./plate-wheat.svg": [
		65631,
		[
			65631
		]
	],
	"./play-circle.svg": [
		91446,
		[
			91446
		]
	],
	"./play-flip.svg": [
		89339,
		[
			89339
		]
	],
	"./play-pause.svg": [
		52292,
		[
			52292
		]
	],
	"./play.svg": [
		7545,
		[
			7545
		]
	],
	"./plug-circle-bolt.svg": [
		64520,
		[
			64520
		]
	],
	"./plug-circle-check.svg": [
		98587,
		[
			98587
		]
	],
	"./plug-circle-exclamation.svg": [
		70960,
		[
			70960
		]
	],
	"./plug-circle-minus.svg": [
		73311,
		[
			73311
		]
	],
	"./plug-circle-plus.svg": [
		29361,
		[
			29361
		]
	],
	"./plug-circle-xmark.svg": [
		43408,
		[
			43408
		]
	],
	"./plug.svg": [
		24283,
		[
			24283
		]
	],
	"./plus-circle.svg": [
		65620,
		[
			65620
		]
	],
	"./plus-hexagon.svg": [
		56564,
		[
			56564
		]
	],
	"./plus-large.svg": [
		2509,
		[
			2509
		]
	],
	"./plus-minus.svg": [
		7832,
		[
			7832
		]
	],
	"./plus-octagon.svg": [
		75017,
		[
			75017
		]
	],
	"./plus-square.svg": [
		91082,
		[
			91082
		]
	],
	"./plus.svg": [
		10583,
		[
			10583
		]
	],
	"./podcast.svg": [
		27961,
		[
			27961
		]
	],
	"./podium-star.svg": [
		69148,
		[
			69148
		]
	],
	"./podium.svg": [
		17099,
		[
			17099
		]
	],
	"./police-box.svg": [
		48933,
		[
			48933
		]
	],
	"./polish-zloty-sign.svg": [
		61259,
		[
			61259
		]
	],
	"./poll-h.svg": [
		62855,
		[
			62855
		]
	],
	"./poll-people.svg": [
		10284,
		[
			10284
		]
	],
	"./poll.svg": [
		63872,
		[
			63872
		]
	],
	"./pompebled.svg": [
		3461,
		[
			3461
		]
	],
	"./poo-bolt.svg": [
		5881,
		[
			5881
		]
	],
	"./poo-storm.svg": [
		54763,
		[
			54763
		]
	],
	"./poo.svg": [
		12447,
		[
			12447
		]
	],
	"./pool-8-ball.svg": [
		97832,
		[
			97832
		]
	],
	"./poop.svg": [
		34493,
		[
			34493
		]
	],
	"./popcorn.svg": [
		13502,
		[
			13502
		]
	],
	"./popsicle.svg": [
		43090,
		[
			43090
		]
	],
	"./portal-enter.svg": [
		2108,
		[
			2108
		]
	],
	"./portal-exit.svg": [
		15838,
		[
			15838
		]
	],
	"./portrait.svg": [
		92078,
		[
			92078
		]
	],
	"./postage-stamp.svg": [
		61528,
		[
			61528
		]
	],
	"./pot-food.svg": [
		36430,
		[
			36430
		]
	],
	"./potato.svg": [
		30054,
		[
			30054
		]
	],
	"./pound-sign.svg": [
		69179,
		[
			69179
		]
	],
	"./power-off.svg": [
		33514,
		[
			33514
		]
	],
	"./pray.svg": [
		20019,
		[
			20019
		]
	],
	"./praying-hands.svg": [
		50864,
		[
			50864
		]
	],
	"./prescription-bottle-alt.svg": [
		28094,
		[
			28094
		]
	],
	"./prescription-bottle-medical.svg": [
		49826,
		[
			49826
		]
	],
	"./prescription-bottle-pill.svg": [
		76500,
		[
			76500
		]
	],
	"./prescription-bottle.svg": [
		27304,
		[
			27304
		]
	],
	"./prescription.svg": [
		61471,
		[
			61471
		]
	],
	"./presentation-screen.svg": [
		58176,
		[
			58176
		]
	],
	"./presentation.svg": [
		93323,
		[
			93323
		]
	],
	"./pretzel.svg": [
		20783,
		[
			20783
		]
	],
	"./print-magnifying-glass.svg": [
		29213,
		[
			29213
		]
	],
	"./print-search.svg": [
		54549,
		[
			54549
		]
	],
	"./print-slash.svg": [
		70408,
		[
			70408
		]
	],
	"./print.svg": [
		64240,
		[
			64240
		]
	],
	"./pro.svg": [
		29104,
		[
			29104
		]
	],
	"./procedures.svg": [
		97469,
		[
			97469
		]
	],
	"./project-diagram.svg": [
		65902,
		[
			65902
		]
	],
	"./projector.svg": [
		39673,
		[
			39673
		]
	],
	"./pronoun.svg": [
		51040,
		[
			51040
		]
	],
	"./pump-impeller.svg": [
		3744,
		[
			3744
		]
	],
	"./pump-medical.svg": [
		60579,
		[
			60579
		]
	],
	"./pump-soap.svg": [
		56101,
		[
			56101
		]
	],
	"./pump.svg": [
		48017,
		[
			48017
		]
	],
	"./pumpkin.svg": [
		41173,
		[
			41173
		]
	],
	"./puzzle-piece-alt.svg": [
		28372,
		[
			28372
		]
	],
	"./puzzle-piece-simple.svg": [
		91189,
		[
			91189
		]
	],
	"./puzzle-piece.svg": [
		67646,
		[
			67646
		]
	],
	"./puzzle.svg": [
		38415,
		[
			38415
		]
	],
	"./q.svg": [
		95268,
		[
			95268
		]
	],
	"./qrcode-read.svg": [
		83514,
		[
			83514
		]
	],
	"./qrcode.svg": [
		71645,
		[
			71645
		]
	],
	"./question-circle.svg": [
		68100,
		[
			68100
		]
	],
	"./question-square.svg": [
		90925,
		[
			90925
		]
	],
	"./question.svg": [
		8455,
		[
			8455
		]
	],
	"./quidditch-broom-ball.svg": [
		92390,
		[
			92390
		]
	],
	"./quidditch.svg": [
		31336,
		[
			31336
		]
	],
	"./quote-left-alt.svg": [
		80675,
		[
			80675
		]
	],
	"./quote-left.svg": [
		45313,
		[
			45313
		]
	],
	"./quote-right-alt.svg": [
		84522,
		[
			84522
		]
	],
	"./quote-right.svg": [
		3916,
		[
			3916
		]
	],
	"./quotes.svg": [
		21428,
		[
			21428
		]
	],
	"./quran.svg": [
		87512,
		[
			87512
		]
	],
	"./r.svg": [
		22244,
		[
			99863
		]
	],
	"./rabbit-fast.svg": [
		1578,
		[
			1578
		]
	],
	"./rabbit-running.svg": [
		89549,
		[
			89549
		]
	],
	"./rabbit.svg": [
		52935,
		[
			52935
		]
	],
	"./raccoon.svg": [
		53294,
		[
			53294
		]
	],
	"./racquet.svg": [
		49990,
		[
			49990
		]
	],
	"./radar.svg": [
		24417,
		[
			24417
		]
	],
	"./radiation-alt.svg": [
		71974,
		[
			71974
		]
	],
	"./radiation.svg": [
		34704,
		[
			34704
		]
	],
	"./radio-alt.svg": [
		90618,
		[
			90618
		]
	],
	"./radio-tuner.svg": [
		13751,
		[
			13751
		]
	],
	"./radio.svg": [
		13660,
		[
			13660
		]
	],
	"./rainbow-half.svg": [
		68695,
		[
			68695
		]
	],
	"./rainbow.svg": [
		47259,
		[
			47259
		]
	],
	"./raindrops.svg": [
		18321,
		[
			18321
		]
	],
	"./ram.svg": [
		15961,
		[
			15961
		]
	],
	"./ramp-loading.svg": [
		4208,
		[
			4208
		]
	],
	"./random.svg": [
		53702,
		[
			53702
		]
	],
	"./ranking-star.svg": [
		87204,
		[
			87204
		]
	],
	"./raygun.svg": [
		61857,
		[
			61857
		]
	],
	"./receipt.svg": [
		55161,
		[
			55161
		]
	],
	"./record-vinyl.svg": [
		15747,
		[
			15747
		]
	],
	"./rectangle-4k.svg": [
		60300,
		[
			60300
		]
	],
	"./rectangle-ad.svg": [
		24908,
		[
			24908
		]
	],
	"./rectangle-barcode.svg": [
		63089,
		[
			63089
		]
	],
	"./rectangle-beta.svg": [
		60881,
		[
			60881
		]
	],
	"./rectangle-code.svg": [
		65608,
		[
			65608
		]
	],
	"./rectangle-hd.svg": [
		53303,
		[
			53303
		]
	],
	"./rectangle-hdr.svg": [
		80663,
		[
			80663
		]
	],
	"./rectangle-high-dynamic-range.svg": [
		97511,
		[
			97511
		]
	],
	"./rectangle-history-circle-plus.svg": [
		41335,
		[
			41335
		]
	],
	"./rectangle-history-circle-user.svg": [
		48646,
		[
			48646
		]
	],
	"./rectangle-history.svg": [
		64257,
		[
			64257
		]
	],
	"./rectangle-landscape.svg": [
		69826,
		[
			69826
		]
	],
	"./rectangle-list.svg": [
		59687,
		[
			59687
		]
	],
	"./rectangle-minus.svg": [
		71033,
		[
			71033
		]
	],
	"./rectangle-plus.svg": [
		94027,
		[
			94027
		]
	],
	"./rectangle-portrait.svg": [
		20154,
		[
			20154
		]
	],
	"./rectangle-pro.svg": [
		26532,
		[
			26532
		]
	],
	"./rectangle-sd.svg": [
		54738,
		[
			54738
		]
	],
	"./rectangle-tall.svg": [
		38934,
		[
			38934
		]
	],
	"./rectangle-terminal.svg": [
		93327,
		[
			93327
		]
	],
	"./rectangle-times.svg": [
		69739,
		[
			69739
		]
	],
	"./rectangle-vertical-history.svg": [
		96498,
		[
			96498
		]
	],
	"./rectangle-vertical.svg": [
		4821,
		[
			4821
		]
	],
	"./rectangle-video-on-demand.svg": [
		67618,
		[
			67618
		]
	],
	"./rectangle-wide.svg": [
		21466,
		[
			21466
		]
	],
	"./rectangle-xmark.svg": [
		63658,
		[
			63658
		]
	],
	"./rectangle.svg": [
		1298,
		[
			1298
		]
	],
	"./rectangles-mixed.svg": [
		56091,
		[
			56091
		]
	],
	"./recycle.svg": [
		99570,
		[
			99570
		]
	],
	"./redo-alt.svg": [
		95621,
		[
			18002
		]
	],
	"./redo.svg": [
		81387,
		[
			81387
		]
	],
	"./reel.svg": [
		23643,
		[
			23643
		]
	],
	"./reflect-both.svg": [
		32566,
		[
			10185
		]
	],
	"./reflect-horizontal.svg": [
		32683,
		[
			32683
		]
	],
	"./reflect-vertical.svg": [
		79633,
		[
			79633
		]
	],
	"./refresh.svg": [
		86956,
		[
			86956
		]
	],
	"./refrigerator.svg": [
		92097,
		[
			92097
		]
	],
	"./registered.svg": [
		41155,
		[
			41155
		]
	],
	"./remove-format.svg": [
		75817,
		[
			75817
		]
	],
	"./remove.svg": [
		72399,
		[
			72399
		]
	],
	"./renminbi-sign.svg": [
		11873,
		[
			11873
		]
	],
	"./reorder.svg": [
		27872,
		[
			27872
		]
	],
	"./repeat-1-alt.svg": [
		12962,
		[
			12962
		]
	],
	"./repeat-1.svg": [
		28676,
		[
			28676
		]
	],
	"./repeat-alt.svg": [
		6804,
		[
			6804
		]
	],
	"./repeat.svg": [
		35134,
		[
			35134
		]
	],
	"./reply-all.svg": [
		99295,
		[
			99295
		]
	],
	"./reply-clock.svg": [
		39832,
		[
			39832
		]
	],
	"./reply-time.svg": [
		46029,
		[
			46029
		]
	],
	"./reply.svg": [
		65373,
		[
			65373
		]
	],
	"./republican.svg": [
		86606,
		[
			86606
		]
	],
	"./restroom-simple.svg": [
		67743,
		[
			67743
		]
	],
	"./restroom.svg": [
		70056,
		[
			70056
		]
	],
	"./retweet-alt.svg": [
		62113,
		[
			62113
		]
	],
	"./retweet.svg": [
		77775,
		[
			77775
		]
	],
	"./rhombus.svg": [
		16565,
		[
			16565
		]
	],
	"./ribbon.svg": [
		75947,
		[
			75947
		]
	],
	"./right-from-bracket.svg": [
		35603,
		[
			35603
		]
	],
	"./right-from-dotted-line.svg": [
		89368,
		[
			89368
		]
	],
	"./right-from-line.svg": [
		45935,
		[
			45935
		]
	],
	"./right-left-large.svg": [
		18193,
		[
			18193
		]
	],
	"./right-left.svg": [
		67803,
		[
			67803
		]
	],
	"./right-long-to-line.svg": [
		32167,
		[
			32167
		]
	],
	"./right-long.svg": [
		32378,
		[
			32378
		]
	],
	"./right-to-bracket.svg": [
		44368,
		[
			44368
		]
	],
	"./right-to-dotted-line.svg": [
		85331,
		[
			85331
		]
	],
	"./right-to-line.svg": [
		67914,
		[
			67914
		]
	],
	"./right.svg": [
		43079,
		[
			43079
		]
	],
	"./ring-diamond.svg": [
		55574,
		[
			55574
		]
	],
	"./ring.svg": [
		26529,
		[
			26529
		]
	],
	"./rings-wedding.svg": [
		17027,
		[
			17027
		]
	],
	"./rmb.svg": [
		31826,
		[
			31826
		]
	],
	"./road-barrier.svg": [
		96443,
		[
			96443
		]
	],
	"./road-bridge.svg": [
		41193,
		[
			41193
		]
	],
	"./road-circle-check.svg": [
		8957,
		[
			8957
		]
	],
	"./road-circle-exclamation.svg": [
		6234,
		[
			6234
		]
	],
	"./road-circle-xmark.svg": [
		9510,
		[
			9510
		]
	],
	"./road-lock.svg": [
		28044,
		[
			28044
		]
	],
	"./road-spikes.svg": [
		15103,
		[
			15103
		]
	],
	"./road.svg": [
		38497,
		[
			38497
		]
	],
	"./robot-astromech.svg": [
		41004,
		[
			41004
		]
	],
	"./robot.svg": [
		20981,
		[
			20981
		]
	],
	"./rocket-launch.svg": [
		23857,
		[
			23857
		]
	],
	"./rocket-vertical.svg": [
		72582,
		[
			72582
		]
	],
	"./rocket.svg": [
		47335,
		[
			47335
		]
	],
	"./rod-asclepius.svg": [
		35738,
		[
			35738
		]
	],
	"./rod-snake.svg": [
		56301,
		[
			56301
		]
	],
	"./roller-coaster.svg": [
		49031,
		[
			49031
		]
	],
	"./rotate-back.svg": [
		9142,
		[
			9142
		]
	],
	"./rotate-backward.svg": [
		9180,
		[
			9180
		]
	],
	"./rotate-exclamation.svg": [
		40042,
		[
			40042
		]
	],
	"./rotate-forward.svg": [
		33758,
		[
			33758
		]
	],
	"./rotate-left.svg": [
		1640,
		[
			1640
		]
	],
	"./rotate-reverse.svg": [
		83031,
		[
			83031
		]
	],
	"./rotate-right.svg": [
		48887,
		[
			48887
		]
	],
	"./rotate.svg": [
		99406,
		[
			99406
		]
	],
	"./rouble.svg": [
		14290,
		[
			14290
		]
	],
	"./route-highway.svg": [
		17152,
		[
			17152
		]
	],
	"./route-interstate.svg": [
		53922,
		[
			53922
		]
	],
	"./route.svg": [
		44562,
		[
			44562
		]
	],
	"./router.svg": [
		31788,
		[
			31788
		]
	],
	"./rows.svg": [
		23456,
		[
			23456
		]
	],
	"./rss-square.svg": [
		16107,
		[
			16107
		]
	],
	"./rss.svg": [
		35289,
		[
			35289
		]
	],
	"./rub.svg": [
		43242,
		[
			43242
		]
	],
	"./ruble-sign.svg": [
		25079,
		[
			25079
		]
	],
	"./ruble.svg": [
		50419,
		[
			50419
		]
	],
	"./rug.svg": [
		98919,
		[
			98919
		]
	],
	"./rugby-ball.svg": [
		11826,
		[
			11826
		]
	],
	"./ruler-combined.svg": [
		94195,
		[
			94195
		]
	],
	"./ruler-horizontal.svg": [
		98170,
		[
			98170
		]
	],
	"./ruler-triangle.svg": [
		23734,
		[
			23734
		]
	],
	"./ruler-vertical.svg": [
		27288,
		[
			27288
		]
	],
	"./ruler.svg": [
		61705,
		[
			61705
		]
	],
	"./running.svg": [
		63220,
		[
			63220
		]
	],
	"./rupee-sign.svg": [
		41024,
		[
			41024
		]
	],
	"./rupee.svg": [
		56834,
		[
			56834
		]
	],
	"./rupiah-sign.svg": [
		65636,
		[
			65636
		]
	],
	"./rv.svg": [
		84683,
		[
			84683
		]
	],
	"./s.svg": [
		37062,
		[
			37062
		]
	],
	"./sack-dollar.svg": [
		83724,
		[
			83724
		]
	],
	"./sack-xmark.svg": [
		37833,
		[
			37833
		]
	],
	"./sack.svg": [
		42805,
		[
			42805
		]
	],
	"./sad-cry.svg": [
		69542,
		[
			69542
		]
	],
	"./sad-tear.svg": [
		23002,
		[
			23002
		]
	],
	"./sailboat.svg": [
		26918,
		[
			26918
		]
	],
	"./salad.svg": [
		75518,
		[
			75518
		]
	],
	"./salt-shaker.svg": [
		80768,
		[
			80768
		]
	],
	"./sandwich.svg": [
		2412,
		[
			2412
		]
	],
	"./satellite-dish.svg": [
		13551,
		[
			13551
		]
	],
	"./satellite.svg": [
		9630,
		[
			9630
		]
	],
	"./sausage.svg": [
		47828,
		[
			47828
		]
	],
	"./save-circle-arrow-right.svg": [
		74400,
		[
			74400
		]
	],
	"./save-circle-xmark.svg": [
		20769,
		[
			20769
		]
	],
	"./save-times.svg": [
		32765,
		[
			32765
		]
	],
	"./save.svg": [
		27136,
		[
			27136
		]
	],
	"./sax-hot.svg": [
		49855,
		[
			49855
		]
	],
	"./saxophone-fire.svg": [
		47721,
		[
			47721
		]
	],
	"./saxophone.svg": [
		59976,
		[
			59976
		]
	],
	"./scale-balanced.svg": [
		57436,
		[
			57436
		]
	],
	"./scale-unbalanced-flip.svg": [
		77115,
		[
			77115
		]
	],
	"./scale-unbalanced.svg": [
		70457,
		[
			70457
		]
	],
	"./scalpel-line-dashed.svg": [
		87270,
		[
			87270
		]
	],
	"./scalpel-path.svg": [
		71419,
		[
			71419
		]
	],
	"./scalpel.svg": [
		97081,
		[
			97081
		]
	],
	"./scanner-gun.svg": [
		60054,
		[
			60054
		]
	],
	"./scanner-image.svg": [
		93271,
		[
			93271
		]
	],
	"./scanner-keyboard.svg": [
		92919,
		[
			92919
		]
	],
	"./scanner-touchscreen.svg": [
		73481,
		[
			73481
		]
	],
	"./scanner.svg": [
		31879,
		[
			31879
		]
	],
	"./scarecrow.svg": [
		66068,
		[
			66068
		]
	],
	"./scarf.svg": [
		8002,
		[
			8002
		]
	],
	"./school-circle-check.svg": [
		34939,
		[
			34939
		]
	],
	"./school-circle-exclamation.svg": [
		6448,
		[
			6448
		]
	],
	"./school-circle-xmark.svg": [
		27376,
		[
			27376
		]
	],
	"./school-flag.svg": [
		6938,
		[
			6938
		]
	],
	"./school-lock.svg": [
		91785,
		[
			91785
		]
	],
	"./school-unlock.svg": [
		30464,
		[
			30464
		]
	],
	"./school.svg": [
		34619,
		[
			34619
		]
	],
	"./scissors.svg": [
		80938,
		[
			80938
		]
	],
	"./scooter.svg": [
		34188,
		[
			34188
		]
	],
	"./screen-users.svg": [
		95332,
		[
			72951
		]
	],
	"./screencast.svg": [
		32822,
		[
			32822
		]
	],
	"./screenshot.svg": [
		48723,
		[
			48723
		]
	],
	"./screwdriver-wrench.svg": [
		70320,
		[
			70320
		]
	],
	"./screwdriver.svg": [
		61335,
		[
			61335
		]
	],
	"./scribble.svg": [
		24511,
		[
			24511
		]
	],
	"./scroll-old.svg": [
		26908,
		[
			26908
		]
	],
	"./scroll-ribbon.svg": [
		98273,
		[
			98273
		]
	],
	"./scroll-torah.svg": [
		85223,
		[
			85223
		]
	],
	"./scroll.svg": [
		61876,
		[
			61876
		]
	],
	"./scrubber.svg": [
		18803,
		[
			18803
		]
	],
	"./scythe.svg": [
		85367,
		[
			85367
		]
	],
	"./sd-card.svg": [
		41101,
		[
			41101
		]
	],
	"./sd-cards.svg": [
		90372,
		[
			90372
		]
	],
	"./seal-exclamation.svg": [
		72352,
		[
			72352
		]
	],
	"./seal-question.svg": [
		59673,
		[
			59673
		]
	],
	"./seal.svg": [
		80712,
		[
			80712
		]
	],
	"./search-dollar.svg": [
		74526,
		[
			74526
		]
	],
	"./search-location.svg": [
		84961,
		[
			84961
		]
	],
	"./search-minus.svg": [
		59580,
		[
			59580
		]
	],
	"./search-plus.svg": [
		44532,
		[
			44532
		]
	],
	"./search.svg": [
		9995,
		[
			9995
		]
	],
	"./seat-airline-window.svg": [
		19682,
		[
			19682
		]
	],
	"./seat-airline.svg": [
		79745,
		[
			79745
		]
	],
	"./seat.svg": [
		23040,
		[
			23040
		]
	],
	"./seats.svg": [
		37059,
		[
			37059
		]
	],
	"./section.svg": [
		13060,
		[
			13060
		]
	],
	"./seedling.svg": [
		69936,
		[
			69936
		]
	],
	"./semicolon.svg": [
		72450,
		[
			72450
		]
	],
	"./send-back.svg": [
		77671,
		[
			77671
		]
	],
	"./send-backward.svg": [
		54521,
		[
			54521
		]
	],
	"./send.svg": [
		17637,
		[
			17637
		]
	],
	"./sensor-alert.svg": [
		65256,
		[
			65256
		]
	],
	"./sensor-cloud.svg": [
		13773,
		[
			13773
		]
	],
	"./sensor-fire.svg": [
		80794,
		[
			80794
		]
	],
	"./sensor-on.svg": [
		28305,
		[
			28305
		]
	],
	"./sensor-smoke.svg": [
		32849,
		[
			32849
		]
	],
	"./sensor-triangle-exclamation.svg": [
		46218,
		[
			46218
		]
	],
	"./sensor.svg": [
		27377,
		[
			27377
		]
	],
	"./septagon.svg": [
		52232,
		[
			52232
		]
	],
	"./server.svg": [
		31430,
		[
			31430
		]
	],
	"./shapes.svg": [
		90757,
		[
			90757
		]
	],
	"./share-all.svg": [
		4350,
		[
			4350
		]
	],
	"./share-alt-square.svg": [
		5666,
		[
			5666
		]
	],
	"./share-alt.svg": [
		70054,
		[
			70054
		]
	],
	"./share-from-square.svg": [
		2795,
		[
			2795
		]
	],
	"./share-nodes.svg": [
		39868,
		[
			39868
		]
	],
	"./share-square.svg": [
		25392,
		[
			25392
		]
	],
	"./share.svg": [
		29744,
		[
			29744
		]
	],
	"./sheep.svg": [
		5900,
		[
			5900
		]
	],
	"./sheet-plastic.svg": [
		6627,
		[
			6627
		]
	],
	"./shekel-sign.svg": [
		37761,
		[
			37761
		]
	],
	"./shekel.svg": [
		14541,
		[
			14541
		]
	],
	"./shelves-empty.svg": [
		92997,
		[
			92997
		]
	],
	"./shelves.svg": [
		39593,
		[
			39593
		]
	],
	"./sheqel-sign.svg": [
		91119,
		[
			91119
		]
	],
	"./sheqel.svg": [
		36619,
		[
			36619
		]
	],
	"./shield-alt.svg": [
		72142,
		[
			72142
		]
	],
	"./shield-blank.svg": [
		43313,
		[
			43313
		]
	],
	"./shield-cat.svg": [
		79115,
		[
			79115
		]
	],
	"./shield-check.svg": [
		19707,
		[
			19707
		]
	],
	"./shield-cross.svg": [
		5575,
		[
			5575
		]
	],
	"./shield-dog.svg": [
		24213,
		[
			24213
		]
	],
	"./shield-exclamation.svg": [
		97008,
		[
			97008
		]
	],
	"./shield-halved.svg": [
		33489,
		[
			33489
		]
	],
	"./shield-heart.svg": [
		39423,
		[
			39423
		]
	],
	"./shield-keyhole.svg": [
		10324,
		[
			10324
		]
	],
	"./shield-minus.svg": [
		30623,
		[
			30623
		]
	],
	"./shield-plus.svg": [
		44305,
		[
			44305
		]
	],
	"./shield-quartered.svg": [
		96287,
		[
			96287
		]
	],
	"./shield-slash.svg": [
		82272,
		[
			82272
		]
	],
	"./shield-times.svg": [
		32773,
		[
			32773
		]
	],
	"./shield-user.svg": [
		3100,
		[
			3100
		]
	],
	"./shield-virus.svg": [
		18904,
		[
			18904
		]
	],
	"./shield-xmark.svg": [
		73840,
		[
			73840
		]
	],
	"./shield.svg": [
		1784,
		[
			1784
		]
	],
	"./ship-large.svg": [
		62851,
		[
			62851
		]
	],
	"./ship.svg": [
		92133,
		[
			92133
		]
	],
	"./shipping-fast.svg": [
		34504,
		[
			34504
		]
	],
	"./shipping-timed.svg": [
		70527,
		[
			70527
		]
	],
	"./shirt-jersey.svg": [
		95898,
		[
			95898
		]
	],
	"./shirt-long-sleeve.svg": [
		57289,
		[
			57289
		]
	],
	"./shirt-running.svg": [
		90475,
		[
			90475
		]
	],
	"./shirt-tank-top.svg": [
		3132,
		[
			3132
		]
	],
	"./shirt.svg": [
		80809,
		[
			80809
		]
	],
	"./shish-kebab.svg": [
		22602,
		[
			22602
		]
	],
	"./shoe-prints.svg": [
		94651,
		[
			94651
		]
	],
	"./shoe.svg": [
		76454,
		[
			76454
		]
	],
	"./shop-24.svg": [
		6193,
		[
			28574
		]
	],
	"./shop-lock.svg": [
		53897,
		[
			53897
		]
	],
	"./shop-slash.svg": [
		99255,
		[
			99255
		]
	],
	"./shop.svg": [
		77691,
		[
			77691
		]
	],
	"./shopping-bag.svg": [
		41370,
		[
			41370
		]
	],
	"./shopping-basket-alt.svg": [
		72951,
		[
			95332
		]
	],
	"./shopping-basket.svg": [
		79150,
		[
			79150
		]
	],
	"./shopping-cart.svg": [
		17010,
		[
			17010
		]
	],
	"./shortcake.svg": [
		49691,
		[
			49691
		]
	],
	"./shorts.svg": [
		69561,
		[
			91942
		]
	],
	"./shovel-snow.svg": [
		98394,
		[
			98394
		]
	],
	"./shovel.svg": [
		39482,
		[
			39482
		]
	],
	"./shower-alt.svg": [
		76387,
		[
			76387
		]
	],
	"./shower-down.svg": [
		50174,
		[
			50174
		]
	],
	"./shower.svg": [
		82497,
		[
			82497
		]
	],
	"./shredder.svg": [
		99912,
		[
			99912
		]
	],
	"./shrimp.svg": [
		88318,
		[
			88318
		]
	],
	"./shuffle.svg": [
		1938,
		[
			1938
		]
	],
	"./shutters.svg": [
		87291,
		[
			87291
		]
	],
	"./shuttle-space-vertical.svg": [
		7586,
		[
			7586
		]
	],
	"./shuttle-space.svg": [
		37411,
		[
			37411
		]
	],
	"./shuttle-van.svg": [
		15338,
		[
			15338
		]
	],
	"./shuttlecock.svg": [
		4266,
		[
			4266
		]
	],
	"./sickle.svg": [
		35524,
		[
			35524
		]
	],
	"./sidebar-flip.svg": [
		16239,
		[
			16239
		]
	],
	"./sidebar.svg": [
		81325,
		[
			81325
		]
	],
	"./sigma.svg": [
		3804,
		[
			3804
		]
	],
	"./sign-hanging.svg": [
		52555,
		[
			52555
		]
	],
	"./sign-in-alt.svg": [
		92454,
		[
			92454
		]
	],
	"./sign-in.svg": [
		87440,
		[
			87440
		]
	],
	"./sign-language.svg": [
		9487,
		[
			9487
		]
	],
	"./sign-out-alt.svg": [
		74145,
		[
			74145
		]
	],
	"./sign-out.svg": [
		11119,
		[
			11119
		]
	],
	"./sign-post.svg": [
		58559,
		[
			58559
		]
	],
	"./sign-posts-wrench.svg": [
		64268,
		[
			64268
		]
	],
	"./sign-posts.svg": [
		10526,
		[
			10526
		]
	],
	"./sign.svg": [
		63100,
		[
			63100
		]
	],
	"./signal-1.svg": [
		78413,
		[
			78413
		]
	],
	"./signal-2.svg": [
		30062,
		[
			30062
		]
	],
	"./signal-3.svg": [
		58495,
		[
			58495
		]
	],
	"./signal-4.svg": [
		92608,
		[
			92608
		]
	],
	"./signal-5.svg": [
		28561,
		[
			28561
		]
	],
	"./signal-alt-1.svg": [
		33063,
		[
			33063
		]
	],
	"./signal-alt-2.svg": [
		45204,
		[
			45204
		]
	],
	"./signal-alt-3.svg": [
		6485,
		[
			6485
		]
	],
	"./signal-alt-4.svg": [
		34858,
		[
			34858
		]
	],
	"./signal-alt-slash.svg": [
		97985,
		[
			97985
		]
	],
	"./signal-alt.svg": [
		61637,
		[
			61637
		]
	],
	"./signal-bars-fair.svg": [
		949,
		[
			949
		]
	],
	"./signal-bars-good.svg": [
		69060,
		[
			69060
		]
	],
	"./signal-bars-slash.svg": [
		17522,
		[
			17522
		]
	],
	"./signal-bars-strong.svg": [
		59570,
		[
			59570
		]
	],
	"./signal-bars-weak.svg": [
		82991,
		[
			82991
		]
	],
	"./signal-bars.svg": [
		76738,
		[
			76738
		]
	],
	"./signal-fair.svg": [
		97102,
		[
			97102
		]
	],
	"./signal-good.svg": [
		71091,
		[
			71091
		]
	],
	"./signal-perfect.svg": [
		17771,
		[
			17771
		]
	],
	"./signal-slash.svg": [
		49575,
		[
			49575
		]
	],
	"./signal-stream-slash.svg": [
		73956,
		[
			73956
		]
	],
	"./signal-stream.svg": [
		12236,
		[
			12236
		]
	],
	"./signal-strong.svg": [
		21561,
		[
			21561
		]
	],
	"./signal-weak.svg": [
		16780,
		[
			16780
		]
	],
	"./signal.svg": [
		86155,
		[
			86155
		]
	],
	"./signapore-dollar-sign.svg": [
		80262,
		[
			80262
		]
	],
	"./signature-lock.svg": [
		65197,
		[
			65197
		]
	],
	"./signature-slash.svg": [
		5579,
		[
			5579
		]
	],
	"./signature.svg": [
		39087,
		[
			39087
		]
	],
	"./signing.svg": [
		34620,
		[
			34620
		]
	],
	"./signs-post.svg": [
		98134,
		[
			98134
		]
	],
	"./sim-card.svg": [
		43343,
		[
			43343
		]
	],
	"./sim-cards.svg": [
		81454,
		[
			81454
		]
	],
	"./single-quote-left.svg": [
		33034,
		[
			33034
		]
	],
	"./single-quote-right.svg": [
		69025,
		[
			69025
		]
	],
	"./sink.svg": [
		75350,
		[
			75350
		]
	],
	"./siren-on.svg": [
		64844,
		[
			64844
		]
	],
	"./siren.svg": [
		35186,
		[
			35186
		]
	],
	"./sitemap.svg": [
		8240,
		[
			8240
		]
	],
	"./skating.svg": [
		58470,
		[
			58470
		]
	],
	"./skeleton-ribs.svg": [
		96205,
		[
			96205
		]
	],
	"./skeleton.svg": [
		79426,
		[
			79426
		]
	],
	"./ski-boot-ski.svg": [
		73459,
		[
			73459
		]
	],
	"./ski-boot.svg": [
		92811,
		[
			92811
		]
	],
	"./ski-jump.svg": [
		22187,
		[
			22187
		]
	],
	"./ski-lift.svg": [
		51576,
		[
			51576
		]
	],
	"./skiing-nordic.svg": [
		62484,
		[
			62484
		]
	],
	"./skiing.svg": [
		11038,
		[
			11038
		]
	],
	"./skull-cow.svg": [
		50824,
		[
			50824
		]
	],
	"./skull-crossbones.svg": [
		65234,
		[
			65234
		]
	],
	"./skull.svg": [
		59070,
		[
			59070
		]
	],
	"./slash-back.svg": [
		82774,
		[
			82774
		]
	],
	"./slash-forward.svg": [
		65406,
		[
			65406
		]
	],
	"./slash.svg": [
		71566,
		[
			71566
		]
	],
	"./sledding.svg": [
		70553,
		[
			70553
		]
	],
	"./sleigh.svg": [
		7857,
		[
			7857
		]
	],
	"./slider-circle.svg": [
		91809,
		[
			91809
		]
	],
	"./slider.svg": [
		24372,
		[
			24372
		]
	],
	"./sliders-h-square.svg": [
		3696,
		[
			3696
		]
	],
	"./sliders-h.svg": [
		94640,
		[
			94640
		]
	],
	"./sliders-simple.svg": [
		49870,
		[
			49870
		]
	],
	"./sliders-up.svg": [
		84127,
		[
			84127
		]
	],
	"./sliders-v-square.svg": [
		16674,
		[
			16674
		]
	],
	"./sliders-v.svg": [
		17734,
		[
			17734
		]
	],
	"./sliders.svg": [
		3583,
		[
			3583
		]
	],
	"./slot-machine.svg": [
		58843,
		[
			58843
		]
	],
	"./smile-beam.svg": [
		91819,
		[
			91819
		]
	],
	"./smile-plus.svg": [
		29758,
		[
			29758
		]
	],
	"./smile-wink.svg": [
		98115,
		[
			98115
		]
	],
	"./smile.svg": [
		1205,
		[
			1205
		]
	],
	"./smog.svg": [
		78073,
		[
			78073
		]
	],
	"./smoke.svg": [
		61274,
		[
			61274
		]
	],
	"./smoking-ban.svg": [
		99751,
		[
			99751
		]
	],
	"./smoking.svg": [
		95363,
		[
			95363
		]
	],
	"./sms.svg": [
		62494,
		[
			62494
		]
	],
	"./snake.svg": [
		4353,
		[
			4353
		]
	],
	"./sneaker-running.svg": [
		15334,
		[
			15334
		]
	],
	"./sneaker.svg": [
		59076,
		[
			59076
		]
	],
	"./snooze.svg": [
		18002,
		[
			95621
		]
	],
	"./snow-blowing.svg": [
		23693,
		[
			23693
		]
	],
	"./snowboarding.svg": [
		80818,
		[
			80818
		]
	],
	"./snowflake-droplets.svg": [
		71399,
		[
			71399
		]
	],
	"./snowflake.svg": [
		56874,
		[
			56874
		]
	],
	"./snowflakes.svg": [
		93940,
		[
			93940
		]
	],
	"./snowman-head.svg": [
		96973,
		[
			96973
		]
	],
	"./snowman.svg": [
		70210,
		[
			70210
		]
	],
	"./snowmobile-blank.svg": [
		62717,
		[
			62717
		]
	],
	"./snowmobile.svg": [
		64700,
		[
			64700
		]
	],
	"./snowplow.svg": [
		58004,
		[
			58004
		]
	],
	"./soap.svg": [
		73882,
		[
			73882
		]
	],
	"./soccer-ball.svg": [
		60208,
		[
			60208
		]
	],
	"./socks.svg": [
		33910,
		[
			33910
		]
	],
	"./soft-serve.svg": [
		97833,
		[
			97833
		]
	],
	"./solar-panel.svg": [
		61571,
		[
			61571
		]
	],
	"./solar-system.svg": [
		65768,
		[
			65768
		]
	],
	"./sort-alpha-asc.svg": [
		6432,
		[
			6432
		]
	],
	"./sort-alpha-desc.svg": [
		28350,
		[
			28350
		]
	],
	"./sort-alpha-down-alt.svg": [
		85571,
		[
			85571
		]
	],
	"./sort-alpha-down.svg": [
		34497,
		[
			34497
		]
	],
	"./sort-alpha-up-alt.svg": [
		95572,
		[
			95572
		]
	],
	"./sort-alpha-up.svg": [
		30174,
		[
			30174
		]
	],
	"./sort-alt.svg": [
		12717,
		[
			12717
		]
	],
	"./sort-amount-asc.svg": [
		79184,
		[
			79184
		]
	],
	"./sort-amount-desc.svg": [
		31566,
		[
			31566
		]
	],
	"./sort-amount-down-alt.svg": [
		51283,
		[
			51283
		]
	],
	"./sort-amount-down.svg": [
		93361,
		[
			93361
		]
	],
	"./sort-amount-up-alt.svg": [
		9252,
		[
			9252
		]
	],
	"./sort-amount-up.svg": [
		33550,
		[
			33550
		]
	],
	"./sort-asc.svg": [
		56276,
		[
			56276
		]
	],
	"./sort-circle-down.svg": [
		46897,
		[
			46897
		]
	],
	"./sort-circle-up.svg": [
		22446,
		[
			22446
		]
	],
	"./sort-circle.svg": [
		71216,
		[
			71216
		]
	],
	"./sort-desc.svg": [
		71095,
		[
			71095
		]
	],
	"./sort-down.svg": [
		47688,
		[
			47688
		]
	],
	"./sort-numeric-asc.svg": [
		44385,
		[
			44385
		]
	],
	"./sort-numeric-desc.svg": [
		50533,
		[
			50533
		]
	],
	"./sort-numeric-down-alt.svg": [
		2424,
		[
			2424
		]
	],
	"./sort-numeric-down.svg": [
		63930,
		[
			63930
		]
	],
	"./sort-numeric-up-alt.svg": [
		38251,
		[
			38251
		]
	],
	"./sort-numeric-up.svg": [
		11433,
		[
			11433
		]
	],
	"./sort-shapes-down-alt.svg": [
		16693,
		[
			16693
		]
	],
	"./sort-shapes-down.svg": [
		20955,
		[
			20955
		]
	],
	"./sort-shapes-up-alt.svg": [
		69394,
		[
			69394
		]
	],
	"./sort-shapes-up.svg": [
		98004,
		[
			98004
		]
	],
	"./sort-size-down-alt.svg": [
		73842,
		[
			73842
		]
	],
	"./sort-size-down.svg": [
		59252,
		[
			59252
		]
	],
	"./sort-size-up-alt.svg": [
		33985,
		[
			33985
		]
	],
	"./sort-size-up.svg": [
		21487,
		[
			21487
		]
	],
	"./sort-up-down.svg": [
		71952,
		[
			71952
		]
	],
	"./sort-up.svg": [
		50235,
		[
			50235
		]
	],
	"./sort.svg": [
		70419,
		[
			70419
		]
	],
	"./soup.svg": [
		25862,
		[
			25862
		]
	],
	"./spa.svg": [
		34743,
		[
			34743
		]
	],
	"./space-shuttle.svg": [
		30471,
		[
			30471
		]
	],
	"./space-station-moon-alt.svg": [
		62908,
		[
			62908
		]
	],
	"./space-station-moon-construction.svg": [
		34540,
		[
			34540
		]
	],
	"./space-station-moon.svg": [
		36870,
		[
			36870
		]
	],
	"./spade.svg": [
		79830,
		[
			79830
		]
	],
	"./spaghetti-monster-flying.svg": [
		36127,
		[
			36127
		]
	],
	"./sparkle.svg": [
		92023,
		[
			92023
		]
	],
	"./sparkles.svg": [
		74534,
		[
			74534
		]
	],
	"./speaker.svg": [
		80950,
		[
			80950
		]
	],
	"./speakers.svg": [
		66729,
		[
			66729
		]
	],
	"./spell-check.svg": [
		77532,
		[
			77532
		]
	],
	"./spider-black-widow.svg": [
		10119,
		[
			10119
		]
	],
	"./spider-web.svg": [
		5829,
		[
			5829
		]
	],
	"./spider.svg": [
		99792,
		[
			99792
		]
	],
	"./spine.svg": [
		76444,
		[
			76444
		]
	],
	"./spinner-scale.svg": [
		69943,
		[
			69943
		]
	],
	"./spinner-third.svg": [
		34054,
		[
			34054
		]
	],
	"./spinner.svg": [
		10234,
		[
			10234
		]
	],
	"./spiral.svg": [
		99472,
		[
			99472
		]
	],
	"./split.svg": [
		77014,
		[
			77014
		]
	],
	"./splotch.svg": [
		46978,
		[
			46978
		]
	],
	"./spoon.svg": [
		33994,
		[
			33994
		]
	],
	"./sportsball.svg": [
		8145,
		[
			8145
		]
	],
	"./spray-can-sparkles.svg": [
		10385,
		[
			10385
		]
	],
	"./spray-can.svg": [
		69559,
		[
			69559
		]
	],
	"./sprinkler-ceiling.svg": [
		91571,
		[
			91571
		]
	],
	"./sprinkler.svg": [
		83025,
		[
			83025
		]
	],
	"./sprout.svg": [
		97048,
		[
			97048
		]
	],
	"./square-0.svg": [
		96505,
		[
			96505
		]
	],
	"./square-1.svg": [
		31112,
		[
			31112
		]
	],
	"./square-2.svg": [
		65499,
		[
			65499
		]
	],
	"./square-3.svg": [
		5130,
		[
			5130
		]
	],
	"./square-4.svg": [
		28341,
		[
			28341
		]
	],
	"./square-5.svg": [
		55732,
		[
			55732
		]
	],
	"./square-6.svg": [
		3943,
		[
			3943
		]
	],
	"./square-7.svg": [
		40118,
		[
			40118
		]
	],
	"./square-8.svg": [
		67361,
		[
			67361
		]
	],
	"./square-9.svg": [
		15472,
		[
			15472
		]
	],
	"./square-a-lock.svg": [
		7784,
		[
			7784
		]
	],
	"./square-a.svg": [
		16312,
		[
			16312
		]
	],
	"./square-ampersand.svg": [
		3264,
		[
			3264
		]
	],
	"./square-arrow-down-left.svg": [
		57867,
		[
			57867
		]
	],
	"./square-arrow-down-right.svg": [
		46158,
		[
			46158
		]
	],
	"./square-arrow-down.svg": [
		19767,
		[
			19767
		]
	],
	"./square-arrow-left.svg": [
		49032,
		[
			49032
		]
	],
	"./square-arrow-right.svg": [
		54231,
		[
			54231
		]
	],
	"./square-arrow-up-left.svg": [
		19602,
		[
			19602
		]
	],
	"./square-arrow-up-right.svg": [
		62806,
		[
			62806
		]
	],
	"./square-arrow-up.svg": [
		99496,
		[
			99496
		]
	],
	"./square-austral.svg": [
		14113,
		[
			14113
		]
	],
	"./square-australian-dollar.svg": [
		42102,
		[
			42102
		]
	],
	"./square-b.svg": [
		71499,
		[
			71499
		]
	],
	"./square-baht.svg": [
		32020,
		[
			32020
		]
	],
	"./square-bangladeshi-taka.svg": [
		81679,
		[
			81679
		]
	],
	"./square-binary.svg": [
		53672,
		[
			53672
		]
	],
	"./square-bitcoin.svg": [
		67595,
		[
			67595
		]
	],
	"./square-bolt.svg": [
		13406,
		[
			13406
		]
	],
	"./square-brazilian-real.svg": [
		25560,
		[
			25560
		]
	],
	"./square-c.svg": [
		52442,
		[
			52442
		]
	],
	"./square-caret-down.svg": [
		73813,
		[
			73813
		]
	],
	"./square-caret-left.svg": [
		85038,
		[
			85038
		]
	],
	"./square-caret-right.svg": [
		53773,
		[
			53773
		]
	],
	"./square-caret-up.svg": [
		43674,
		[
			43674
		]
	],
	"./square-cedi.svg": [
		68830,
		[
			68830
		]
	],
	"./square-cent.svg": [
		89065,
		[
			89065
		]
	],
	"./square-check.svg": [
		33753,
		[
			33753
		]
	],
	"./square-chevron-down.svg": [
		25789,
		[
			25789
		]
	],
	"./square-chevron-left.svg": [
		28166,
		[
			28166
		]
	],
	"./square-chevron-right.svg": [
		74085,
		[
			74085
		]
	],
	"./square-chevron-up.svg": [
		43202,
		[
			43202
		]
	],
	"./square-chf.svg": [
		51436,
		[
			51436
		]
	],
	"./square-code.svg": [
		9280,
		[
			9280
		]
	],
	"./square-colon.svg": [
		58504,
		[
			58504
		]
	],
	"./square-cruzeiro.svg": [
		63462,
		[
			63462
		]
	],
	"./square-currency.svg": [
		48894,
		[
			48894
		]
	],
	"./square-d.svg": [
		64069,
		[
			64069
		]
	],
	"./square-danish-krone.svg": [
		66946,
		[
			66946
		]
	],
	"./square-dashed-circle-plus.svg": [
		18974,
		[
			18974
		]
	],
	"./square-dashed.svg": [
		81467,
		[
			81467
		]
	],
	"./square-divide.svg": [
		33892,
		[
			33892
		]
	],
	"./square-dollar.svg": [
		69649,
		[
			69649
		]
	],
	"./square-dong.svg": [
		40989,
		[
			40989
		]
	],
	"./square-down-left.svg": [
		11847,
		[
			11847
		]
	],
	"./square-down-right.svg": [
		86850,
		[
			86850
		]
	],
	"./square-down.svg": [
		50995,
		[
			50995
		]
	],
	"./square-e.svg": [
		9348,
		[
			9348
		]
	],
	"./square-ellipsis-vertical.svg": [
		8781,
		[
			8781
		]
	],
	"./square-ellipsis.svg": [
		12842,
		[
			12842
		]
	],
	"./square-envelope.svg": [
		54696,
		[
			54696
		]
	],
	"./square-equals.svg": [
		62608,
		[
			62608
		]
	],
	"./square-euro.svg": [
		3204,
		[
			3204
		]
	],
	"./square-eurozone.svg": [
		55358,
		[
			55358
		]
	],
	"./square-exclamation.svg": [
		24382,
		[
			24382
		]
	],
	"./square-f.svg": [
		36119,
		[
			36119
		]
	],
	"./square-florin.svg": [
		64711,
		[
			64711
		]
	],
	"./square-fragile.svg": [
		1713,
		[
			1713
		]
	],
	"./square-franc.svg": [
		86149,
		[
			86149
		]
	],
	"./square-full.svg": [
		87152,
		[
			87152
		]
	],
	"./square-g.svg": [
		64934,
		[
			64934
		]
	],
	"./square-guarani.svg": [
		14836,
		[
			14836
		]
	],
	"./square-h.svg": [
		39793,
		[
			39793
		]
	],
	"./square-half-horizontal.svg": [
		39501,
		[
			39501
		]
	],
	"./square-half-stroke-horizontal.svg": [
		55830,
		[
			55830
		]
	],
	"./square-half-stroke.svg": [
		74973,
		[
			74973
		]
	],
	"./square-half.svg": [
		42648,
		[
			42648
		]
	],
	"./square-heart.svg": [
		59629,
		[
			59629
		]
	],
	"./square-hryvnia.svg": [
		68944,
		[
			68944
		]
	],
	"./square-i.svg": [
		76992,
		[
			76992
		]
	],
	"./square-indian-rupee.svg": [
		66674,
		[
			66674
		]
	],
	"./square-info.svg": [
		23851,
		[
			23851
		]
	],
	"./square-j.svg": [
		47891,
		[
			47891
		]
	],
	"./square-k.svg": [
		68898,
		[
			68898
		]
	],
	"./square-kanban.svg": [
		57630,
		[
			57630
		]
	],
	"./square-kip.svg": [
		31333,
		[
			31333
		]
	],
	"./square-l.svg": [
		43565,
		[
			43565
		]
	],
	"./square-lari.svg": [
		42433,
		[
			42433
		]
	],
	"./square-left.svg": [
		55972,
		[
			55972
		]
	],
	"./square-lira.svg": [
		59809,
		[
			59809
		]
	],
	"./square-list.svg": [
		7983,
		[
			7983
		]
	],
	"./square-litecoin.svg": [
		81516,
		[
			81516
		]
	],
	"./square-m.svg": [
		63852,
		[
			63852
		]
	],
	"./square-malaysian-ringgit.svg": [
		23085,
		[
			23085
		]
	],
	"./square-manat.svg": [
		24042,
		[
			24042
		]
	],
	"./square-microphone.svg": [
		59231,
		[
			59231
		]
	],
	"./square-mill.svg": [
		90541,
		[
			90541
		]
	],
	"./square-minus.svg": [
		11073,
		[
			11073
		]
	],
	"./square-n.svg": [
		19199,
		[
			19199
		]
	],
	"./square-naira.svg": [
		81118,
		[
			81118
		]
	],
	"./square-nfi.svg": [
		2224,
		[
			2224
		]
	],
	"./square-norwegian-krone.svg": [
		51887,
		[
			51887
		]
	],
	"./square-o.svg": [
		14446,
		[
			14446
		]
	],
	"./square-p.svg": [
		92729,
		[
			92729
		]
	],
	"./square-parking-slash.svg": [
		81261,
		[
			81261
		]
	],
	"./square-parking.svg": [
		27345,
		[
			27345
		]
	],
	"./square-pen.svg": [
		5532,
		[
			5532
		]
	],
	"./square-person-confined.svg": [
		10149,
		[
			10149
		]
	],
	"./square-peruvian-soles.svg": [
		1330,
		[
			1330
		]
	],
	"./square-peseta.svg": [
		28027,
		[
			28027
		]
	],
	"./square-peso.svg": [
		92332,
		[
			92332
		]
	],
	"./square-phone-flip.svg": [
		26883,
		[
			26883
		]
	],
	"./square-phone-hangup.svg": [
		46637,
		[
			46637
		]
	],
	"./square-phone.svg": [
		95777,
		[
			95777
		]
	],
	"./square-plus.svg": [
		90755,
		[
			90755
		]
	],
	"./square-polish-zloty.svg": [
		63299,
		[
			63299
		]
	],
	"./square-poll-horizontal.svg": [
		77969,
		[
			77969
		]
	],
	"./square-poll-vertical.svg": [
		50775,
		[
			50775
		]
	],
	"./square-q.svg": [
		84808,
		[
			84808
		]
	],
	"./square-quarters.svg": [
		62440,
		[
			62440
		]
	],
	"./square-question.svg": [
		99547,
		[
			99547
		]
	],
	"./square-quote.svg": [
		57713,
		[
			57713
		]
	],
	"./square-r.svg": [
		66171,
		[
			66171
		]
	],
	"./square-renminbi.svg": [
		77625,
		[
			77625
		]
	],
	"./square-right.svg": [
		50219,
		[
			50219
		]
	],
	"./square-ring.svg": [
		85261,
		[
			85261
		]
	],
	"./square-root-alt.svg": [
		9317,
		[
			9317
		]
	],
	"./square-root-variable.svg": [
		41228,
		[
			41228
		]
	],
	"./square-root.svg": [
		73707,
		[
			73707
		]
	],
	"./square-rss.svg": [
		44173,
		[
			44173
		]
	],
	"./square-ruble.svg": [
		57887,
		[
			57887
		]
	],
	"./square-rupee.svg": [
		13278,
		[
			13278
		]
	],
	"./square-rupiah.svg": [
		3546,
		[
			3546
		]
	],
	"./square-s.svg": [
		31978,
		[
			31978
		]
	],
	"./square-share-nodes.svg": [
		86512,
		[
			86512
		]
	],
	"./square-shekel.svg": [
		27153,
		[
			27153
		]
	],
	"./square-sliders-vertical.svg": [
		4938,
		[
			4938
		]
	],
	"./square-sliders.svg": [
		94603,
		[
			94603
		]
	],
	"./square-small.svg": [
		98867,
		[
			76486
		]
	],
	"./square-star.svg": [
		49015,
		[
			49015
		]
	],
	"./square-sterling.svg": [
		68899,
		[
			68899
		]
	],
	"./square-swedish-krona.svg": [
		81976,
		[
			81976
		]
	],
	"./square-t.svg": [
		58741,
		[
			58741
		]
	],
	"./square-tenge.svg": [
		88056,
		[
			88056
		]
	],
	"./square-terminal.svg": [
		1655,
		[
			1655
		]
	],
	"./square-this-way-up.svg": [
		6329,
		[
			6329
		]
	],
	"./square-tugrik.svg": [
		88925,
		[
			88925
		]
	],
	"./square-turkish-lira.svg": [
		43076,
		[
			43076
		]
	],
	"./square-u.svg": [
		16756,
		[
			16756
		]
	],
	"./square-up-left.svg": [
		48518,
		[
			48518
		]
	],
	"./square-up-right.svg": [
		16741,
		[
			16741
		]
	],
	"./square-up.svg": [
		62220,
		[
			62220
		]
	],
	"./square-user.svg": [
		70002,
		[
			70002
		]
	],
	"./square-v.svg": [
		4615,
		[
			4615
		]
	],
	"./square-virus.svg": [
		49574,
		[
			49574
		]
	],
	"./square-w.svg": [
		95113,
		[
			95113
		]
	],
	"./square-wine-glass-crack.svg": [
		31002,
		[
			31002
		]
	],
	"./square-won.svg": [
		4817,
		[
			4817
		]
	],
	"./square-x.svg": [
		23937,
		[
			23937
		]
	],
	"./square-xmark.svg": [
		26450,
		[
			26450
		]
	],
	"./square-y.svg": [
		11696,
		[
			11696
		]
	],
	"./square-yen.svg": [
		28593,
		[
			28593
		]
	],
	"./square-z.svg": [
		73187,
		[
			73187
		]
	],
	"./square.svg": [
		11066,
		[
			11066
		]
	],
	"./squareapore-dollar.svg": [
		2958,
		[
			2958
		]
	],
	"./squid.svg": [
		99755,
		[
			99755
		]
	],
	"./squirrel.svg": [
		55026,
		[
			55026
		]
	],
	"./stadium.svg": [
		46952,
		[
			46952
		]
	],
	"./staff-aesculapius.svg": [
		92901,
		[
			92901
		]
	],
	"./staff-snake.svg": [
		71364,
		[
			71364
		]
	],
	"./staff.svg": [
		56243,
		[
			56243
		]
	],
	"./stair-car.svg": [
		60551,
		[
			60551
		]
	],
	"./stairs.svg": [
		41733,
		[
			41733
		]
	],
	"./stamp.svg": [
		20508,
		[
			20508
		]
	],
	"./standard-definition.svg": [
		70710,
		[
			70710
		]
	],
	"./stapler.svg": [
		73322,
		[
			73322
		]
	],
	"./star-and-crescent.svg": [
		8773,
		[
			8773
		]
	],
	"./star-christmas.svg": [
		51632,
		[
			51632
		]
	],
	"./star-circle.svg": [
		91904,
		[
			91904
		]
	],
	"./star-exclamation.svg": [
		17519,
		[
			17519
		]
	],
	"./star-half-alt.svg": [
		81617,
		[
			81617
		]
	],
	"./star-half-stroke.svg": [
		71284,
		[
			71284
		]
	],
	"./star-half.svg": [
		69599,
		[
			69599
		]
	],
	"./star-of-david.svg": [
		74938,
		[
			74938
		]
	],
	"./star-of-life.svg": [
		81518,
		[
			81518
		]
	],
	"./star-sharp-half-alt.svg": [
		25540,
		[
			25540
		]
	],
	"./star-sharp-half-stroke.svg": [
		61143,
		[
			61143
		]
	],
	"./star-sharp-half.svg": [
		39598,
		[
			39598
		]
	],
	"./star-sharp.svg": [
		92075,
		[
			92075
		]
	],
	"./star-shooting.svg": [
		31575,
		[
			31575
		]
	],
	"./star.svg": [
		53219,
		[
			53219
		]
	],
	"./starfighter-alt-advanced.svg": [
		43947,
		[
			43947
		]
	],
	"./starfighter-alt.svg": [
		69016,
		[
			69016
		]
	],
	"./starfighter-twin-ion-engine-advanced.svg": [
		81162,
		[
			81162
		]
	],
	"./starfighter-twin-ion-engine.svg": [
		57819,
		[
			57819
		]
	],
	"./starfighter.svg": [
		52890,
		[
			52890
		]
	],
	"./stars.svg": [
		71114,
		[
			71114
		]
	],
	"./starship-freighter.svg": [
		57058,
		[
			57058
		]
	],
	"./starship.svg": [
		54977,
		[
			54977
		]
	],
	"./steak.svg": [
		59063,
		[
			59063
		]
	],
	"./steering-wheel.svg": [
		63828,
		[
			63828
		]
	],
	"./step-backward.svg": [
		18313,
		[
			18313
		]
	],
	"./step-forward.svg": [
		34401,
		[
			34401
		]
	],
	"./sterling-sign.svg": [
		50371,
		[
			50371
		]
	],
	"./stethoscope.svg": [
		54018,
		[
			54018
		]
	],
	"./sticky-note.svg": [
		63311,
		[
			63311
		]
	],
	"./stocking.svg": [
		18401,
		[
			18401
		]
	],
	"./stomach.svg": [
		30378,
		[
			30378
		]
	],
	"./stop-circle.svg": [
		36164,
		[
			36164
		]
	],
	"./stop.svg": [
		24935,
		[
			24935
		]
	],
	"./stopwatch-20.svg": [
		49799,
		[
			49799
		]
	],
	"./stopwatch.svg": [
		45104,
		[
			45104
		]
	],
	"./store-24.svg": [
		41253,
		[
			41253
		]
	],
	"./store-alt-slash.svg": [
		64696,
		[
			64696
		]
	],
	"./store-alt.svg": [
		33120,
		[
			33120
		]
	],
	"./store-lock.svg": [
		77274,
		[
			77274
		]
	],
	"./store-slash.svg": [
		4434,
		[
			4434
		]
	],
	"./store.svg": [
		86690,
		[
			86690
		]
	],
	"./strawberry.svg": [
		94500,
		[
			94500
		]
	],
	"./stream.svg": [
		487,
		[
			487
		]
	],
	"./street-view.svg": [
		27356,
		[
			27356
		]
	],
	"./stretcher.svg": [
		12271,
		[
			12271
		]
	],
	"./strikethrough.svg": [
		64828,
		[
			64828
		]
	],
	"./stroopwafel.svg": [
		22239,
		[
			22239
		]
	],
	"./subscript.svg": [
		93134,
		[
			93134
		]
	],
	"./subtitles-slash.svg": [
		89010,
		[
			89010
		]
	],
	"./subtitles.svg": [
		44962,
		[
			44962
		]
	],
	"./subtract.svg": [
		45011,
		[
			45011
		]
	],
	"./subway-tunnel.svg": [
		39935,
		[
			39935
		]
	],
	"./subway.svg": [
		99836,
		[
			99836
		]
	],
	"./suitcase-medical.svg": [
		96198,
		[
			96198
		]
	],
	"./suitcase-rolling.svg": [
		53780,
		[
			53780
		]
	],
	"./suitcase.svg": [
		21396,
		[
			21396
		]
	],
	"./sun-alt.svg": [
		79885,
		[
			79885
		]
	],
	"./sun-bright.svg": [
		50856,
		[
			50856
		]
	],
	"./sun-cloud.svg": [
		66383,
		[
			66383
		]
	],
	"./sun-dust.svg": [
		20664,
		[
			20664
		]
	],
	"./sun-haze.svg": [
		55970,
		[
			55970
		]
	],
	"./sun-plant-wilt.svg": [
		54480,
		[
			54480
		]
	],
	"./sun.svg": [
		43763,
		[
			43763
		]
	],
	"./sunglasses.svg": [
		45434,
		[
			45434
		]
	],
	"./sunrise.svg": [
		28524,
		[
			28524
		]
	],
	"./sunset.svg": [
		25373,
		[
			25373
		]
	],
	"./superscript.svg": [
		61461,
		[
			61461
		]
	],
	"./surprise.svg": [
		80414,
		[
			80414
		]
	],
	"./sushi-roll.svg": [
		16825,
		[
			16825
		]
	],
	"./sushi.svg": [
		61735,
		[
			61735
		]
	],
	"./swap-arrows.svg": [
		95401,
		[
			95401
		]
	],
	"./swap.svg": [
		87330,
		[
			87330
		]
	],
	"./swatchbook.svg": [
		49156,
		[
			49156
		]
	],
	"./swedish-krona-sign.svg": [
		25858,
		[
			25858
		]
	],
	"./swimmer.svg": [
		77629,
		[
			77629
		]
	],
	"./swimming-pool.svg": [
		69575,
		[
			69575
		]
	],
	"./sword-laser-alt.svg": [
		68046,
		[
			68046
		]
	],
	"./sword-laser.svg": [
		31256,
		[
			31256
		]
	],
	"./sword.svg": [
		74346,
		[
			74346
		]
	],
	"./swords-laser.svg": [
		46815,
		[
			46815
		]
	],
	"./swords.svg": [
		94773,
		[
			94773
		]
	],
	"./symbols.svg": [
		3402,
		[
			3402
		]
	],
	"./synagogue.svg": [
		25059,
		[
			25059
		]
	],
	"./sync-alt.svg": [
		30628,
		[
			30628
		]
	],
	"./sync.svg": [
		6382,
		[
			6382
		]
	],
	"./syringe.svg": [
		12714,
		[
			12714
		]
	],
	"./t-rex.svg": [
		21983,
		[
			21983
		]
	],
	"./t-shirt.svg": [
		84026,
		[
			84026
		]
	],
	"./t.svg": [
		80297,
		[
			80297
		]
	],
	"./table-cells-column-lock.svg": [
		57484,
		[
			57484
		]
	],
	"./table-cells-column-unlock.svg": [
		40201,
		[
			40201
		]
	],
	"./table-cells-columns.svg": [
		33431,
		[
			33431
		]
	],
	"./table-cells-header-lock.svg": [
		80947,
		[
			80947
		]
	],
	"./table-cells-header-unlock.svg": [
		51734,
		[
			51734
		]
	],
	"./table-cells-header.svg": [
		9749,
		[
			9749
		]
	],
	"./table-cells-large.svg": [
		51387,
		[
			51387
		]
	],
	"./table-cells-lock.svg": [
		95947,
		[
			95947
		]
	],
	"./table-cells-row-lock.svg": [
		16334,
		[
			16334
		]
	],
	"./table-cells-row-unlock.svg": [
		34047,
		[
			34047
		]
	],
	"./table-cells-rows.svg": [
		62825,
		[
			62825
		]
	],
	"./table-cells-unlock.svg": [
		56702,
		[
			56702
		]
	],
	"./table-cells.svg": [
		14173,
		[
			14173
		]
	],
	"./table-columns.svg": [
		71279,
		[
			71279
		]
	],
	"./table-layout.svg": [
		60856,
		[
			60856
		]
	],
	"./table-list.svg": [
		13622,
		[
			13622
		]
	],
	"./table-picnic.svg": [
		8776,
		[
			8776
		]
	],
	"./table-pivot.svg": [
		67442,
		[
			67442
		]
	],
	"./table-rows.svg": [
		1857,
		[
			1857
		]
	],
	"./table-tennis-paddle-ball.svg": [
		33130,
		[
			33130
		]
	],
	"./table-tennis.svg": [
		37139,
		[
			37139
		]
	],
	"./table-tree.svg": [
		87598,
		[
			87598
		]
	],
	"./table.svg": [
		7333,
		[
			7333
		]
	],
	"./tablet-alt.svg": [
		80205,
		[
			80205
		]
	],
	"./tablet-android-alt.svg": [
		94571,
		[
			94571
		]
	],
	"./tablet-android.svg": [
		11465,
		[
			11465
		]
	],
	"./tablet-button.svg": [
		37784,
		[
			37784
		]
	],
	"./tablet-rugged.svg": [
		21238,
		[
			21238
		]
	],
	"./tablet-screen-button.svg": [
		58701,
		[
			58701
		]
	],
	"./tablet-screen.svg": [
		42168,
		[
			42168
		]
	],
	"./tablet.svg": [
		94963,
		[
			94963
		]
	],
	"./tablets.svg": [
		27418,
		[
			27418
		]
	],
	"./tachograph-digital.svg": [
		62117,
		[
			62117
		]
	],
	"./tachometer-alt-average.svg": [
		68229,
		[
			68229
		]
	],
	"./tachometer-alt-fast.svg": [
		49786,
		[
			27405
		]
	],
	"./tachometer-alt-fastest.svg": [
		8386,
		[
			8386
		]
	],
	"./tachometer-alt-slow.svg": [
		29103,
		[
			29103
		]
	],
	"./tachometer-alt-slowest.svg": [
		98693,
		[
			98693
		]
	],
	"./tachometer-alt.svg": [
		44759,
		[
			44759
		]
	],
	"./tachometer-average.svg": [
		88759,
		[
			88759
		]
	],
	"./tachometer-fast.svg": [
		91340,
		[
			91340
		]
	],
	"./tachometer-fastest.svg": [
		74964,
		[
			74964
		]
	],
	"./tachometer-slow.svg": [
		94573,
		[
			94573
		]
	],
	"./tachometer-slowest.svg": [
		240,
		[
			77859
		]
	],
	"./tachometer.svg": [
		36845,
		[
			36845
		]
	],
	"./taco.svg": [
		9304,
		[
			9304
		]
	],
	"./tag.svg": [
		93977,
		[
			93977
		]
	],
	"./tags.svg": [
		15992,
		[
			15992
		]
	],
	"./tally-1.svg": [
		95833,
		[
			95833
		]
	],
	"./tally-2.svg": [
		69834,
		[
			69834
		]
	],
	"./tally-3.svg": [
		11803,
		[
			11803
		]
	],
	"./tally-4.svg": [
		80180,
		[
			80180
		]
	],
	"./tally-5.svg": [
		25109,
		[
			25109
		]
	],
	"./tally.svg": [
		14575,
		[
			14575
		]
	],
	"./tamale.svg": [
		40473,
		[
			40473
		]
	],
	"./tanakh.svg": [
		41232,
		[
			41232
		]
	],
	"./tank-recovery.svg": [
		71673,
		[
			71673
		]
	],
	"./tank-water.svg": [
		8593,
		[
			8593
		]
	],
	"./tape.svg": [
		51351,
		[
			51351
		]
	],
	"./tarp-droplet.svg": [
		68129,
		[
			68129
		]
	],
	"./tarp.svg": [
		37052,
		[
			37052
		]
	],
	"./tasks-alt.svg": [
		44497,
		[
			44497
		]
	],
	"./tasks.svg": [
		46047,
		[
			46047
		]
	],
	"./taxi-bus.svg": [
		46846,
		[
			46846
		]
	],
	"./taxi.svg": [
		96539,
		[
			96539
		]
	],
	"./teddy-bear.svg": [
		88590,
		[
			88590
		]
	],
	"./teeth-open.svg": [
		21020,
		[
			21020
		]
	],
	"./teeth.svg": [
		3507,
		[
			3507
		]
	],
	"./telescope.svg": [
		34457,
		[
			34457
		]
	],
	"./teletype-answer.svg": [
		73622,
		[
			73622
		]
	],
	"./teletype.svg": [
		43863,
		[
			43863
		]
	],
	"./television.svg": [
		7283,
		[
			7283
		]
	],
	"./temperature-0.svg": [
		71376,
		[
			71376
		]
	],
	"./temperature-1.svg": [
		62497,
		[
			62497
		]
	],
	"./temperature-2.svg": [
		73810,
		[
			73810
		]
	],
	"./temperature-3.svg": [
		60771,
		[
			60771
		]
	],
	"./temperature-4.svg": [
		79196,
		[
			79196
		]
	],
	"./temperature-arrow-down.svg": [
		72840,
		[
			72840
		]
	],
	"./temperature-arrow-up.svg": [
		88859,
		[
			88859
		]
	],
	"./temperature-down.svg": [
		46412,
		[
			46412
		]
	],
	"./temperature-empty.svg": [
		45291,
		[
			45291
		]
	],
	"./temperature-frigid.svg": [
		17187,
		[
			17187
		]
	],
	"./temperature-full.svg": [
		67359,
		[
			67359
		]
	],
	"./temperature-half.svg": [
		47747,
		[
			47747
		]
	],
	"./temperature-high.svg": [
		40364,
		[
			40364
		]
	],
	"./temperature-hot.svg": [
		32145,
		[
			32145
		]
	],
	"./temperature-list.svg": [
		12328,
		[
			12328
		]
	],
	"./temperature-low.svg": [
		98190,
		[
			98190
		]
	],
	"./temperature-quarter.svg": [
		87668,
		[
			87668
		]
	],
	"./temperature-slash.svg": [
		42163,
		[
			42163
		]
	],
	"./temperature-snow.svg": [
		73590,
		[
			73590
		]
	],
	"./temperature-sun.svg": [
		54410,
		[
			54410
		]
	],
	"./temperature-three-quarters.svg": [
		5134,
		[
			5134
		]
	],
	"./temperature-up.svg": [
		94951,
		[
			94951
		]
	],
	"./tenge-sign.svg": [
		62346,
		[
			62346
		]
	],
	"./tenge.svg": [
		37820,
		[
			37820
		]
	],
	"./tennis-ball.svg": [
		7812,
		[
			7812
		]
	],
	"./tent-arrow-down-to-line.svg": [
		88192,
		[
			88192
		]
	],
	"./tent-arrow-left-right.svg": [
		68399,
		[
			68399
		]
	],
	"./tent-arrow-turn-left.svg": [
		28658,
		[
			28658
		]
	],
	"./tent-arrows-down.svg": [
		45500,
		[
			45500
		]
	],
	"./tent-circus.svg": [
		53264,
		[
			53264
		]
	],
	"./tent-double-peak.svg": [
		13222,
		[
			13222
		]
	],
	"./tent.svg": [
		62152,
		[
			62152
		]
	],
	"./tents.svg": [
		38523,
		[
			38523
		]
	],
	"./terminal.svg": [
		69539,
		[
			69539
		]
	],
	"./text-height.svg": [
		9170,
		[
			9170
		]
	],
	"./text-size.svg": [
		63264,
		[
			63264
		]
	],
	"./text-slash.svg": [
		23602,
		[
			23602
		]
	],
	"./text-width.svg": [
		92793,
		[
			92793
		]
	],
	"./text.svg": [
		14530,
		[
			14530
		]
	],
	"./th-large.svg": [
		98025,
		[
			98025
		]
	],
	"./th-list.svg": [
		56484,
		[
			56484
		]
	],
	"./th.svg": [
		90003,
		[
			90003
		]
	],
	"./theater-masks.svg": [
		66490,
		[
			66490
		]
	],
	"./thermometer-0.svg": [
		7486,
		[
			7486
		]
	],
	"./thermometer-1.svg": [
		51215,
		[
			51215
		]
	],
	"./thermometer-2.svg": [
		72188,
		[
			72188
		]
	],
	"./thermometer-3.svg": [
		61661,
		[
			61661
		]
	],
	"./thermometer-4.svg": [
		27730,
		[
			27730
		]
	],
	"./thermometer-empty.svg": [
		22697,
		[
			22697
		]
	],
	"./thermometer-full.svg": [
		60221,
		[
			60221
		]
	],
	"./thermometer-half.svg": [
		27985,
		[
			27985
		]
	],
	"./thermometer-quarter.svg": [
		52050,
		[
			52050
		]
	],
	"./thermometer-three-quarters.svg": [
		37936,
		[
			37936
		]
	],
	"./thermometer.svg": [
		92509,
		[
			92509
		]
	],
	"./theta.svg": [
		3473,
		[
			3473
		]
	],
	"./thought-bubble.svg": [
		1693,
		[
			1693
		]
	],
	"./thumb-tack-slash.svg": [
		45417,
		[
			45417
		]
	],
	"./thumb-tack.svg": [
		90365,
		[
			90365
		]
	],
	"./thumbs-down.svg": [
		58185,
		[
			58185
		]
	],
	"./thumbs-up.svg": [
		53529,
		[
			75910
		]
	],
	"./thumbtack-angle-slash.svg": [
		45504,
		[
			45504
		]
	],
	"./thumbtack-angle.svg": [
		38552,
		[
			38552
		]
	],
	"./thumbtack-slash.svg": [
		60806,
		[
			60806
		]
	],
	"./thumbtack.svg": [
		62406,
		[
			62406
		]
	],
	"./thunderstorm-moon.svg": [
		78848,
		[
			78848
		]
	],
	"./thunderstorm-sun.svg": [
		90075,
		[
			90075
		]
	],
	"./thunderstorm.svg": [
		60678,
		[
			60678
		]
	],
	"./tick.svg": [
		71036,
		[
			71036
		]
	],
	"./ticket-airline.svg": [
		7794,
		[
			7794
		]
	],
	"./ticket-alt.svg": [
		35625,
		[
			35625
		]
	],
	"./ticket-perforated-plane.svg": [
		50539,
		[
			50539
		]
	],
	"./ticket-perforated.svg": [
		78546,
		[
			78546
		]
	],
	"./ticket-plane.svg": [
		14670,
		[
			14670
		]
	],
	"./ticket-simple.svg": [
		47094,
		[
			47094
		]
	],
	"./ticket.svg": [
		76855,
		[
			76855
		]
	],
	"./tickets-airline.svg": [
		77119,
		[
			77119
		]
	],
	"./tickets-perforated-plane.svg": [
		94712,
		[
			94712
		]
	],
	"./tickets-perforated.svg": [
		84285,
		[
			84285
		]
	],
	"./tickets-plane.svg": [
		62863,
		[
			62863
		]
	],
	"./tickets-simple.svg": [
		6221,
		[
			6221
		]
	],
	"./tickets.svg": [
		97670,
		[
			97670
		]
	],
	"./tilde.svg": [
		99384,
		[
			99384
		]
	],
	"./timeline-arrow.svg": [
		79502,
		[
			79502
		]
	],
	"./timeline.svg": [
		25754,
		[
			25754
		]
	],
	"./timer.svg": [
		61990,
		[
			61990
		]
	],
	"./times-circle.svg": [
		84052,
		[
			84052
		]
	],
	"./times-hexagon.svg": [
		35828,
		[
			35828
		]
	],
	"./times-octagon.svg": [
		12553,
		[
			12553
		]
	],
	"./times-rectangle.svg": [
		93807,
		[
			93807
		]
	],
	"./times-square.svg": [
		14365,
		[
			14365
		]
	],
	"./times-to-slot.svg": [
		4432,
		[
			4432
		]
	],
	"./times.svg": [
		76375,
		[
			76375
		]
	],
	"./tint-slash.svg": [
		10060,
		[
			10060
		]
	],
	"./tint.svg": [
		78052,
		[
			78052
		]
	],
	"./tire-flat.svg": [
		48799,
		[
			48799
		]
	],
	"./tire-pressure-warning.svg": [
		49404,
		[
			49404
		]
	],
	"./tire-rugged.svg": [
		39428,
		[
			39428
		]
	],
	"./tire.svg": [
		57465,
		[
			57465
		]
	],
	"./tired.svg": [
		83655,
		[
			83655
		]
	],
	"./toggle-large-off.svg": [
		86641,
		[
			86641
		]
	],
	"./toggle-large-on.svg": [
		9725,
		[
			9725
		]
	],
	"./toggle-off.svg": [
		32399,
		[
			32399
		]
	],
	"./toggle-on.svg": [
		18771,
		[
			18771
		]
	],
	"./toilet-paper-alt.svg": [
		69331,
		[
			69331
		]
	],
	"./toilet-paper-blank-under.svg": [
		34513,
		[
			34513
		]
	],
	"./toilet-paper-blank.svg": [
		60720,
		[
			60720
		]
	],
	"./toilet-paper-check.svg": [
		67878,
		[
			67878
		]
	],
	"./toilet-paper-reverse-alt.svg": [
		82114,
		[
			82114
		]
	],
	"./toilet-paper-reverse-slash.svg": [
		79244,
		[
			79244
		]
	],
	"./toilet-paper-reverse.svg": [
		40676,
		[
			40676
		]
	],
	"./toilet-paper-slash.svg": [
		75021,
		[
			75021
		]
	],
	"./toilet-paper-under-slash.svg": [
		80356,
		[
			80356
		]
	],
	"./toilet-paper-under.svg": [
		16972,
		[
			16972
		]
	],
	"./toilet-paper-xmark.svg": [
		86693,
		[
			86693
		]
	],
	"./toilet-paper.svg": [
		65009,
		[
			65009
		]
	],
	"./toilet-portable.svg": [
		59656,
		[
			59656
		]
	],
	"./toilet.svg": [
		560,
		[
			560
		]
	],
	"./toilets-portable.svg": [
		89259,
		[
			89259
		]
	],
	"./tomato.svg": [
		45577,
		[
			45577
		]
	],
	"./tombstone-alt.svg": [
		27302,
		[
			27302
		]
	],
	"./tombstone-blank.svg": [
		26025,
		[
			26025
		]
	],
	"./tombstone.svg": [
		29904,
		[
			29904
		]
	],
	"./toolbox.svg": [
		13424,
		[
			13424
		]
	],
	"./tools.svg": [
		64116,
		[
			64116
		]
	],
	"./tooth.svg": [
		85287,
		[
			85287
		]
	],
	"./toothbrush.svg": [
		65881,
		[
			65881
		]
	],
	"./torah.svg": [
		50921,
		[
			50921
		]
	],
	"./torii-gate.svg": [
		4368,
		[
			4368
		]
	],
	"./tornado.svg": [
		70622,
		[
			70622
		]
	],
	"./tower-broadcast.svg": [
		96100,
		[
			96100
		]
	],
	"./tower-cell.svg": [
		27583,
		[
			27583
		]
	],
	"./tower-control.svg": [
		44586,
		[
			44586
		]
	],
	"./tower-observation.svg": [
		90103,
		[
			90103
		]
	],
	"./tractor.svg": [
		22800,
		[
			22800
		]
	],
	"./trademark.svg": [
		88340,
		[
			88340
		]
	],
	"./traffic-cone.svg": [
		73682,
		[
			73682
		]
	],
	"./traffic-light-go.svg": [
		31736,
		[
			31736
		]
	],
	"./traffic-light-slow.svg": [
		53033,
		[
			53033
		]
	],
	"./traffic-light-stop.svg": [
		93054,
		[
			93054
		]
	],
	"./traffic-light.svg": [
		73886,
		[
			73886
		]
	],
	"./trailer.svg": [
		17896,
		[
			17896
		]
	],
	"./train-stop.svg": [
		92956,
		[
			92956
		]
	],
	"./train-subway-tunnel.svg": [
		41414,
		[
			41414
		]
	],
	"./train-subway.svg": [
		56567,
		[
			56567
		]
	],
	"./train-track.svg": [
		85737,
		[
			85737
		]
	],
	"./train-tram.svg": [
		14856,
		[
			14856
		]
	],
	"./train-tunnel.svg": [
		56077,
		[
			78458
		]
	],
	"./train.svg": [
		24619,
		[
			24619
		]
	],
	"./tram.svg": [
		81587,
		[
			81587
		]
	],
	"./transducer.svg": [
		15572,
		[
			15572
		]
	],
	"./transformer-bolt.svg": [
		88832,
		[
			88832
		]
	],
	"./transgender-alt.svg": [
		40093,
		[
			62474
		]
	],
	"./transgender.svg": [
		26604,
		[
			26604
		]
	],
	"./transmission.svg": [
		34231,
		[
			34231
		]
	],
	"./transporter-1.svg": [
		90081,
		[
			90081
		]
	],
	"./transporter-2.svg": [
		96946,
		[
			96946
		]
	],
	"./transporter-3.svg": [
		11587,
		[
			11587
		]
	],
	"./transporter-4.svg": [
		41404,
		[
			41404
		]
	],
	"./transporter-5.svg": [
		30877,
		[
			30877
		]
	],
	"./transporter-6.svg": [
		76702,
		[
			76702
		]
	],
	"./transporter-7.svg": [
		20431,
		[
			20431
		]
	],
	"./transporter-empty.svg": [
		56459,
		[
			56459
		]
	],
	"./transporter.svg": [
		73767,
		[
			73767
		]
	],
	"./trash-alt-slash.svg": [
		44053,
		[
			44053
		]
	],
	"./trash-alt.svg": [
		51721,
		[
			51721
		]
	],
	"./trash-arrow-turn-left.svg": [
		73829,
		[
			73829
		]
	],
	"./trash-arrow-up.svg": [
		39211,
		[
			39211
		]
	],
	"./trash-can-arrow-turn-left.svg": [
		2204,
		[
			2204
		]
	],
	"./trash-can-arrow-up.svg": [
		9740,
		[
			9740
		]
	],
	"./trash-can-check.svg": [
		33245,
		[
			33245
		]
	],
	"./trash-can-clock.svg": [
		68367,
		[
			68367
		]
	],
	"./trash-can-list.svg": [
		34003,
		[
			34003
		]
	],
	"./trash-can-plus.svg": [
		65175,
		[
			65175
		]
	],
	"./trash-can-slash.svg": [
		64174,
		[
			64174
		]
	],
	"./trash-can-undo.svg": [
		86306,
		[
			86306
		]
	],
	"./trash-can-xmark.svg": [
		2918,
		[
			2918
		]
	],
	"./trash-can.svg": [
		10846,
		[
			10846
		]
	],
	"./trash-check.svg": [
		74344,
		[
			74344
		]
	],
	"./trash-circle.svg": [
		58964,
		[
			58964
		]
	],
	"./trash-clock.svg": [
		49666,
		[
			49666
		]
	],
	"./trash-list.svg": [
		90168,
		[
			90168
		]
	],
	"./trash-plus.svg": [
		62416,
		[
			62416
		]
	],
	"./trash-restore-alt.svg": [
		85348,
		[
			85348
		]
	],
	"./trash-restore.svg": [
		52814,
		[
			52814
		]
	],
	"./trash-slash.svg": [
		54659,
		[
			54659
		]
	],
	"./trash-undo-alt.svg": [
		32536,
		[
			32536
		]
	],
	"./trash-undo.svg": [
		81626,
		[
			81626
		]
	],
	"./trash-xmark.svg": [
		3891,
		[
			3891
		]
	],
	"./trash.svg": [
		28599,
		[
			28599
		]
	],
	"./treasure-chest.svg": [
		29656,
		[
			29656
		]
	],
	"./tree-alt.svg": [
		37734,
		[
			37734
		]
	],
	"./tree-christmas.svg": [
		22012,
		[
			22012
		]
	],
	"./tree-city.svg": [
		35613,
		[
			35613
		]
	],
	"./tree-deciduous.svg": [
		97499,
		[
			97499
		]
	],
	"./tree-decorated.svg": [
		38307,
		[
			38307
		]
	],
	"./tree-large.svg": [
		67965,
		[
			67965
		]
	],
	"./tree-palm.svg": [
		94224,
		[
			94224
		]
	],
	"./tree.svg": [
		27975,
		[
			27975
		]
	],
	"./trees.svg": [
		10185,
		[
			32566
		]
	],
	"./trian-balbot.svg": [
		3300,
		[
			3300
		]
	],
	"./triangle-circle-square.svg": [
		62740,
		[
			62740
		]
	],
	"./triangle-exclamation.svg": [
		19531,
		[
			19531
		]
	],
	"./triangle-instrument.svg": [
		18859,
		[
			18859
		]
	],
	"./triangle-music.svg": [
		31182,
		[
			31182
		]
	],
	"./triangle-person-digging.svg": [
		40057,
		[
			40057
		]
	],
	"./triangle.svg": [
		56615,
		[
			56615
		]
	],
	"./tricycle-adult.svg": [
		17855,
		[
			17855
		]
	],
	"./tricycle.svg": [
		25272,
		[
			25272
		]
	],
	"./trillium.svg": [
		7677,
		[
			7677
		]
	],
	"./triple-chevrons-down.svg": [
		61505,
		[
			61505
		]
	],
	"./triple-chevrons-left.svg": [
		20346,
		[
			20346
		]
	],
	"./triple-chevrons-right.svg": [
		16273,
		[
			16273
		]
	],
	"./triple-chevrons-up.svg": [
		71390,
		[
			71390
		]
	],
	"./trombone.svg": [
		89163,
		[
			89163
		]
	],
	"./trophy-alt.svg": [
		11903,
		[
			11903
		]
	],
	"./trophy-star.svg": [
		19946,
		[
			19946
		]
	],
	"./trophy.svg": [
		29173,
		[
			29173
		]
	],
	"./trowel-bricks.svg": [
		16531,
		[
			16531
		]
	],
	"./trowel.svg": [
		30160,
		[
			30160
		]
	],
	"./truck-arrow-right.svg": [
		54877,
		[
			54877
		]
	],
	"./truck-bolt.svg": [
		23427,
		[
			45808
		]
	],
	"./truck-clock.svg": [
		76721,
		[
			76721
		]
	],
	"./truck-container-empty.svg": [
		82994,
		[
			82994
		]
	],
	"./truck-container.svg": [
		72766,
		[
			72766
		]
	],
	"./truck-couch.svg": [
		93845,
		[
			93845
		]
	],
	"./truck-droplet.svg": [
		61221,
		[
			61221
		]
	],
	"./truck-fast.svg": [
		52315,
		[
			52315
		]
	],
	"./truck-field-un.svg": [
		51709,
		[
			51709
		]
	],
	"./truck-field.svg": [
		33571,
		[
			33571
		]
	],
	"./truck-fire.svg": [
		4209,
		[
			4209
		]
	],
	"./truck-flatbed.svg": [
		61397,
		[
			61397
		]
	],
	"./truck-front.svg": [
		49082,
		[
			49082
		]
	],
	"./truck-ladder.svg": [
		38109,
		[
			38109
		]
	],
	"./truck-loading.svg": [
		66384,
		[
			66384
		]
	],
	"./truck-medical.svg": [
		63642,
		[
			63642
		]
	],
	"./truck-monster.svg": [
		25821,
		[
			25821
		]
	],
	"./truck-moving.svg": [
		24755,
		[
			24755
		]
	],
	"./truck-pickup.svg": [
		53717,
		[
			53717
		]
	],
	"./truck-plane.svg": [
		33021,
		[
			33021
		]
	],
	"./truck-plow.svg": [
		70651,
		[
			70651
		]
	],
	"./truck-ramp-box.svg": [
		23681,
		[
			23681
		]
	],
	"./truck-ramp-couch.svg": [
		98116,
		[
			98116
		]
	],
	"./truck-ramp.svg": [
		60525,
		[
			60525
		]
	],
	"./truck-suv.svg": [
		56453,
		[
			56453
		]
	],
	"./truck-tow.svg": [
		43805,
		[
			43805
		]
	],
	"./truck-utensils.svg": [
		35356,
		[
			35356
		]
	],
	"./truck.svg": [
		58560,
		[
			58560
		]
	],
	"./trumpet.svg": [
		39802,
		[
			39802
		]
	],
	"./try.svg": [
		4226,
		[
			4226
		]
	],
	"./tshirt.svg": [
		51511,
		[
			51511
		]
	],
	"./tty-answer.svg": [
		80479,
		[
			80479
		]
	],
	"./tty.svg": [
		76636,
		[
			76636
		]
	],
	"./tugrik-sign.svg": [
		68413,
		[
			68413
		]
	],
	"./turkey.svg": [
		53877,
		[
			53877
		]
	],
	"./turkish-lira-sign.svg": [
		38966,
		[
			38966
		]
	],
	"./turkish-lira.svg": [
		33704,
		[
			33704
		]
	],
	"./turn-down-left.svg": [
		91003,
		[
			91003
		]
	],
	"./turn-down-right.svg": [
		7102,
		[
			7102
		]
	],
	"./turn-down.svg": [
		37095,
		[
			37095
		]
	],
	"./turn-left-down.svg": [
		32729,
		[
			32729
		]
	],
	"./turn-left-up.svg": [
		13398,
		[
			13398
		]
	],
	"./turn-left.svg": [
		34680,
		[
			34680
		]
	],
	"./turn-right.svg": [
		68519,
		[
			68519
		]
	],
	"./turn-up.svg": [
		73112,
		[
			73112
		]
	],
	"./turntable.svg": [
		73362,
		[
			73362
		]
	],
	"./turtle.svg": [
		45749,
		[
			45749
		]
	],
	"./tv-alt.svg": [
		98847,
		[
			98847
		]
	],
	"./tv-music.svg": [
		93439,
		[
			93439
		]
	],
	"./tv-retro.svg": [
		38954,
		[
			38954
		]
	],
	"./tv.svg": [
		23093,
		[
			23093
		]
	],
	"./typewriter.svg": [
		58070,
		[
			58070
		]
	],
	"./u-turn-down-left.svg": [
		22094,
		[
			99713
		]
	],
	"./u-turn-down-right.svg": [
		10156,
		[
			10156
		]
	],
	"./u-turn-left-down.svg": [
		79983,
		[
			79983
		]
	],
	"./u-turn-left-up.svg": [
		11520,
		[
			11520
		]
	],
	"./u-turn-right-down.svg": [
		30610,
		[
			30610
		]
	],
	"./u-turn-right-up.svg": [
		81934,
		[
			81934
		]
	],
	"./u-turn-up-left.svg": [
		43964,
		[
			43964
		]
	],
	"./u-turn-up-right.svg": [
		57571,
		[
			57571
		]
	],
	"./u-turn.svg": [
		42124,
		[
			42124
		]
	],
	"./u.svg": [
		4792,
		[
			4792
		]
	],
	"./ufo-beam.svg": [
		9763,
		[
			9763
		]
	],
	"./ufo.svg": [
		8317,
		[
			8317
		]
	],
	"./umbrella-alt.svg": [
		11097,
		[
			11097
		]
	],
	"./umbrella-beach.svg": [
		11609,
		[
			11609
		]
	],
	"./umbrella-simple.svg": [
		72006,
		[
			72006
		]
	],
	"./umbrella.svg": [
		37351,
		[
			37351
		]
	],
	"./underline.svg": [
		31893,
		[
			31893
		]
	],
	"./undo-alt.svg": [
		10719,
		[
			10719
		]
	],
	"./undo.svg": [
		21557,
		[
			21557
		]
	],
	"./unicorn.svg": [
		64749,
		[
			64749
		]
	],
	"./unicycle.svg": [
		20383,
		[
			20383
		]
	],
	"./uniform-martial-arts.svg": [
		18675,
		[
			18675
		]
	],
	"./union.svg": [
		56348,
		[
			56348
		]
	],
	"./universal-access.svg": [
		30145,
		[
			30145
		]
	],
	"./university.svg": [
		54011,
		[
			54011
		]
	],
	"./unlink.svg": [
		2934,
		[
			2934
		]
	],
	"./unlock-alt.svg": [
		20473,
		[
			20473
		]
	],
	"./unlock-keyhole.svg": [
		8627,
		[
			8627
		]
	],
	"./unlock.svg": [
		60039,
		[
			60039
		]
	],
	"./unsorted.svg": [
		7249,
		[
			7249
		]
	],
	"./up-down-left-right.svg": [
		51980,
		[
			51980
		]
	],
	"./up-down.svg": [
		65913,
		[
			65913
		]
	],
	"./up-from-bracket.svg": [
		18878,
		[
			18878
		]
	],
	"./up-from-dotted-line.svg": [
		43505,
		[
			43505
		]
	],
	"./up-from-line.svg": [
		9192,
		[
			9192
		]
	],
	"./up-left.svg": [
		90530,
		[
			90530
		]
	],
	"./up-long-to-line.svg": [
		24750,
		[
			24750
		]
	],
	"./up-long.svg": [
		54105,
		[
			98867
		]
	],
	"./up-right-and-down-left-from-center.svg": [
		16429,
		[
			16429
		]
	],
	"./up-right-from-square.svg": [
		87486,
		[
			87486
		]
	],
	"./up-right.svg": [
		89913,
		[
			89913
		]
	],
	"./up-to-bracket.svg": [
		42609,
		[
			42609
		]
	],
	"./up-to-dotted-line.svg": [
		92694,
		[
			92694
		]
	],
	"./up-to-line.svg": [
		5461,
		[
			5461
		]
	],
	"./up.svg": [
		55512,
		[
			55512
		]
	],
	"./upload.svg": [
		82036,
		[
			82036
		]
	],
	"./usb-drive.svg": [
		80724,
		[
			80724
		]
	],
	"./usd-circle.svg": [
		34666,
		[
			34666
		]
	],
	"./usd-square.svg": [
		16303,
		[
			16303
		]
	],
	"./usd.svg": [
		27101,
		[
			27101
		]
	],
	"./user-alien.svg": [
		84812,
		[
			84812
		]
	],
	"./user-alt-slash.svg": [
		34900,
		[
			34900
		]
	],
	"./user-alt.svg": [
		82172,
		[
			82172
		]
	],
	"./user-astronaut.svg": [
		16140,
		[
			16140
		]
	],
	"./user-beard-bolt.svg": [
		34921,
		[
			34921
		]
	],
	"./user-beard.svg": [
		34575,
		[
			34575
		]
	],
	"./user-bounty-hunter.svg": [
		92877,
		[
			92877
		]
	],
	"./user-chart.svg": [
		37801,
		[
			37801
		]
	],
	"./user-check.svg": [
		23957,
		[
			23957
		]
	],
	"./user-chef-hair-long.svg": [
		81951,
		[
			81951
		]
	],
	"./user-chef.svg": [
		30479,
		[
			30479
		]
	],
	"./user-circle-minus.svg": [
		87028,
		[
			87028
		]
	],
	"./user-circle-plus.svg": [
		88284,
		[
			88284
		]
	],
	"./user-circle.svg": [
		95107,
		[
			95107
		]
	],
	"./user-clock.svg": [
		791,
		[
			791
		]
	],
	"./user-cog.svg": [
		28352,
		[
			28352
		]
	],
	"./user-construction.svg": [
		30956,
		[
			30956
		]
	],
	"./user-cowboy.svg": [
		26338,
		[
			26338
		]
	],
	"./user-crown.svg": [
		98576,
		[
			98576
		]
	],
	"./user-dashed.svg": [
		86524,
		[
			86524
		]
	],
	"./user-doctor-hair-long.svg": [
		90446,
		[
			90446
		]
	],
	"./user-doctor-hair-mullet.svg": [
		6281,
		[
			6281
		]
	],
	"./user-doctor-hair.svg": [
		65979,
		[
			65979
		]
	],
	"./user-doctor-message.svg": [
		65004,
		[
			65004
		]
	],
	"./user-doctor.svg": [
		74318,
		[
			74318
		]
	],
	"./user-edit.svg": [
		36651,
		[
			36651
		]
	],
	"./user-friends.svg": [
		71222,
		[
			71222
		]
	],
	"./user-gear.svg": [
		89482,
		[
			89482
		]
	],
	"./user-graduate.svg": [
		59868,
		[
			59868
		]
	],
	"./user-group-crown.svg": [
		37642,
		[
			37642
		]
	],
	"./user-group-simple.svg": [
		78939,
		[
			78939
		]
	],
	"./user-group.svg": [
		63948,
		[
			63948
		]
	],
	"./user-hair-buns.svg": [
		34218,
		[
			34218
		]
	],
	"./user-hair-long.svg": [
		54518,
		[
			54518
		]
	],
	"./user-hair-mullet.svg": [
		86065,
		[
			86065
		]
	],
	"./user-hair.svg": [
		46867,
		[
			46867
		]
	],
	"./user-hard-hat.svg": [
		95020,
		[
			95020
		]
	],
	"./user-hat-tie-magnifying-glass.svg": [
		95144,
		[
			95144
		]
	],
	"./user-hat-tie.svg": [
		86195,
		[
			86195
		]
	],
	"./user-headset.svg": [
		78811,
		[
			78811
		]
	],
	"./user-helmet-safety.svg": [
		15883,
		[
			15883
		]
	],
	"./user-hoodie.svg": [
		50091,
		[
			50091
		]
	],
	"./user-injured.svg": [
		52086,
		[
			52086
		]
	],
	"./user-key.svg": [
		80972,
		[
			80972
		]
	],
	"./user-large-slash.svg": [
		61148,
		[
			61148
		]
	],
	"./user-large.svg": [
		18644,
		[
			18644
		]
	],
	"./user-lock.svg": [
		79582,
		[
			79582
		]
	],
	"./user-magnifying-glass.svg": [
		87271,
		[
			87271
		]
	],
	"./user-md-chat.svg": [
		85631,
		[
			85631
		]
	],
	"./user-md.svg": [
		59380,
		[
			59380
		]
	],
	"./user-message.svg": [
		59172,
		[
			59172
		]
	],
	"./user-microphone.svg": [
		58691,
		[
			58691
		]
	],
	"./user-minus.svg": [
		9565,
		[
			9565
		]
	],
	"./user-music.svg": [
		77652,
		[
			77652
		]
	],
	"./user-ninja.svg": [
		44137,
		[
			44137
		]
	],
	"./user-nurse-hair-long.svg": [
		24278,
		[
			24278
		]
	],
	"./user-nurse-hair.svg": [
		82131,
		[
			82131
		]
	],
	"./user-nurse.svg": [
		17670,
		[
			17670
		]
	],
	"./user-pen.svg": [
		42384,
		[
			42384
		]
	],
	"./user-pilot-hair-long.svg": [
		68603,
		[
			68603
		]
	],
	"./user-pilot-tie-hair-long.svg": [
		15878,
		[
			15878
		]
	],
	"./user-pilot-tie.svg": [
		44598,
		[
			44598
		]
	],
	"./user-pilot.svg": [
		89211,
		[
			89211
		]
	],
	"./user-plus.svg": [
		27663,
		[
			27663
		]
	],
	"./user-police-hair-long.svg": [
		35521,
		[
			35521
		]
	],
	"./user-police-tie-hair-long.svg": [
		97788,
		[
			97788
		]
	],
	"./user-police-tie.svg": [
		13340,
		[
			13340
		]
	],
	"./user-police.svg": [
		8633,
		[
			8633
		]
	],
	"./user-question.svg": [
		79071,
		[
			79071
		]
	],
	"./user-robot-xmarks.svg": [
		26288,
		[
			26288
		]
	],
	"./user-robot.svg": [
		4845,
		[
			4845
		]
	],
	"./user-secret.svg": [
		53739,
		[
			53739
		]
	],
	"./user-shakespeare.svg": [
		18379,
		[
			18379
		]
	],
	"./user-shield.svg": [
		45648,
		[
			45648
		]
	],
	"./user-sith.svg": [
		59471,
		[
			59471
		]
	],
	"./user-slash.svg": [
		81030,
		[
			81030
		]
	],
	"./user-tag.svg": [
		10705,
		[
			10705
		]
	],
	"./user-tie-hair-long.svg": [
		99656,
		[
			99656
		]
	],
	"./user-tie-hair-mullet.svg": [
		78040,
		[
			78040
		]
	],
	"./user-tie-hair.svg": [
		12112,
		[
			12112
		]
	],
	"./user-tie.svg": [
		75003,
		[
			75003
		]
	],
	"./user-times.svg": [
		49167,
		[
			49167
		]
	],
	"./user-unlock.svg": [
		39439,
		[
			39439
		]
	],
	"./user-viewfinder.svg": [
		24112,
		[
			24112
		]
	],
	"./user-visor.svg": [
		25632,
		[
			25632
		]
	],
	"./user-vneck-hair-long.svg": [
		48802,
		[
			48802
		]
	],
	"./user-vneck-hair-mullet.svg": [
		13629,
		[
			13629
		]
	],
	"./user-vneck-hair.svg": [
		79551,
		[
			79551
		]
	],
	"./user-vneck.svg": [
		93490,
		[
			93490
		]
	],
	"./user-xmark.svg": [
		94350,
		[
			94350
		]
	],
	"./user.svg": [
		34246,
		[
			34246
		]
	],
	"./users-between-lines.svg": [
		6284,
		[
			6284
		]
	],
	"./users-class.svg": [
		56750,
		[
			56750
		]
	],
	"./users-cog.svg": [
		99491,
		[
			99491
		]
	],
	"./users-crown.svg": [
		65519,
		[
			65519
		]
	],
	"./users-gear.svg": [
		61015,
		[
			61015
		]
	],
	"./users-line.svg": [
		23920,
		[
			23920
		]
	],
	"./users-medical.svg": [
		44408,
		[
			44408
		]
	],
	"./users-rays.svg": [
		94613,
		[
			94613
		]
	],
	"./users-rectangle.svg": [
		58657,
		[
			58657
		]
	],
	"./users-slash.svg": [
		96037,
		[
			96037
		]
	],
	"./users-viewfinder.svg": [
		9549,
		[
			9549
		]
	],
	"./users.svg": [
		95225,
		[
			95225
		]
	],
	"./utensil-fork.svg": [
		27816,
		[
			27816
		]
	],
	"./utensil-knife.svg": [
		30023,
		[
			30023
		]
	],
	"./utensil-spoon.svg": [
		12683,
		[
			12683
		]
	],
	"./utensils-alt.svg": [
		53112,
		[
			53112
		]
	],
	"./utensils-slash.svg": [
		1754,
		[
			1754
		]
	],
	"./utensils.svg": [
		4890,
		[
			4890
		]
	],
	"./utility-pole-double.svg": [
		24914,
		[
			24914
		]
	],
	"./utility-pole.svg": [
		11620,
		[
			11620
		]
	],
	"./v.svg": [
		43627,
		[
			43627
		]
	],
	"./vacuum-robot.svg": [
		77885,
		[
			77885
		]
	],
	"./vacuum.svg": [
		57622,
		[
			57622
		]
	],
	"./value-absolute.svg": [
		34343,
		[
			56724
		]
	],
	"./van-shuttle.svg": [
		65138,
		[
			65138
		]
	],
	"./van.svg": [
		73366,
		[
			73366
		]
	],
	"./vault.svg": [
		29461,
		[
			29461
		]
	],
	"./vcard.svg": [
		76913,
		[
			76913
		]
	],
	"./vector-circle.svg": [
		50659,
		[
			50659
		]
	],
	"./vector-polygon.svg": [
		98595,
		[
			98595
		]
	],
	"./vector-square.svg": [
		11234,
		[
			11234
		]
	],
	"./vent-damper.svg": [
		30532,
		[
			30532
		]
	],
	"./venus-double.svg": [
		27684,
		[
			27684
		]
	],
	"./venus-mars.svg": [
		16452,
		[
			16452
		]
	],
	"./venus.svg": [
		27405,
		[
			49786
		]
	],
	"./vest-patches.svg": [
		86044,
		[
			86044
		]
	],
	"./vest.svg": [
		81609,
		[
			81609
		]
	],
	"./vhs.svg": [
		7192,
		[
			7192
		]
	],
	"./vial-circle-check.svg": [
		91647,
		[
			91647
		]
	],
	"./vial-vertical.svg": [
		92830,
		[
			92830
		]
	],
	"./vial-virus.svg": [
		21063,
		[
			21063
		]
	],
	"./vial.svg": [
		16287,
		[
			16287
		]
	],
	"./vials.svg": [
		42878,
		[
			42878
		]
	],
	"./video-arrow-down-left.svg": [
		5509,
		[
			5509
		]
	],
	"./video-arrow-up-right.svg": [
		3895,
		[
			3895
		]
	],
	"./video-camera.svg": [
		36748,
		[
			36748
		]
	],
	"./video-circle.svg": [
		74465,
		[
			74465
		]
	],
	"./video-down-to-line.svg": [
		1720,
		[
			1720
		]
	],
	"./video-handheld.svg": [
		99859,
		[
			99859
		]
	],
	"./video-plus.svg": [
		11885,
		[
			11885
		]
	],
	"./video-question.svg": [
		84909,
		[
			84909
		]
	],
	"./video-slash.svg": [
		74780,
		[
			74780
		]
	],
	"./video.svg": [
		19988,
		[
			19988
		]
	],
	"./vihara.svg": [
		62514,
		[
			62514
		]
	],
	"./violin.svg": [
		74072,
		[
			74072
		]
	],
	"./virus-covid-slash.svg": [
		1081,
		[
			23462
		]
	],
	"./virus-covid.svg": [
		21286,
		[
			21286
		]
	],
	"./virus-slash.svg": [
		33378,
		[
			33378
		]
	],
	"./virus.svg": [
		64530,
		[
			64530
		]
	],
	"./viruses.svg": [
		1930,
		[
			1930
		]
	],
	"./voicemail.svg": [
		52902,
		[
			52902
		]
	],
	"./volcano.svg": [
		94527,
		[
			94527
		]
	],
	"./volleyball-ball.svg": [
		307,
		[
			307
		]
	],
	"./volleyball.svg": [
		65099,
		[
			65099
		]
	],
	"./volume-control-phone.svg": [
		75526,
		[
			75526
		]
	],
	"./volume-down.svg": [
		2322,
		[
			2322
		]
	],
	"./volume-high.svg": [
		30282,
		[
			30282
		]
	],
	"./volume-low.svg": [
		12148,
		[
			12148
		]
	],
	"./volume-medium.svg": [
		52799,
		[
			52799
		]
	],
	"./volume-mute.svg": [
		29725,
		[
			29725
		]
	],
	"./volume-off.svg": [
		14185,
		[
			14185
		]
	],
	"./volume-slash.svg": [
		21345,
		[
			21345
		]
	],
	"./volume-times.svg": [
		77020,
		[
			77020
		]
	],
	"./volume-up.svg": [
		44225,
		[
			44225
		]
	],
	"./volume-xmark.svg": [
		30041,
		[
			30041
		]
	],
	"./volume.svg": [
		20837,
		[
			20837
		]
	],
	"./vote-nay.svg": [
		74952,
		[
			74952
		]
	],
	"./vote-yea.svg": [
		90923,
		[
			90923
		]
	],
	"./vr-cardboard.svg": [
		63726,
		[
			63726
		]
	],
	"./w.svg": [
		38362,
		[
			38362
		]
	],
	"./waffle.svg": [
		51414,
		[
			51414
		]
	],
	"./wagon-covered.svg": [
		70804,
		[
			70804
		]
	],
	"./walker.svg": [
		42221,
		[
			42221
		]
	],
	"./walkie-talkie.svg": [
		34391,
		[
			34391
		]
	],
	"./walking.svg": [
		67744,
		[
			67744
		]
	],
	"./wall-brick.svg": [
		3351,
		[
			3351
		]
	],
	"./wallet.svg": [
		97892,
		[
			97892
		]
	],
	"./wand-magic-sparkles.svg": [
		32657,
		[
			32657
		]
	],
	"./wand-magic.svg": [
		66391,
		[
			66391
		]
	],
	"./wand-sparkles.svg": [
		21531,
		[
			21531
		]
	],
	"./wand.svg": [
		12021,
		[
			12021
		]
	],
	"./warehouse-alt.svg": [
		31242,
		[
			31242
		]
	],
	"./warehouse-full.svg": [
		8890,
		[
			8890
		]
	],
	"./warehouse.svg": [
		88748,
		[
			88748
		]
	],
	"./warning.svg": [
		4853,
		[
			4853
		]
	],
	"./washer.svg": [
		31547,
		[
			31547
		]
	],
	"./washing-machine.svg": [
		99994,
		[
			99994
		]
	],
	"./watch-apple.svg": [
		41927,
		[
			41927
		]
	],
	"./watch-calculator.svg": [
		11957,
		[
			11957
		]
	],
	"./watch-fitness.svg": [
		52223,
		[
			52223
		]
	],
	"./watch-smart.svg": [
		79880,
		[
			79880
		]
	],
	"./watch.svg": [
		11040,
		[
			11040
		]
	],
	"./water-arrow-down.svg": [
		31933,
		[
			31933
		]
	],
	"./water-arrow-up.svg": [
		81794,
		[
			81794
		]
	],
	"./water-ladder.svg": [
		36261,
		[
			36261
		]
	],
	"./water-lower.svg": [
		73444,
		[
			73444
		]
	],
	"./water-rise.svg": [
		94166,
		[
			94166
		]
	],
	"./water-temp.svg": [
		9907,
		[
			9907
		]
	],
	"./water-temperature.svg": [
		77545,
		[
			77545
		]
	],
	"./water.svg": [
		62520,
		[
			62520
		]
	],
	"./watermelon-slice.svg": [
		75652,
		[
			75652
		]
	],
	"./wave-pulse.svg": [
		4284,
		[
			4284
		]
	],
	"./wave-sine.svg": [
		88362,
		[
			88362
		]
	],
	"./wave-square.svg": [
		75868,
		[
			75868
		]
	],
	"./wave-triangle.svg": [
		67069,
		[
			67069
		]
	],
	"./wave.svg": [
		68044,
		[
			68044
		]
	],
	"./waveform-circle.svg": [
		9987,
		[
			9987
		]
	],
	"./waveform-lines.svg": [
		30460,
		[
			30460
		]
	],
	"./waveform-path.svg": [
		37298,
		[
			37298
		]
	],
	"./waveform.svg": [
		16678,
		[
			16678
		]
	],
	"./waves-sine.svg": [
		89111,
		[
			89111
		]
	],
	"./web-awesome.svg": [
		2865,
		[
			2865
		]
	],
	"./webcam-slash.svg": [
		93736,
		[
			93736
		]
	],
	"./webcam.svg": [
		10032,
		[
			10032
		]
	],
	"./webhook.svg": [
		84426,
		[
			84426
		]
	],
	"./weight-hanging.svg": [
		51164,
		[
			51164
		]
	],
	"./weight-scale.svg": [
		6058,
		[
			6058
		]
	],
	"./weight.svg": [
		88555,
		[
			88555
		]
	],
	"./whale.svg": [
		98458,
		[
			98458
		]
	],
	"./wheat-alt.svg": [
		51358,
		[
			51358
		]
	],
	"./wheat-awn-circle-exclamation.svg": [
		60290,
		[
			60290
		]
	],
	"./wheat-awn-slash.svg": [
		80613,
		[
			80613
		]
	],
	"./wheat-awn.svg": [
		48025,
		[
			48025
		]
	],
	"./wheat-slash.svg": [
		38864,
		[
			38864
		]
	],
	"./wheat.svg": [
		90376,
		[
			90376
		]
	],
	"./wheelchair-alt.svg": [
		48461,
		[
			48461
		]
	],
	"./wheelchair-move.svg": [
		46915,
		[
			46915
		]
	],
	"./wheelchair.svg": [
		48147,
		[
			48147
		]
	],
	"./whiskey-glass-ice.svg": [
		32706,
		[
			32706
		]
	],
	"./whiskey-glass.svg": [
		23932,
		[
			23932
		]
	],
	"./whistle.svg": [
		77931,
		[
			77931
		]
	],
	"./wifi-1.svg": [
		87918,
		[
			87918
		]
	],
	"./wifi-2.svg": [
		17037,
		[
			17037
		]
	],
	"./wifi-3.svg": [
		37324,
		[
			37324
		]
	],
	"./wifi-exclamation.svg": [
		2600,
		[
			2600
		]
	],
	"./wifi-fair.svg": [
		26615,
		[
			26615
		]
	],
	"./wifi-slash.svg": [
		96696,
		[
			96696
		]
	],
	"./wifi-strong.svg": [
		33888,
		[
			33888
		]
	],
	"./wifi-weak.svg": [
		23713,
		[
			23713
		]
	],
	"./wifi.svg": [
		97504,
		[
			97504
		]
	],
	"./wind-circle-exclamation.svg": [
		21118,
		[
			21118
		]
	],
	"./wind-turbine.svg": [
		50151,
		[
			50151
		]
	],
	"./wind-warning.svg": [
		71942,
		[
			71942
		]
	],
	"./wind.svg": [
		3405,
		[
			3405
		]
	],
	"./window-alt.svg": [
		95537,
		[
			95537
		]
	],
	"./window-close.svg": [
		12063,
		[
			34444
		]
	],
	"./window-flip.svg": [
		54865,
		[
			54865
		]
	],
	"./window-frame-open.svg": [
		24608,
		[
			24608
		]
	],
	"./window-frame.svg": [
		47391,
		[
			47391
		]
	],
	"./window-maximize.svg": [
		51022,
		[
			51022
		]
	],
	"./window-minimize.svg": [
		74888,
		[
			74888
		]
	],
	"./window-restore.svg": [
		46390,
		[
			46390
		]
	],
	"./window.svg": [
		17503,
		[
			17503
		]
	],
	"./windsock.svg": [
		72981,
		[
			72981
		]
	],
	"./wine-bottle.svg": [
		67149,
		[
			67149
		]
	],
	"./wine-glass-alt.svg": [
		92429,
		[
			92429
		]
	],
	"./wine-glass-crack.svg": [
		42598,
		[
			42598
		]
	],
	"./wine-glass-empty.svg": [
		54727,
		[
			54727
		]
	],
	"./wine-glass.svg": [
		26963,
		[
			26963
		]
	],
	"./wireless.svg": [
		94403,
		[
			94403
		]
	],
	"./won-sign.svg": [
		41113,
		[
			41113
		]
	],
	"./won.svg": [
		10789,
		[
			10789
		]
	],
	"./worm.svg": [
		63366,
		[
			63366
		]
	],
	"./wreath-laurel.svg": [
		21608,
		[
			21608
		]
	],
	"./wreath.svg": [
		11142,
		[
			11142
		]
	],
	"./wrench-simple.svg": [
		38491,
		[
			38491
		]
	],
	"./wrench.svg": [
		86060,
		[
			86060
		]
	],
	"./x-ray.svg": [
		60294,
		[
			60294
		]
	],
	"./x.svg": [
		64109,
		[
			64109
		]
	],
	"./xmark-circle.svg": [
		93763,
		[
			93763
		]
	],
	"./xmark-hexagon.svg": [
		82009,
		[
			82009
		]
	],
	"./xmark-large.svg": [
		95988,
		[
			95988
		]
	],
	"./xmark-octagon.svg": [
		98040,
		[
			98040
		]
	],
	"./xmark-square.svg": [
		54338,
		[
			54338
		]
	],
	"./xmark-to-slot.svg": [
		17554,
		[
			95173
		]
	],
	"./xmark.svg": [
		15110,
		[
			15110
		]
	],
	"./xmarks-lines.svg": [
		62515,
		[
			62515
		]
	],
	"./y.svg": [
		28652,
		[
			28652
		]
	],
	"./yen-sign.svg": [
		90433,
		[
			90433
		]
	],
	"./yen.svg": [
		70989,
		[
			70989
		]
	],
	"./yin-yang.svg": [
		90669,
		[
			90669
		]
	],
	"./z.svg": [
		7679,
		[
			7679
		]
	],
	"./zap.svg": [
		13172,
		[
			13172
		]
	],
	"./zzz.svg": [
		35343,
		[
			35343
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38192;
module.exports = webpackAsyncContext;